/**
 * select2 4.0.13 + Safari 한글 조합(IME) 버그 패치
 *
 * 증상: ajax select2에서 한글로 검색한 뒤 결과 item을 클릭하면 "한 칸 위의 item"이 선택된다.
 *       Safari(한글 IME 조합 중)에서만 재현.
 *
 * 근본 원인 (Safari 실측 로그로 확인):
 *   조합 중인 한글이 남은 상태에서 결과 item을 클릭하면 Safari가 그 클릭을 IME commit 에 써버린다.
 *   실제 이벤트 순서 (Safari 18 / macOS, "원예" 조합 중 2번째 항목 클릭):
 *      COMPOSITIONUPDATE "원예" → INPUT "원예" → INPUT "원" → INPUT "원예" → COMPOSITIONEND "원예"
 *      → MOUSEUP (행#1)         ※ MOUSEDOWN 은 DOM 으로 아예 오지 않는다
 *   여기서 세 가지가 겹친다.
 *   1) commit 과정에서 값이 "원예" → "원" → "원예" 로 되돌아가며 input 이 연속 발생한다.
 *      값이 실제로 바뀌므로 '같은 검색어 무시' 만으로는 못 막고, select2가 query 를 2번 더 던진다.
 *   2) query 가 시작되면 select2는 결과 목록 '맨 위'에 "검색중..." li 를 prepend 한다
 *      (results.js showLoading). 기존 목록을 지우지 않으므로 목록 전체가 정확히 한 행 아래로 밀린다.
 *   3) select2의 '선택'은 mouseup 시점의 '커서 아래 element'로 결정된다
 *      (results.js 의 $results.on('mouseup', '.select2-results__option[aria-selected]')).
 *      → 밀린 목록 위에서 mouseup → 한 칸 위 item 이 선택된다.
 *   ★ Safari 는 이때 mousedown 을 DOM 에 전달하지 않는다. 즉 'mousedown 기준' 방어는 무력하다.
 *
 * 해결 (mousedown 에 의존하지 않는 방어 위주):
 *   [1] 결과 item mousedown 에서 preventDefault() → 포커스 이탈(=IME commit) 자체를 줄인다.
 *       (mousedown 이 오는 브라우저에서만 유효. Safari IME 상황에서는 동작하지 않는다)
 *   [2] handleSearch 를 짧게 coalesce + 같은 검색어면 무시.
 *       commit 이 만든 "원"→"원예" 연속 input 이 1건으로 합쳐지고, 직전 조회어와 같아 통째로 버려진다.
 *   [3] mousedown~mouseup 사이에 목록이 변했으면 '누른 item' 을 선택. (mousedown 이 오는 브라우저용)
 *   [4] "검색중..." 행을 prepend 대신 목록 맨 뒤로 옮긴다.
 *       → query 가 어떤 이유로 끼어들더라도 기존 행들의 좌표가 흔들리지 않는다. (최종 방어선)
 */
(function patchSelect2ImeSearch($) {
  if (!$ || !$.fn || !$.fn.select2 || !$.fn.select2.amd) return;

  const amd = $.fn.select2.amd;
  const OPTION_SELECTOR = '.select2-results__option[aria-selected]';

  // 결과 item mousedown ~ 셀렉션 직후 사이를 '셀렉션 중'으로 표시
  let isSelecting = false;
  // [3]에서 쓰는 '지금 누르고 있는 결과 item'. 인스턴스마다 리스너를 달지 않도록 모듈 스코프에 둔다.
  let pressedOption = null;
  let pressedResultsEl = null;

  // [1] 캡처 단계에서 결과 item mousedown을 잡아 포커스 이탈을 차단한다.
  //   - 캡처 단계여야 select2 dropdown 컨테이너의 stopPropagation(버블)보다 먼저 실행된다.
  //   - 선택은 mouseup에서 일어나므로 preventDefault해도 선택 동작에는 영향이 없다.
  document.addEventListener('mousedown', function (e) {
    const target = e.target;
    const canQuery = !!(target && target.closest);

    // 어느 결과 목록의 어떤 item을 눌렀는지 기억해 둔다([3]에서 사용).
    pressedOption = canQuery ? target.closest(OPTION_SELECTOR) : null;
    pressedResultsEl = pressedOption ? pressedOption.closest('.select2-results__options') : null;

    if (canQuery && target.closest('.select2-results__option')) {
      isSelecting = true;
      e.preventDefault(); // search input의 blur(=IME commit → 재검색 → 재렌더)를 원천 차단
    }
  }, true);

  // isSelecting 해제는 '캡처' 단계에서 한다.
  //   [3]이 보정할 때 stopPropagation()을 하는데, 버블 단계에 두면 그 경우 해제가 영영 안 된다.
  document.addEventListener('mouseup', function () {
    // 셀렉션으로 인한 포커스 이탈/조합 commit 이벤트가 모두 흘러간 뒤 해제
    setTimeout(function () {
      isSelecting = false;
    }, 300);
  }, true);

  // 드롭다운 밖에서 버튼을 떼면(드래그 이탈) 기억을 지운다.
  //   버블 단계라 [3]이 보정한 경우엔 도달하지 않지만, 그 경로는 핸들러 안에서 직접 비운다.
  document.addEventListener('mouseup', function () {
    pressedOption = null;
    pressedResultsEl = null;
  }, false);

  // 드롭다운이 새로 열리면 플래그를 즉시 초기화 (안전장치)
  $(document).on('select2:open', function () {
    isSelecting = false;
  });

  // [2] handleSearch coalesce + 같은 검색어 재조회 차단
  //   IME commit 은 1~3ms 간격으로 input 을 몰아서 흘린다("원예"→"원"→"원예").
  //   짧게 묶어두면 마지막 값 하나만 남고, 그 값이 직전 조회어와 같아 [2]의 dedupe 에 걸려 사라진다.
  //   사람이 치는 속도(보통 80ms 이상 간격)에는 영향이 없다.
  const SEARCH_COALESCE_MS = 50;

  ['select2/dropdown/search', 'select2/selection/search'].forEach(function (moduleName) {
    let Adapter;
    try {
      Adapter = amd.require(moduleName);
    } catch (e) {
      return;
    }
    if (!Adapter || !Adapter.prototype || Adapter.prototype.__imeSearchPatched) return;

    const originalHandleSearch = Adapter.prototype.handleSearch;
    Adapter.prototype.handleSearch = function () {
      // 결과 클릭으로 인한 포커스 이탈/조합 commit이 만든 spurious query는 무시
      if (isSelecting) return undefined;

      // 검색 input을 못 찾으면 비교할 수 없으므로 원래 동작을 그대로 둔다.
      if (!this.$search || !this.$search.length) return originalHandleSearch.apply(this, arguments);

      // 원본과 동일하게 keyUp 억제 플래그를 여기서 소비한다.
      if (this._keyUpPrevented) {
        this._keyUpPrevented = false;
        return undefined;
      }

      const self = this;
      window.clearTimeout(this.__searchTimer);
      this.__searchTimer = window.setTimeout(function () {
        // 검색어가 직전 조회와 동일하면(= IME commit 이 값만 왕복시킨 경우) 재조회하지 않는다.
        const term = self.$search.val();
        if (self.__lastSearchTerm !== undefined && term === self.__lastSearchTerm) return;
        self.__lastSearchTerm = term;
        originalHandleSearch.call(self);
      }, SEARCH_COALESCE_MS);

      return undefined;
    };

    // 드롭다운 open/close, 선택/해제 시 검색어 기억을 비운다 (같은 단어를 다시 검색할 수 있도록)
    const originalBind = Adapter.prototype.bind;
    Adapter.prototype.bind = function (decorated, container) {
      const self = this;
      const result = originalBind.apply(this, arguments);
      const reset = function () { self.__lastSearchTerm = null; };
      container.on('open', reset);
      container.on('close', reset);
      container.on('select', reset);
      container.on('unselect', reset);
      return result;
    };

    Adapter.prototype.__imeSearchPatched = true;
  });

  // [3] mousedown 기준 선택 (최종 방어선)
  (function patchResultsMouseAnchor() {
    let Results;
    let Utils;
    try {
      Results = amd.require('select2/results');
      Utils = amd.require('select2/utils');
    } catch (e) {
      return;
    }
    if (!Results || !Results.prototype || Results.prototype.__mouseAnchorPatched) return;

    // [4] "검색중..." 행이 목록을 밀지 않게 한다 (최종 방어선).
    //   select2 기본은 prepend 라 기존 행 전체가 한 행 아래로 내려가고, 그 상태에서 mouseup 이
    //   일어나면 커서 아래 item 이 바뀐다. 기존 결과가 있을 때는 맨 뒤로 보내 좌표를 고정한다.
    const originalShowLoading = Results.prototype.showLoading;
    Results.prototype.showLoading = function () {
      originalShowLoading.apply(this, arguments);

      const $loading = this.$results.find('.loading-results');
      if ($loading.length && this.$results.children().length > 1) {
        this.$results.append($loading);
      }
    };

    const originalBind = Results.prototype.bind;
    Results.prototype.bind = function () {
      const self = this;
      const resultsEl = this.$results[0];

      // 캡처 단계 → select2 자신의 mouseup(delegated, 버블)보다 먼저 실행된다.
      // 누른 item은 document 캡처 mousedown([1])에서 이미 기억해 두었다.
      resultsEl.addEventListener('mouseup', function (evt) {
        const anchor = pressedOption;
        const anchorList = pressedResultsEl;
        pressedOption = null;
        pressedResultsEl = null;

        if (!anchor) return;
        if (anchorList !== resultsEl) return; // 다른 select2에서 누른 것 → 관여하지 않는다

        const released = evt.target.closest ? evt.target.closest(OPTION_SELECTOR) : null;
        if (released === anchor) return; // 목록이 안 밀렸으면 select2 기본 동작에 맡긴다

        // 목록이 밀렸다 → 커서 위치로 판단하는 select2 mouseup 핸들러를 막고 직접 처리한다.
        evt.stopPropagation();

        const data = Utils.GetData(anchor, 'data');
        if (!data) return;

        if (anchor.getAttribute('aria-selected') === 'true') {
          if (self.options.get('multiple')) {
            self.trigger('unselect', { originalEvent: evt, data: data });
          } else {
            self.trigger('close', {});
          }
          return;
        }
        self.trigger('select', { originalEvent: evt, data: data });
      }, true);

      return originalBind.apply(this, arguments);
    };

    Results.prototype.__mouseAnchorPatched = true;
  })();
})(window.jQuery || window.$);

window.addEventListener('load', () => {
  Utils.setDatepicker();
  Utils.setDatetimepicker();
  Utils.setSelect2();
  Utils.setToastr();
  Utils.setInputmask();
});

/**
 * 공통함수
 */
const Utils = (function () {
  let global = {};

  window.addEventListener('load', () => {
    init();
  });

  /**
   * Initialize (Only Once)
   */
  function init() {
    setHeaderEvent();
    setTooltip();
    setTableCheckbox();
    setCommonEvent();
    setDoubleModalEvent();
    setPopover();
    setBannerEvent();
    setContenteditableEvent();
    setWeatherEvent();
    setAriaListEvent();
    setTocEvent();
    setScrollTopEvent();
  }
  function setTocEvent() {
    // TOC 닫기
    $(document).on('click', '.btn-toc-close', function () {
      const $container = $(this).closest('.toc-container');
      $container.addClass('closed');
      setTimeout(() => { $(window).trigger('resize'); }, 0);
    });
    // TOC 열기
    $(document).on('click', '.btn-toc-open', function () {
      const $container = $(this).closest('.toc-container');
      $container.removeClass('closed');
      setTimeout(() => { $(window).trigger('resize'); }, 0);
    });
    // TOC 링크 클릭 시 해당 섹션으로 스크롤
    $(document).on('click', '.content-item a[href^="#"]', function (e) {
      e.preventDefault();
      const target = document.getElementById($(this).attr('href').substring(1));
      if (target) {
        const scroller = target.closest('.layout-main');
        if (!scroller) return;
        const marginTop = parseFloat(getComputedStyle(target).marginTop) || 0;
        const top = target.getBoundingClientRect().top - scroller.getBoundingClientRect().top + scroller.scrollTop - marginTop;
        scroller.scrollTo({ top, behavior: 'smooth' });
      }
    });
  }
  function setAriaListEvent() {
    $(document).on('change', '.aria-item input[type="radio"]', function () {
      const $target = $($(this).attr('data-target'));

      $target.removeClass('d-none');
      $target.siblings('.aria-content').addClass('d-none');
    });
  }
  /**
   * Set Weather Scroll Event
   */
  function setWeatherEvent() {
    $(document).on('click', '.weather-tab .nav-link', function () {
      const $container = $(this).closest('.weather-container');
      const $table = $container.find('.weather-table');
      const index = $(this).parents().index();
      const totalCol = $container.find('.weather-table-row:first-of-type .weather-table-data');
      const $target = $container.find(`.weather-table-row:first-of-type .weather-table-data:nth-last-of-type(${index == 0 ? totalCol.length - 1 : 48 / index + 1})`);
      const stickyColWidth = $container.find('.weather-table-row:first-of-type .weather-table-data:first-of-type').outerWidth();
      const duration = Math.abs($target.position().left - stickyColWidth - $table[0].scrollLeft);

      $table.stop().animate({ scrollLeft: $target.position().left - stickyColWidth }, duration / 6);

      if (global['weather'] != null) clearInterval(global['weather']);

      global['weather'] = setTimeout(() => {
        global['weather'] = null;
      }, duration / 6);
    });
    $(document).on('scroll', '.weather-table', function () {
      const $container = $(this).closest('.weather-container');
      const $table = $container.find('.weather-table');
      const $tabs = $container.find('.weather-tab .nav-item');
      const totalCol = $container.find('.weather-table-row:first-of-type .weather-table-data');

      if (!global['weather']) {
        $tabs.each(function () {
          const index = $(this).index();
          const $target = $container.find(`.weather-table-row:first-of-type .weather-table-data:nth-last-of-type(${index == 0 ? totalCol.length - 1 : 48 / index + 1})`);
          const stickyColWidth = $container.find('.weather-table-row:first-of-type .weather-table-data:first-of-type').outerWidth();

          if ($table[0].scrollLeft >= $target.position().left - stickyColWidth) {
            $tabs.find('.nav-link').removeClass('active');
            $(this).find('.nav-link').addClass('active');
          }
        });
      }
    });
  }
  function setContenteditableEvent() {
    const allowedTags = ['i', 'div', 'br'];

    let currentSelection = null;
    let currentRange = null;
    let activeEditor = null;

    // 선택 처리 함수
    const fnHandleSelection = (e) => {
      const selection = window.getSelection();

      if (selection.rangeCount === 0 || selection.isCollapsed) {
        fnHideToolbox();
        return;
      }

      const selectedText = selection.toString().trim();
      if (selectedText.length === 0) {
        fnHideToolbox();
        return;
      }

      const range = selection.getRangeAt(0);
      const $editor = $(e.target).closest('.contenteditable');

      currentSelection = selection;
      currentRange = range;
      activeEditor = $editor;

      fnShowToolbox(range);
      updateToolboxState();
    };

    // 툴박스 표시
    const fnShowToolbox = (range) => {
      const isRangeOverlappedByScroll = (range, element) => {
        const rangeRect = range.getBoundingClientRect();
        const elementRect = element.getBoundingClientRect();

        // range가 element의 보이는 영역에 있는지 확인
        const isVisible = rangeRect.left >= elementRect.left && rangeRect.right <= elementRect.right && rangeRect.top >= elementRect.top && rangeRect.bottom <= elementRect.bottom;

        return {
          isVisible: isVisible,
          isCursorLeft: rangeRect.right > elementRect.right,
          isCursorRight: rangeRect.left < elementRect.left,
        };
      };
      const container = currentRange.commonAncestorContainer;
      const element = container.nodeType === Node.TEXT_NODE ? container.parentElement : container;
      const $iParent = $(element).closest('i');

      const rect = range.getBoundingClientRect();

      if ($('.contenteditable-toolbox').length == 0) {
        $('body').append(`
          <div class="contenteditable-toolbox">
            <button type="button" class="btn-icon btn-italic">
              <i class="material-icons ${$iParent.length > 0 ? 'active' : ''}">format_italic</i>
            </button>
          </div>
        `);
      }
      const $toolbox = $('.contenteditable-toolbox');

      let left = $(document).scrollLeft() - $toolbox.outerWidth() / 2;

      if (isRangeOverlappedByScroll(range, element).isVisible) {
        left += rect.left + rect.width / 2;
      } else {
        if (isRangeOverlappedByScroll(range, element).isCursorLeft && !isRangeOverlappedByScroll(range, element).isCursorRight) {
          left += rect.left + (element.getBoundingClientRect().right - rect.left) / 2;
        } else {
          left += rect.right - (rect.right - element.getBoundingClientRect().left) / 2;
        }
      }
      const top = rect.top + rect.height + 12;

      $toolbox.css({
        left: left + 'px',
        top: top + 'px',
      });
    };

    // 툴박스 숨기기
    const fnHideToolbox = () => {
      $('.contenteditable-toolbox').remove();
      currentSelection = null;
      currentRange = null;
      activeEditor = null;
    };

    // 툴박스 상태 업데이트
    const updateToolboxState = () => {
      if (!currentRange) return;

      const container = currentRange.commonAncestorContainer;
      const element = container.nodeType === Node.TEXT_NODE ? container.parentElement : container;
      const hasItalic = $(element).closest('i').length > 0;

      $('.btn-italic').toggleClass('active', hasItalic);
    };

    // 이탤릭 토글
    const toggleItalic = () => {
      if (!currentSelection || !currentRange) return;

      // 현재 선택 영역 복원
      currentSelection.removeAllRanges();
      currentSelection.addRange(currentRange);

      // 브라우저 내장 이탤릭 기능 사용
      document.execCommand('italic');

      // 새로운 선택 영역 가져오기
      const newSelection = window.getSelection();
      if (newSelection.rangeCount > 0) {
        currentSelection = newSelection;
        currentRange = newSelection.getRangeAt(0);
      }

      updateToolboxState();

      if (activeEditor) activeEditor.trigger('input');
    };

    const fnSanitizeHTML = (html) => {
      const $temp = $('<div>').html(html);
      $temp.find('*').each((_, el) => {
        if (!allowedTags.includes(el.tagName.toLowerCase())) {
          $(el).replaceWith($(el).html());
        }
      });
      return $temp.html();
    };

    const fnHtmlToText = (html) => {
      const $temp = $('<div>').html(html);

      // br을 \n으로 변환
      // $temp.find('br').replaceWith('\n');

      // div를 \n으로 변환 (첫 번째 제외)
      $temp.find('div').each((i, div) => {
        const $div = $(div);
        $div.before('&lt;br&gt;');
        $div.replaceWith($div.html());
      });

      // i 태그를 <i>텍스트</i> 형태로 변환
      $temp.find('i').each((_, i) => {
        $(i).replaceWith(`&lt;i&gt;${$(i).html()}&lt;/i&gt;`);
      });

      return $temp.text();
    };

    const fnRemoveEmptyItalicTags = (html) => {
      const $temp = $('<div>').html(html);

      $temp.find('i').each(function () {
        const $i = $(this);
        const content = $i.html(); // innerHTML 가져오기

        // 완전히 비어있는 i 태그만 제거
        if (content === '') {
          $i.remove();
        }
        // 공백만 있는 경우 태그 제거하고 내용 유지
        else if ($i.text().trim() === '' && content !== '') {
          $i.replaceWith(content);
        }
      });

      if (currentRange) {
        const selection = window.getSelection();
        selection.addRange(currentRange);
      }

      return $temp.html();
    };

    // 붙여넣기 이벤트
    $(document).on('paste', '.contenteditable-wrap .contenteditable', async function (e) {
      e.preventDefault();

      try {
        const text = await navigator.clipboard.readText();
        const selection = window.getSelection();

        if (selection.rangeCount > 0) {
          const range = selection.getRangeAt(0);
          range.deleteContents();

          const textNode = document.createTextNode(text);
          range.insertNode(textNode);
          range.setStartAfter(textNode);
          range.collapse(true);
          selection.removeAllRanges();
          selection.addRange(range);
        }

        $(this).trigger('input');

        // 붙여넣은 텍스트 끝의 커서 위치로 스크롤
        setTimeout(() => {
          const element = this;
          const updatedSelection = window.getSelection();
          if (!updatedSelection.rangeCount) return;

          // 임시 span을 커서 위치에 삽입하여 정확한 위치 측정
          const range = updatedSelection.getRangeAt(0);
          const tempSpan = document.createElement('span');
          tempSpan.textContent = '\u200B'; // 제로폭 공백문자

          const clonedRange = range.cloneRange();
          clonedRange.insertNode(tempSpan);

          // 커서 위치와 요소 경계 계산
          const spanRect = tempSpan.getBoundingClientRect();
          const elementRect = element.getBoundingClientRect();

          // 커서가 요소의 오른쪽 경계를 벗어났는지 확인
          const cursorX = spanRect.left;
          const elementRight = elementRect.right;
          const elementLeft = elementRect.left;
          const padding = 1;

          if (cursorX > elementRight - padding) {
            // 오른쪽으로 스크롤 필요
            const overflowAmount = cursorX - (elementRight - padding);
            element.scrollLeft += overflowAmount;
          } else if (cursorX < elementLeft + padding) {
            // 왼쪽으로 스크롤 필요 (혹시 모를 경우)
            const underflowAmount = elementLeft + padding - cursorX;
            element.scrollLeft = Math.max(0, element.scrollLeft - underflowAmount);
          }

          // 임시 span 제거
          tempSpan.remove();

          // 선택 영역 복원
          updatedSelection.removeAllRanges();
          updatedSelection.addRange(range);
        }, 0);
      } catch (error) {}
    });

    // 포커스 이벤트
    $(document).on('focusin', '.contenteditable-wrap input, .contenteditable-wrap textarea', function (e) {
      const $parent = $(this).closest('.contenteditable-wrap');
      $parent.find('.contenteditable').trigger('focus');
    });

    // 입력 이벤트
    $(document).on('input', '.contenteditable-wrap .contenteditable', function (e) {
      const $this = $(this);
      if ($(this).html().trim() == '<br>') $(this).html('');
      const $input = $this.closest('.input-wrap').find('input, textarea');
      if (!$input.length) return;

      let html = $this.html();

      // HTML 정리
      let sanitizedHtml = fnSanitizeHTML(html);

      // 빈 i 태그 제거 (정규식 사용)
      sanitizedHtml = fnRemoveEmptyItalicTags(sanitizedHtml);

      // contenteditable에 정리된 HTML 적용 (변경된 경우만)
      // if (html !== sanitizedHtml) {
      //   // 커서 위치 저장
      //   const selection = window.getSelection();
      //   let cursorPosition = 0;

      //   if (selection.rangeCount > 0) {
      //     const range = selection.getRangeAt(0);
      //     cursorPosition = range.startOffset;
      //   }

      //   $this.html(sanitizedHtml);

      //   // 커서 위치 복원 시도
      //   try {
      //     const range = document.createRange();
      //     const firstChild = $this[0].firstChild;
      //     if (firstChild && firstChild.nodeType === Node.TEXT_NODE) {
      //       range.setStart(firstChild, Math.min(cursorPosition, firstChild.textContent.length));
      //       range.collapse(true);
      //       selection.removeAllRanges();
      //       selection.addRange(range);
      //     }
      //   } catch (error) {
      //     // 커서 복원 실패 시 무시
      //   }
      // }

      // input 텍스트 형태로 변환하여 동기화
      const text = fnHtmlToText(sanitizedHtml);
      $input.val(text);
      $input[0].dispatchEvent(new Event('input'));
      $input.trigger('keyup');
    });

    // 이벤트 바인딩
    $(document).on('mouseup', '.contenteditable-wrap .contenteditable', function (e) {
      setTimeout(() => fnHandleSelection(e), 10);
    });
    $(document).on('keyup', '.contenteditable-wrap .contenteditable', function (e) {
      if (e.key === 'Shift' || e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'ArrowUp' || e.key === 'ArrowDown' || e.key === 'Meta') {
        setTimeout(() => fnHandleSelection(e), 10);
      }
    });

    // 툴박스 버튼 이벤트
    $(document).on('click', '.btn-italic', toggleItalic);

    // 문서 클릭으로 툴박스 숨기기
    $(document).on('click', function (e) {
      if ($(e.target).closest('.contenteditable-toolbox').length == 0 && $('.contenteditable-toolbox').length > 0) {
        fnHideToolbox();
      }
    });
    $(document).on('mousewheel', function (e) {
      const selection = window.getSelection();

      if (currentRange != null) {
        setTimeout(() => fnHandleSelection(e), 10);
      }
    });

    // Command 이벤트
    $(document).on('keydown', '.contenteditable-wrap .contenteditable', function (e) {
      const $input = $(this).closest('.input-wrap').find('input, textarea');

      // 다른 포맷팅 단축키, input enter key 비활성화
      if ((e.ctrlKey && ['b', 'u'].includes(e.key)) || ($input[0].tagName == 'INPUT' && e.key == 'Enter')) {
        e.preventDefault();
      }

      if (currentRange != null) {
        $(this).trigger('mouseup');
      }

      if (e.key == 'Enter') {
        const enterEvent = new KeyboardEvent('keydown', {
          key: 'Enter',
          code: 'Enter',
          which: 13,
          keyCode: 13,
          bubbles: true,
          cancelable: true,
          composed: true,
          isComposing: e.originalEvent.isComposing,
        });
        $input[0].dispatchEvent(enterEvent);
      }
    });
  }
  function setBannerEvent() {
    // 배너 삭제 이벤트
    $(document).on('click', '.layout-banner .btn-close', function () {
      $(this).closest('.layout-banner').removeClass('active');
    });
  }
  /**
   * Set Header Tab Event For Accessibility
   */
  function setHeaderEvent() {
    // #region hover event
    // TODO: 임시코드 추후 Utils.getBreakpoint() != 'lg' 제거
    let isMoved = false;
    let timeOut = null;
    $(document).on('mouseenter focusin', '.layout-header .navbar-nav .nav-item', function () {
      const $header = $('.layout-header');

      if (!isMoved) {
        if (Utils.getBreakpoint() != 'sm' && Utils.getBreakpoint() != 'md' && Utils.getBreakpoint() != 'lg' && Utils.getBreakpoint() != 'xl') {
          isMoved = true;
          clearTimeout(timeOut);
          $header.addClass('active');
          $header.find('.dropdown.show .btn').trigger('blur');
          $header.find('.dropdown.show, .dropdown .show').removeClass('show');
          let $subItem = $header.find('ul ul');
          let $maxSubItem = $subItem;
          $subItem.filter(function (index, el) {
            if (index > 0) {
              if ($(el).outerHeight() > $maxSubItem.outerHeight()) {
                $maxSubItem = $(el);
              }
            }
          });
          let fontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
          let maxHeight = $maxSubItem.height() / fontSize + 8 + 'rem';
          $header.stop().animate({ height: maxHeight }, 300);
          setTimeout(function () {
            isMoved = false;
          }, 300);
        }
      }
    });
    $(document).on('mouseleave', '.layout-header .navbar-nav .nav-item', function () {
      const $header = $('.layout-header');

      if (Utils.getBreakpoint() != 'sm' && Utils.getBreakpoint() != 'md' && Utils.getBreakpoint() != 'lg' && Utils.getBreakpoint() != 'xl') {
        isMoved = false;
        $header.stop().animate({ height: '5rem' }, 300);
        clearTimeout(timeOut);
        timeOut = setTimeout(function () {
          $header.removeClass('active');
          $header.find('.dropdown.show .btn').trigger('blur');
          $header.find('.dropdown.show, .dropdown .show').removeClass('show');
        }, 250);
      }
    });
    // #endregion hover event
    // #region mobile menu event
    $(document).on('click', '.navbar-nav.mobile a', () => {
      const $mobileMenu = $('.navbar.mobile');

      $('.layout-header').append('<div class="header-backdrop modal-backdrop fade"></div>');
      $mobileMenu.addClass('active');
      $mobileMenu.addClass('visible');
      setTimeout(() => {
        $('body').addClass('modal-open mobile');
        $('.header-backdrop').addClass('show');
      }, 100);
    });
    $(document).on('click', '.header-backdrop, .btn-navbar-close', () => {
      const $mobileMenu = $('.navbar.mobile');

      $('.header-backdrop').removeClass('show');
      $mobileMenu.removeClass('active');
      $('body').removeClass('modal-open mobile');
      setTimeout(() => {
        $('.header-backdrop').remove();
        $mobileMenu.removeClass('visible');
        $('html').scrollLeft(1000)
      }, 300);
    });
    // #endregion mobile menu event
    // #region tab event
    $(document).on('focusin', '.layout-header .navbar-nav .nav-item', function () {
      removeMenuActive();
      $(this).addClass('active');
    });
    $(document).on('click', '.layout-header .navbar-nav .nav-item', function () {
      const $navItem = $('.layout-header .navbar-nav .nav-item');

      $navItem.removeClass('active-only');
      $(this).addClass('active-only');
      $(this).removeClass('active');
    });
    $(document).on('focusin', '.navbar-brand, .layout-header .navbar-nav li > a', function () {
      removeMenuActive();
    });
    $(document).on('mousedown', function () {
      removeMenuActive();
    });
    $('.contents-skip, .layout-main, .layout-footer, .btn.login').on('focusin', function () {
      const $header = $('.layout-header');

      removeMenuActive();
      if ($header.hasClass('active')) {
        if (Utils.getBreakpoint() != 'sm' && Utils.getBreakpoint() != 'md' && Utils.getBreakpoint() != 'lg') {
          $header.animate({ height: '5rem' }, 300);
          clearTimeout(timeOut);
          timeOut = setTimeout(function () {
            $header.removeClass('active');
          }, 250);
        }
      }
    });
    function removeMenuActive() {
      $('.layout-header .navbar-nav .nav-item').removeClass('active');
    }
    // #endregion tab event
    // #region login menu event
    $(document).on('click', '.dropdown-menu', function (e) {
      const isDropdownItem = $(e.target).closest('.dropdown-item').length > 0;
      if (!isDropdownItem) e.stopPropagation();
    });
    // #endregion login menu event
  }
  /**
   * Set Common Event
   */
  function setCommonEvent() {
    // #region password event
    $(document).on('click', '.btn-password-view', function () {
      const $input = $(this).parents('.password-container').find('input');

      if ($(this).text() == 'visibility_off') {
        $input.attr('type', 'text');
        $(this).find('i').text('visibility');
      } else {
        $input.attr('type', 'password');
        $(this).find('i').text('visibility_off');
      }
    });
    // #endregion password event
    // #region step event
    $(document).on('click', '.btn-step', function () {
      let count = 0;
      const fnStepEvent = () => {
        if (count >= 10) return;
        setTimeout(() => {
          const $container = $(this).closest('.login-main, .step-main');
          const $containerInner = $(this).closest('.login-main-inner, .step-main-inner');
          const $currentSectionForm = $(this).closest('section').parent('form').length > 0 ? $(this).closest('section').parent('form') : $(this).closest('section');
          const $currentSection = $(this).closest('section');
          const $targetForm = $($(this).attr('data-target')).parent('form').length > 0 ? $($(this).attr('data-target')).parent() : $($(this).attr('data-target'));
          const $target = $($(this).attr('data-target'));

          // modal size 변경
          if ($target.closest('.modal') && $target.attr('data-size')) {
            $target.closest('.modal-dialog').removeClass('modal-sm modal-md modal-lg modal-xl modal-xxl');
            $target.closest('.modal-dialog').addClass($target.attr('data-size'));
          }

          if ($target.length == 0) {
            fnStepEvent();
          } else {
            $target.css('display', 'block');
            if ($targetForm.index() > 0) {
              $container.find('h1').css('display', 'none');
            } else {
              $container.find('h1').css('display', 'block');
            }

            if ($targetForm.index() > $currentSectionForm.index()) {
              $containerInner.css('transform', `translateX(-${$container.outerWidth()}px)`);
            } else {
              $containerInner.addClass('no-animate');
              $containerInner.css('transform', `translateX(-${$container.outerWidth()}px)`);
              setTimeout(function () {
                $containerInner.removeClass('no-animate');
                $containerInner.css('transform', 'translateX(0)');
              }, 10);
            }
            setTimeout(function () {
              $containerInner.addClass('no-animate');
              $currentSection.css('display', 'none');
              $containerInner.css('transform', 'translateX(0)');
              setTimeout(function () {
                $containerInner.removeClass('no-animate');
              }, 10);
            }, 300);
          }
        }, 100);
        count++;
      };
      fnStepEvent();
    });
    // #endregion step event
    // #region number list event
    $(document).on('click', '.btn-code-request', function () {
      const $codeInput = $(this).parent().prev().find('input');
      const $target = $($(this).attr('data-target'));

      $target.find('.target-email').html($codeInput.val());

      Utils.setCodeTimer($(this).attr('data-target'));
    });
    $(document).on('click', '.btn-step[data-target="#step_1"]', function () {
      $(window).off('beforeunload');
    });
    $(document).on('paste', '.number-list .number-item input:not(:disabled)', function (e) {
      e.preventDefault();

      const clipboardData = e.originalEvent.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData('text');

      // 숫자만 추출
      const numbers = pastedText.replace(/\D/g, '').split('');

      // 현재 input부터 이후 input들에 숫자 하나씩 넣기
      const $inputs = $('.number-list .number-item input');
      const startIndex = $inputs.index(this);

      numbers.forEach((num, i) => {
        const $input = $inputs.eq(startIndex + i);
        if ($input.length) {
          $input.val(num);
        }
      });

      // 붙여넣기 이후, 다음 빈 input으로 focus 이동
      const nextEmpty = $inputs.toArray().find((input, i) => i >= startIndex && !input.value);
      if (nextEmpty) {
        $(nextEmpty).focus();
      }
    });
    $(document).on('input', '.number-list .number-item input:not(:disabled)', function (e) {
      const inputData = e.originalEvent.data;
      const $numberItem = $(this).closest('.number-item');

      if (inputData) {
        let isValid = /[0-9]/g.test(inputData);

        if (isValid) {
          $(this).val(inputData);
          $numberItem.next().find('input').trigger('focus');
        } else {
          $(this).val('');
        }
      }
    });
    $(document).on('keydown', '.number-list .number-item input:not(:disabled)', function (e) {
      e.stopPropagation();

      const $numberItem = $(this).closest('.number-item');

      if (e.originalEvent.code == 'ArrowLeft') {
        let $prevInput = $numberItem.prev().find('input');
        setTimeout(function () {
          $prevInput.trigger('select');
        }, 0);
      } else if (e.originalEvent.code == 'ArrowRight') {
        let $nextInput = $numberItem.next().find('input');
        setTimeout(function () {
          $nextInput.trigger('select');
        }, 0);
      } else if (e.originalEvent.code == 'Backspace') {
        let $targetInput = $numberItem.prev().find('input');
        if (e.target.value != '') {
          $targetInput = $numberItem.find('input');
        }

        if ($targetInput.length > 0) {
          $targetInput.val('').focus();
        }
      }
    });
    // #endregion number list event
    // #region sidebar event
    $(document).on('click', '.list-sidebar .sidebar-link', function () {
      const $sidebarDetail = $(this).closest('.list-sidebar').find('.sidebar-detail');
      const $targetDetail = $($(this).attr('data-target'));

      if ($(this).hasClass('active')) {
        $sidebarDetail.removeClass('active');
        $(this).removeClass('active');
      } else {
        $(this).parent().siblings().find('.sidebar-link').removeClass('active');
        $(this).addClass('active');
        $targetDetail.siblings().addClass('d-none');
        $targetDetail.removeClass('d-none');

        if (!$sidebarDetail.hasClass('active')) {
          $sidebarDetail.addClass('active');
        }
      }
    });
    $(document).on('click', '.list-sidebar .result-link', function (e) {
      const $resultItem = $(this).closest('.result-item');

      if (!$(this).hasClass('active')) {
        $resultItem.siblings().find('.result-link').removeClass('active');
        $(this).addClass('active');
      }
    });
    // #endregion sidebar event
    // #region custom select2-search event
    $(document).on('click', '.search-selected-list .btn-remove', function (e) {
      $(this).closest('.search-selected-item').remove();
    });
    // #endregion custom select2-search event
    // #region input wrap event
    $(document).on('input focus', '.input-wrap input, .input-wrap textarea', function () {
      const $btnClear = $(this).closest('.input-wrap').find('.btn-clear');

      if ($(this).val().trim() != '') {
        $btnClear.removeClass('d-none');
      } else {
        $btnClear.addClass('d-none');
      }
    });
    $(document).on('input focus', '.contenteditable-wrap .contenteditable', function () {
      const $btnClear = $(this).closest('.input-wrap').find('.btn-clear');

      if ($(this).html() != '') {
        $btnClear.removeClass('d-none');
      } else {
        $btnClear.addClass('d-none');
      }
    });
    $(document).on('mousedown', '.input-wrap .btn-clear', function () {
      const $input = $(this).closest('.input-wrap').find('input');
      const $contenteditable = $(this).closest('.input-wrap').find('.contenteditable');
      $contenteditable.html('');
      $input.val('').trigger('input');
    });
    // #endregion input wrap event
    // #region add input wrap
    $(document).on('click', '.add-input-list .btn-add', function () {
      const $addInputList = $(this).closest('.add-input-list');
      const $newItem = $(this).closest('.add-input-item').clone();
      $newItem.find('.contenteditable').html('');
      $newItem.find('input').val('');
      $newItem.find('input').attr('id', '');
      // $newItem.find('select').val('');
      // $newItem.find('span.select2-container').remove();
      // $newItem.find('select').removeClass('select2-hidden-accessible');
      // $newItem.find('select').removeAttr('data-select2-id');
      // $newItem.find('select').each(function() {
      //   $(this).attr('id', `${$(this).attr('id')}_${new Date().getTime()}`);
      // });
      $newItem.find('.btn').removeClass('btn-add');
      $newItem.find('.btn').addClass('btn-remove');
      $newItem.find('.btn').html($newItem.find('.btn').html().replace('추가', '삭제'));
      $newItem.find('.btn i').text('delete_outline');
      $newItem.find('.btn i').addClass('text-danger');

      $addInputList.append($newItem);

      Utils.setInputmask();
      Utils.setSelect2();
    });
    $(document).on('click', '.add-input-list .btn-remove', function () {
      const $addInputList = $(this).closest('.add-input-list');
      const addInputLength = $addInputList.find('.add-input-item').length;
      const defaultValue = $addInputList.attr('data-default');

      if (!defaultValue || (defaultValue && defaultValue < addInputLength)) {
        $(this).closest('.add-input-item').remove();
      }
    });
    // #endregion add input wrap
    // #region tag event
    $(document).on('keydown', '.tag-wrap input', function (e) {
      if (e.originalEvent.isComposing) return;

      let value = Utils.getEscapeHtml($(this).val().trim(), ['i']);
      let validValue = $(this)
        .val()
        .trim()
        .replace(/<\/?i>/g, '')
        .replace(/\s+/g, '');
      const $contenteditableWrap = $(this).closest('.contenteditable-wrap');
      const $tagWrap = $(this).closest('.tag-wrap');
      const $tagList = $tagWrap.find('.tag-list');
      const valueArr = $tagList
        .find('input')
        .map((index, input) => {
          return $(input)
            .val()
            .replace(/<\/?i>/g, '')
            .replace(/\s+/g, '');
        })
        .get();

      if (e.code == 'Enter') {
        if(!$tagWrap.hasClass('no-validate')) {
          $(this).removeClass('is-invalid');
          $(this).closest('.tag-wrap').find('.invalid-feedback').remove();
        }

        if (value == '') return;

        if(!$tagWrap.hasClass('no-validate')) {
          if (valueArr.includes(validValue)) {
            $(this).addClass('is-invalid');
  
            if ($contenteditableWrap.length > 0) {
              $contenteditableWrap.after('<p class="invalid-feedback">이미 존재하는 태그입니다.</p>');
            } else {
              $(this).after('<p class="invalid-feedback">이미 존재하는 태그입니다.</p>');
            }
            return;
          }
  
          if (value.length > 100) {
            $(this).addClass('is-invalid');
  
            if ($contenteditableWrap.length > 0) {
              $contenteditableWrap.after('<p class="invalid-feedback">태그는 100자 이내로만 작성 가능합니다.</p>');
            } else {
              $(this).after('<p class="invalid-feedback">태그는 100자 이내로만 작성 가능합니다.</p>');
            }
            return;
          }
        }

        $(this).val('').trigger('input');
        $(this).prev('.contenteditable').html('').trigger('input');
        $tagList.append(`
        <li class="tag-item">
          <input type="hidden" name="${$(this).attr('name')}" value="${value}" />
          <span class="value">${value}</span>
          <button type="button" class="btn-icon btn-remove">
            <i class="material-icons">cancel</i>
          </button>
        </li>
        `);
      }
    });
    $(document).on('click', '.tag-wrap .btn-remove', function (e) {
      $(this).closest('.tag-item').remove();
    });
    // #endregion tag event
    // #region input number event
    $(document).on('input', 'input.integer', function () {
      if (!$(this)[0].cleave) {
        $(this)[0].cleave = true;
        new Cleave($(this)[0], {
          numeral: true,
          numeralDecimalMark: '',
          numeralPositiveOnly: true,
          numeralDecimalScale: 0,
          numeralThousandsGroupStyle: 'none',
        });
      }
    });
    // #endregion input number event
    // #region textarea event
    $(document).on('input focus', 'textarea.form-control', function () {
      if (!$(this).hasClass('original')) {
        $(this).css('height', 48);
        if ($(this).innerHeight() < $(this)[0].scrollHeight) {
          $(this).css('height', $(this)[0].scrollHeight + 2);
        }
      }
    });
    // #endregion textarea event
    // #region custom tab event
    $(document).on('change', '[data-toggle="custom-tab"]', function () {
      const $target = $($(this).attr('data-target'));
      const isShow = $(this).attr('data-show') === 'true';
      const $customTabElList = $(this).closest('.custom-checked-list').find('[data-toggle="custom-tab"]');

      $customTabElList.each((index, el) => {
        $($(el).attr('data-target')).addClass('d-none');
      });

      if (isShow) {
        $target.removeClass('d-none');
      } else {
        $target.addClass('d-none');
      }
    });
    // #endregion custom tab event
    // #region expand event
    $(document).on('click', '.log-group .btn-expand', function () {
      const $logGroup = $(this).closest('.log-group');
      const $activeLogList = $logGroup.find('.log-item:not(.d-none)');
      const defaultLength = $(this).attr('data-default');

      if ($activeLogList.length == defaultLength) {
        $logGroup.find('.log-item.d-none').removeClass('d-none');
        $(this).html('변경 내용 접기<i class="material-icons ml-8">expand_less</i>');
      } else {
        $logGroup.find('.log-item:nth-of-type(n+6)').addClass('d-none');
        $(this).html('변경 내용 펼치기<i class="material-icons ml-8">expand_more</i>');
      }
    });
    $(document).on('click', '.card-group .btn-expand', function () {
      const $cardGroup = $(this).closest('.card-group');
      const $activeCardList = $cardGroup.find('.card-member:not(.d-none)');
      const defaultLength = $(this).attr('data-default');

      if ($activeCardList.length == defaultLength) {
        $cardGroup.find('.card-member.d-none').removeClass('d-none');
        $(this).html('접기<i class="material-icons ml-8">expand_less</i>');
      } else {
        $cardGroup.find('.card-member:nth-of-type(n+6)').addClass('d-none');
        $(this).html('펼치기<i class="material-icons ml-8">expand_more</i>');
      }
    });
    $(document).on('click', '.info-group .btn-expand', function () {
      const $infoGroup = $(this).closest('.info-group');
      const $activeInfoList = $infoGroup.find('.info-item:not(.d-none)');
      const defaultLength = $(this).attr('data-default');

      if ($activeInfoList.length == defaultLength) {
        $infoGroup.find('.info-item.d-none').removeClass('d-none');
        $(this).html('접기<i class="material-icons ml-8">expand_less</i>');
      } else {
        $infoGroup.find('.info-item:nth-of-type(n+6)').addClass('d-none');
        $(this).html('펼치기<i class="material-icons ml-8">expand_more</i>');
      }
    });
    // #endregion expand event
    // #region Set Drag and Drop File
    $(document).on('dragenter', '.upload-wrap', function () {
      $(this).addClass('active');
    });
    $(document).on('dragleave drop', '.upload-wrap input[type="file"]', function () {
      const $uploadWrap = $(this).closest('.upload-wrap');
      $uploadWrap.removeClass('active');
    });
    $(document).on('change', '.upload-wrap input[type="file"]', function () {
      const files = $(this)[0].files;
      const $uploadWrap = $(this).closest('.upload-wrap');
      const $uploadInput = $uploadWrap.find('input');
      const $uploadList = $uploadWrap.next('.upload-list');
      const $uploadInputList = $uploadList.find('.upload-item input');
      const targetValidBtn = $uploadWrap.attr('data-target');
      let validExtArr = '';

      if ($uploadInput.attr('data-accept')) {
        validExtArr = $uploadInput
          .attr('data-accept')
          .split(',')
          .map((ext) => ext.replace('.', '').trim());
      } else {
        validExtArr = $uploadInput
          .attr('accept')
          .split(',')
          .map((ext) => ext.replace('.', '').trim());
      }

      if (files.length > 0) {
        // Validation
        for (let i = 0; i < files.length; i++) {
          if (!validExtArr.some((ext) => Utils.getFileDetail(files[i], true).ext.endsWith(ext))) {
            if ($uploadInput.attr('data-invalid-message')) {
              toastr.error($uploadInput.attr('data-invalid-message'));
            } else {
              toastr.error(`${validExtArr.join(', ')} 파일 확장자만 업로드 가능합니다.`);
            }
            $(this).val('');
            return;
          }
          for (let j = 0; j < $uploadInputList.length; j++) {
            if (
              Utils.getFileDetail($uploadInputList[j].files[i]).originalName == Utils.getFileDetail(files[i], true).originalName &&
              Utils.getFileDetail($uploadInputList[j].files[i]).size == Utils.getFileDetail(files[i], true).size
            ) {
              toastr.error('이미 업로드한 파일입니다.');
              $(this).val('');
              return;
            }
          }
        }

        for (let i = 0; i < files.length; i++) {
          const file = files[i];

          const dataTransfer = new DataTransfer();
          dataTransfer.items.add(file);

          const newFileInput = document.createElement('input');
          newFileInput.type = 'file';
          newFileInput.name = $(this).attr('name');
          newFileInput.classList.add('sr-only');
          newFileInput.files = dataTransfer.files;

          $uploadList.prepend(`
          <li class="upload-item">
            <div class="icon-wrap" data-ext="${Utils.getFileDetail(files[i], true).ext}"></div>
            <div class="info-wrap">
              <p class="file-info">
                <span class="file-name">${Utils.getFileDetail(files[i], true).name}</span>
                <span class="file-ext">.${Utils.getFileDetail(files[i], true).ext}</span>
              </p>
              <p class="file-size">${Utils.byteFormatter(Utils.getFileDetail(files[i], true).size)}</p>
            </div>
            <button type="button" class="btn-icon btn-remove">
              <i class="ic-delete"></i>
            </button>
          </li>
          `);
          $uploadList.find('.upload-item:first-of-type').append(newFileInput);
        }

        $(this).val('');
        $(targetValidBtn).attr('disabled', false);
      }
    });
    $(document).on('click', '.upload-list .btn-remove', function () {
      const $uploadList = $(this).closest('.upload-list');
      const $uploadWrap = $uploadList.prev('.upload-wrap');
      const targetValidBtn = $uploadWrap.attr('data-target');

      if ($(this).closest('.upload-item').siblings().length == 0) {
        $(targetValidBtn).attr('disabled', true);
      }

      $(this).closest('.upload-item').remove();
    });
    // #endregion Set Drag and Drop File
  }
  /**
   * Set Tooltip
   */
  function setTooltip() {
    $(document).on('mouseenter', '[data-toggle="tooltip"]', function () {
      const isMermaid = $(this).closest('.mermaid').length > 0;
      const isIncosheet = $(this).closest('.incosheet').length > 0;

      $('.ui-helper-hidden-accessible').remove();
      setTimeout(() => {
        const tooltipId = $(this).attr('aria-describedby');
        $(`.ui-tooltip:not(#${tooltipId})`).remove();
      }, 0);

      $(this).tooltip({
        ...((isMermaid || isIncosheet) && {
          position: {
            my: 'center top',
            at: 'center+8 bottom+10',
          },
        }),
        content: function () {
          return $(this).prop('title');
        },
      });
      $(this).tooltip('open');
    });
    $(document).on('mouseleave', '[data-toggle="tooltip"], .incosheet-input', function () {
      $('.ui-tooltip').fadeOut(300);
    });
    $(document).on('mouseenter', '.incosheet-updated, td.editmode', function () {
      $('.ui-tooltip').fadeOut(300);
    });
  }
  /**
   * Set Popover
   */
  function setPopover() {
    $(document).on('mouseenter', '[data-toggle="popover"]', function () {
      $(this).popover();
      $(this).popover('show');
    });
  }
  /**
   * Set Table Checkbox
   */
  function setTableCheckbox() {
    $(document).on('change', '.ta-table-wrap input.all', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $eachCheckboxList = $tableWrap.find('input.each');
      $eachCheckboxList.prop('checked', $(e.target).prop('checked'));
    });
    $(document).on('change', '.ta-table-wrap input.each', (e) => {
      let $tableWrap = $(e.target).parents('.ta-table-wrap');
      let $allCheckbox = $tableWrap.find('input.all');
      let $eachLength = $tableWrap.find('input.each').length;
      let $eachCheckedLength = $tableWrap.find('input.each:checked').length;
      if ($eachLength == $eachCheckedLength) {
        $allCheckbox.prop('checked', true);
      } else {
        $allCheckbox.prop('checked', false);
      }
    });
  }
  /**
   * Set Double Model Event
   */
  function setDoubleModalEvent() {
    $(document).on(
      {
        'show.bs.modal': function () {
          $('.popover').popover('hide');

          const type = $(this).attr('data-type');
          let zIndex = 1040 + 10 * $('.modal:visible').length;

          // 기존에 열려있는 modal close and 선택한 modal open
          if (type == 'close-and-open') {
            $('.modal').each((index, el) => {
              if ($(el).attr('id') == $(this).attr('id')) {
                // close and open 일때 z-index 초기화
                zIndex = 1040;
              } else {
                $(el).modal('hide');
              }
            });
          }

          $(this).css('z-index', zIndex);

          setTimeout(function () {
            $('.modal-backdrop')
              .not('.modal-stack')
              .css('z-index', zIndex - 1)
              .addClass('modal-stack');
          }, 0);
          setTimeout(() => {
            $(this).find('textarea').trigger('input');
            Utils.setInputmask();
          }, 200);
        },
        'hidePrevented.bs.modal': function (e) {
          let $target = $(e.target).attr('data-confirm');
          $($target).modal('show');
        },
        'hidden.bs.modal': function () {
          setTimeout(function () {
            if ($('.modal:visible').length > 0) {
              // restore the modal-open class to the body element, so that scrolling works
              // properly after de-stacking a modal.

              $(document.body).addClass('modal-open');
            }
          }, 300);
        },
      },
      '.modal',
    );
    $(document).on('click', '.btn-close', function () {
      let $modal = $('.modal');
      $modal.modal('hide');
    });
  }
  /**
   * Set Scroll Top Event
   */
  function setScrollTopEvent() {
    $(document).on('click', '.btn-scroll-top', function () {
      const scroller = $(this).closest('.layout-main');
      if (scroller.length) {
        scroller.animate({ scrollTop: 0 }, 800, 'swing');
      } else {
        $('html, body').animate({ scrollTop: 0 }, 800, 'swing');
      }
    });
  }

  // #region Event
  function onSelect2OpenEvent() {
    // Only Dropdown
    if ($(this).hasClass('dropdown')) {
      $('.select2-dropdown').closest('.select2-container').addClass('dropdown');
    }
    // Only title-wrap Dropdown
    if ($(this).closest('.title-wrap').length > 0) {
      $('.select2-dropdown').closest('.select2-container').addClass('title');
    }
  }
  function onSelect2SelectEvent() {
    // Multiple Select2 Set Unit
    // if($(this).attr('multiple') == 'multiple') {
    //   let $options = $('.select2-selection--multiple .select2-selection__choice');
    //   if($(this).data('unit')) {
    //     $options.attr('data-unit', $(this).data('unit'));
    //   } else {
    //     $options.attr('data-unit', '개 항목');
    //   }
    // }
    $(this).trigger('keyup');
  }
  // #endregion Event

  // #region ECharts Rich Text Auto-Parser
  /**
   * '과실성숙도<i>테스트</i>' → { text: '과실성숙도{i|테스트}', rich: { i: {fontStyle:'italic'}, b: {fontWeight:'bold'} } }
   * HTML 엔티티(&lt;i&gt; 등)로 들어와도 같은 결과로 변환된다.
   * 변환 대상 태그가 없으면 null 반환 (스킵 신호)
   */
  function parseRichText(str) {
    if (str == null || typeof str !== 'string') return null;

    // HTML entity 디코딩 (&lt;i&gt;X.campestris&lt;/i&gt; → <i>X.campestris</i>)
    let s = str
      .replace(/&lt;/gi, '<')
      .replace(/&gt;/gi, '>')
      .replace(/&quot;/gi, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/gi, '&');

    if (!/<(i|b|em|strong)>/i.test(s)) return null;
    const text = s
      .replace(/<i>([\s\S]*?)<\/i>/gi, '{i|$1}')
      .replace(/<em>([\s\S]*?)<\/em>/gi, '{i|$1}')
      .replace(/<strong>([\s\S]*?)<\/strong>/gi, '{b|$1}')
      .replace(/<b>([\s\S]*?)<\/b>/gi, '{b|$1}');
    return {
      text: text,
      rich: {
        i: { fontStyle: 'italic' },
        b: { fontWeight: 'bold' },
      },
    };
  }

  /**
   * parent 객체의 textField에 HTML 태그가 있으면 ECharts rich 문법으로 치환하고
   * styleField.rich에 italic/bold 정의를 머지한다.
   *
   * ECharts rich.<style>는 외부 textStyle을 자동 상속하지 않으므로,
   * 부모 textStyle의 시각 속성을 명시적으로 복사해서 기울임/볼드만 덮어씌운다.
   */
  function applyRichTextField(parent, textField, styleField) {
    if (!parent || typeof parent !== 'object') return;
    const parsed = parseRichText(parent[textField]);
    if (!parsed) return;
    parent[textField] = parsed.text;
    parent[styleField] = parent[styleField] || {};
    const ps = parent[styleField];

    // 부모 textStyle에서 상속할 시각 속성들
    const INHERIT_KEYS = ['fontFamily', 'fontSize', 'fontWeight', 'color', 'lineHeight', 'textBorderColor', 'textBorderWidth', 'textShadowColor', 'textShadowBlur', 'textShadowOffsetX', 'textShadowOffsetY'];
    const inherited = {};
    INHERIT_KEYS.forEach(function (k) {
      if (ps[k] !== undefined) inherited[k] = ps[k];
    });

    // 각 rich 스타일에 부모 속성 머지 (단, 정의된 italic/bold은 그대로 유지)
    const richBase = {};
    Object.keys(parsed.rich).forEach(function (styleName) {
      richBase[styleName] = Object.assign({}, inherited, parsed.rich[styleName]);
    });

    // 사용자가 이미 정의한 rich가 있으면 그쪽이 우선
    ps.rich = Object.assign(richBase, ps.rich || {});
  }

  /**
   * ECharts option의 title.text / title.subtext / xAxis.name / yAxis.name 에 대해
   * <i>, <em>, <b>, <strong> 태그가 있으면 자동으로 rich text로 변환.
   * (title, xAxis, yAxis가 배열인 경우도 처리)
   */
  function applyRichTextToOption(option) {
    if (!option || typeof option !== 'object') return option;

    const titles = Array.isArray(option.title) ? option.title : option.title ? [option.title] : [];
    titles.forEach(function (t) {
      applyRichTextField(t, 'text', 'textStyle');
      applyRichTextField(t, 'subtext', 'subtextStyle');
    });

    ['xAxis', 'yAxis'].forEach(function (axisKey) {
      var raw = option[axisKey];
      var axes = Array.isArray(raw) ? raw : raw ? [raw] : [];
      axes.forEach(function (ax) {
        applyRichTextField(ax, 'name', 'nameTextStyle');
      });
    });

    return option;
  }

  /**
   * echarts.init을 한 번 래핑하여, 모든 setOption 호출에 대해
   * 자동으로 rich text 파싱을 적용한다. (한 번만 실행됨)
   */
  function patchECharts() {
    if (typeof echarts === 'undefined' || echarts.__richTextPatched) return;
    var _origInit = echarts.init;
    echarts.init = function () {
      var inst = _origInit.apply(this, arguments);
      if (inst && typeof inst.setOption === 'function' && !inst.__richTextPatched) {
        var _setOption = inst.setOption.bind(inst);
        inst.setOption = function (option) {
          var rest = Array.prototype.slice.call(arguments, 1);
          return _setOption.apply(null, [applyRichTextToOption(option)].concat(rest));
        };
        inst.__richTextPatched = true;
      }
      return inst;
    };
    echarts.__richTextPatched = true;
  }

  if (typeof window !== 'undefined') {
    if (typeof echarts !== 'undefined') {
      patchECharts();
    } else {
      window.addEventListener('load', patchECharts);
    }
  }
  // #endregion ECharts Rich Text Auto-Parser

  return {
    parseRichText: parseRichText,
    applyRichTextToOption: applyRichTextToOption,
    openPopup(url, options) {
      const screenWidth = window.screen.availWidth;
      const screenHeight = window.screen.availHeight;

      const left = (screenWidth - options.width) / 2;
      const top = (screenHeight - options.height) / 2;

      const newOptions = [`width=${options.width}`, `height=${options.height}`, `left=${left}`, `top=${top}`, 'resizable=yes', 'scrollbars=yes'].join(',');

      window.open(url, 'popup', newOptions);
    },
    /**
     *
     * @param {String} id
     * @param {Array} data
     * @param {String} unit
     * @param {String} color
     */
    setLineChart(id, data, unit, color) {
      var chartDom = document.querySelector(id);
      if (!chartDom) return;
      var table = $(chartDom).closest('.weather-table')[0];
      if (!table) return;
      $(chartDom).css('width', table.scrollWidth - 296);
      if (!data || !data.length) data = [];

      var myChart = echarts.init(chartDom);
      var option = {
        tooltip: {
          show: false,
        },
        grid: {
          top: 52,
          left: -56,
          right: -56,
          bottom: 0,
        },
        xAxis: {
          type: 'category',
          axisLabel: false,
          boundaryGap: false,
          data: data,
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
          axisLine: {
            onZero: false,
          },
        },
        yAxis: {
          type: 'value',
          min: -8,
          axisLabel: false,
          axisTick: {
            show: false,
          },
          splitLine: {
            show: false,
          },
        },
        series: [
          {
            label: {
              show: true,
              position: 'top',
              offset: [0, -12],
              textStyle: {
                fontFamily: 'Pretendard, sans-serif',
                fontSize: '18',
                color: '#596063',
                fontWeight: '600',
              },
              formatter: function (data) {
                return data.value + unit;
              },
            },
            symbol: 'circle',
            silent: true,
            lineStyle: {
              color: color,
            },
            itemStyle: {
              borderWidth: 3,
              borderColor: color,
              color: color,
            },
            areaStyle: {
              color: new echarts.graphic.LinearGradient(-10, -10, -10, 1, [
                {
                  offset: 0,
                  color: color,
                },
                {
                  offset: 1,
                  color: '#fff',
                },
              ]),
            },
            data: data,
            type: 'line',
          },
        ],
      };
      option && myChart.setOption(option);
    },
    /**
     * Set Spark Chart (대시보드용 미니 sparkline)
     * 축·툴팁·라벨 없이 라인+그라디언트 영역 또는 막대 sparkline 을 그림
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - data: {Number[]} 시계열 값 (필수)
     *   - type: {'line'|'bar'} 차트 타입 (optional, default 'line')
     *   - color: {String} 메인 색상. 팔레트 이름('green', 'blue', 'lightblue' 등) 또는 HEX (optional, default '#39b852')
     *   - smooth: {Boolean} (line) 곡선 스무딩 (optional, default true)
     *   - showArea: {Boolean} (line) 영역 fill 표시 (optional, default true)
     *   - highlightTop: {Number} (bar) 값이 큰 순으로 N개 막대를 진한 색으로 강조 (optional, default 0)
     */
    setSparkChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      // 팔레트 이름 → 디자인 색 (CSS 기본색 'blue'=#0000ff 등으로 그려지지 않도록)
      const namedColorMap = {
        green: '#39b852', blue: '#2863ff', lightblue: '#22b5ff', red: '#f54a4a',
        orange: '#ffa431', cyan: '#37cec6', navy: '#342fe5', indigo: '#a307dd',
        purple: '#7528f0', yellow: '#f0cb00', magenta: '#ff6ff9', gray: '#8b9496',
      };

      const data = (dataSet && Array.isArray(dataSet.data)) ? dataSet.data : [];
      const rawColor = (dataSet && dataSet.color) || '#39b852';
      const color = namedColorMap[rawColor] || rawColor;
      const type = (dataSet && dataSet.type === 'bar') ? 'bar' : 'line';
      const smooth = !(dataSet && dataSet.smooth === false);
      const showArea = !(dataSet && dataSet.showArea === false);
      const highlightTop = (dataSet && Number.isFinite(dataSet.highlightTop))
        ? Math.max(0, Math.floor(dataSet.highlightTop)) : 0;

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const fadeAlpha = (alpha) => (echarts.color && echarts.color.modifyAlpha)
        ? echarts.color.modifyAlpha(color, alpha) : color;

      // 값 기준 상위 N개 인덱스 집합
      const topIdxSet = new Set(
        data
          .map((v, i) => ({ v, i }))
          .sort((a, b) => b.v - a.v)
          .slice(0, highlightTop)
          .map((o) => o.i),
      );

      let series;
      if (type === 'bar') {
        series = {
          type: 'bar',
          data,
          silent: true,
          barCategoryGap: '30%',
          itemStyle: {
            color: (params) => (topIdxSet.has(params.dataIndex)
              ? color : fadeAlpha(0.45)),
            borderRadius: [3, 3, 0, 0],
          },
        };
      } else {
        series = {
          type: 'line',
          data,
          smooth,
          symbol: 'none',
          silent: true,
          lineStyle: { color, width: 2 },
        };
        if (showArea) {
          series.areaStyle = {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: fadeAlpha(0.25) },
              { offset: 1, color: fadeAlpha(0) },
            ]),
          };
        }
      }

      myChart.setOption({
        grid: { left: 0, right: 0, top: 6, bottom: 6, containLabel: false },
        xAxis: {
          type: 'category',
          show: false,
          boundaryGap: type === 'bar',
          data: data.map((_, i) => i),
        },
        yAxis: { type: 'value', show: false, scale: type !== 'bar' },
        series: [series],
      });

      $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
    },
    /**
     * Set Environment Line Chart (환경요소 시계열 미니 차트)
     * 차트 상단에 제목(좌)과 평균값(우)을 표시하고 그 아래 라인 차트를 그림
     * 컨테이너 크기는 호출 측 인라인 스타일(예: style="height:180px")로 지정
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - title: {String} 차트 제목 (예: '외부온도(°C)')
     *   - unit: {String} 평균/툴팁 단위 표기 (optional, default '')
     *   - color: {String} 라인/포인트 색상 (optional, default '#39b852')
     *   - dates: {String[]} X축 날짜 라벨
     *   - values: {Number[]} Y축 값
     *   - decimals: {Number} 평균 소수점 자리수 (optional, default 1)
     */
    setEnvLineChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      const namedColorMap = {
        green: '#39b852', blue: '#2863ff', lightblue: '#22b5ff', red: '#f54a4a',
        orange: '#ffa431', cyan: '#37cec6', navy: '#342fe5', indigo: '#a307dd',
        purple: '#7528f0', yellow: '#f0cb00', magenta: '#ff6ff9', gray: '#8b9496',
      };

      const dates = (dataSet && Array.isArray(dataSet.dates)) ? dataSet.dates : [];
      const values = (dataSet && Array.isArray(dataSet.values)) ? dataSet.values : [];
      const colorKey = (dataSet && dataSet.color) || 'green';
      const color = namedColorMap[colorKey] || colorKey;
      const title = (dataSet && dataSet.title) || '';
      const unit = (dataSet && dataSet.unit) || '';
      const decimals = (dataSet && Number.isFinite(dataSet.decimals)) ? dataSet.decimals : 1;

      const validValues = values.filter((v) => Number.isFinite(v));
      const avg = validValues.length
        ? validValues.reduce((s, v) => s + v, 0) / validValues.length
        : null;
      const avgText = avg !== null ? `평균 ${avg.toFixed(decimals)}` : '';

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const minVal = validValues.length ? Math.min(...validValues) : 0;
      const maxVal = validValues.length ? Math.max(...validValues) : 1;
      const range = (maxVal - minVal) || 1;
      const pad = range * 0.15;
      const yMin = Math.floor(minVal - pad);
      const yMax = Math.ceil(maxVal + pad);

      myChart.setOption({
        title: [
          {
            text: title,
            left: 0,
            top: 0,
            textStyle: { color: '#1d1f20', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 600 },
          },
          {
            text: avgText,
            right: 0,
            top: 4,
            textStyle: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 12, fontWeight: 500 },
          },
        ],
        grid: { left: 24, right: 24, top: 40, bottom: 8, containLabel: true },
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: { color: '#1d1f20', fontFamily: 'Pretendard', fontSize: 12, fontWeight: 500 },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 6px 10px;',
          formatter(params) {
            if (!params || !params.length) return '';
            const p = params[0];
            return `${p.name}<br/>${p.marker}${p.value}${unit}`;
          },
        },
        xAxis: {
          type: 'category',
          data: dates,
          boundaryGap: false,
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          axisTick: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 10,
            fontWeight: 500,
            rotate: 45,
            interval: dates.length > 8 ? Math.floor(dates.length / 5) : 'auto',
          },
        },
        yAxis: {
          type: 'value',
          min: yMin,
          max: yMax,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 10,
            fontWeight: 500,
            formatter(val) {
              return (val === yMin || val === yMax) ? val : '';
            },
          },
        },
        series: [
          {
            type: 'line',
            data: values,
            smooth: false,
            symbol: 'circle',
            symbolSize: 5,
            lineStyle: { color, width: 1.5 },
            itemStyle: { color, borderColor: color },
          },
        ],
      });

      $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
    },
    /**
     * Set Segmented Bar Chart (가로 누적 막대 - 단일 row, 상태 비율 표시)
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - items: [{ value, color, name? }, ...] (필수)
     *   - height: 막대 두께 px (optional, default 8)
     *   - radius: 양 끝 모서리 반경 px (optional, default 4)
     */
    setSegmentedBarChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      const items = (dataSet && Array.isArray(dataSet.items)) ? dataSet.items : [];
      const barHeight = (dataSet && Number.isFinite(dataSet.height)) ? dataSet.height : 8;
      const radius = (dataSet && Number.isFinite(dataSet.radius)) ? dataSet.radius : 4;

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const total = items.reduce((s, it) => s + (Number(it.value) || 0), 0);
      const lastIdx = items.length - 1;

      const series = items.map((item, i) => {
        const isFirst = i === 0;
        const isLast = i === lastIdx;
        let borderRadius;
        if (isFirst && isLast) borderRadius = radius;
        else if (isFirst) borderRadius = [radius, 0, 0, radius];
        else if (isLast) borderRadius = [0, radius, radius, 0];
        else borderRadius = 0;
        return {
          type: 'bar',
          stack: 'total',
          silent: true,
          data: [Number(item.value) || 0],
          barWidth: barHeight,
          itemStyle: { color: item.color, borderRadius },
        };
      });

      myChart.setOption({
        grid: { left: 0, right: 0, top: 0, bottom: 0, containLabel: false },
        xAxis: { type: 'value', show: false, max: total || 1, min: 0 },
        yAxis: { type: 'category', show: false, data: [''] },
        series,
      });

      $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
    },
    /**
     * Set Dashboard Mode (대시보드 AI 질문 / 데이터 현황 전환)
     * - [data-dashboard-mode] 탭의 aria-controls 패널을 토글하고 section[data-mode] 갱신
     * - 숨김 상태에서 init 된 echarts 는 크기가 0 → 재진입 시 window resize 로 재계산
     * - 패널이 보일 때 패널에 'shown.dashboard.panel' 이벤트 발생
     * @param {String} id - section DOM id
     * @param {Object} options
     *   - mode: {'chat'|'stats'} 초기 모드 (optional, default 'chat')
     *   - onChange: {Function} (mode, isFirst) 전환 후 콜백. isFirst = 해당 모드 첫 진입 여부 (optional)
     */
    setDashboardMode(id, options) {
      const section = document.getElementById(id);
      if (!section) return;
      const opts = options || {};
      const tabs = Array.prototype.slice.call(section.querySelectorAll('[data-dashboard-mode]'));
      const indicator = section.querySelector('.switch-indicator');
      const visited = {};

      const getActiveTab = () => tabs.filter((tab) => tab.getAttribute('aria-selected') === 'true')[0];

      const moveIndicator = () => {
        const active = getActiveTab();
        if (!indicator || !active) return;
        indicator.style.width = `${active.offsetWidth}px`;
        indicator.style.transform = `translateX(${active.offsetLeft}px)`;
      };

      const apply = (mode, focus) => {
        if (visited[mode] && section.getAttribute('data-mode') === mode) return;
        let activePanel = null;

        section.setAttribute('data-mode', mode);
        tabs.forEach((tab) => {
          const isActive = tab.getAttribute('data-dashboard-mode') === mode;
          const panel = document.getElementById(tab.getAttribute('aria-controls'));
          tab.setAttribute('aria-selected', String(isActive));
          tab.tabIndex = isActive ? 0 : -1;
          if (panel) panel.hidden = !isActive;
          if (isActive) {
            activePanel = panel;
            if (focus) tab.focus();
          }
        });
        moveIndicator();

        const isFirst = !visited[mode];
        visited[mode] = true;
        // resize 를 먼저: onChange 에서 차트를 다시 init 하는 경우, 이후 resize 가 echarts
        // entrance 애니메이션을 즉시 완료시켜 버리므로 순서를 바꿀 수 없다.
        if (!isFirst) $(window).trigger('resize');
        if (typeof opts.onChange === 'function') opts.onChange(mode, isFirst);
        if (activePanel) $(activePanel).trigger('shown.dashboard.panel', [mode]);
      };

      tabs.forEach((tab, idx) => {
        tab.addEventListener('click', () => apply(tab.getAttribute('data-dashboard-mode')));
        // 좌우 방향키 / Home / End 로 탭 이동
        tab.addEventListener('keydown', (e) => {
          let next = null;
          if (e.key === 'ArrowRight') next = tabs[(idx + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(idx - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (!next) return;
          e.preventDefault();
          apply(next.getAttribute('data-dashboard-mode'), true);
        });
      });

      $(window).off(`resize.${id}`).on(`resize.${id}`, moveIndicator);
      apply(opts.mode === 'stats' ? 'stats' : 'chat');

      // 웹폰트 로드 후 탭 너비가 바뀌므로 다시 계산하고, 이후 전환부터 이동 애니메이션 적용
      const ready = () => {
        moveIndicator();
        requestAnimationFrame(() => indicator && indicator.classList.add('is-ready'));
      };
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(ready);
      else ready();
    },
    setSunburstChart(id, data) {
      var chartDom = document.getElementById(id);
      if (!chartDom) return;
      if (!data || !data.length) data = [];
      var myChart = echarts.init(chartDom);
      var option;

      option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter: (params) => {
            const childrenCount = params.data.children ? params.data.children.length : 0;
            return childrenCount > 0 ? `${params.marker}${params.name}(${childrenCount})` : `${params.marker}${params.name}(${params.value})`;
          },
        },
        series: {
          type: 'sunburst',
          emphasis: {
            focus: 'ancestor',
          },
          data: data,
          radius: [0, '90%'],
          label: {
            rotate: 'radial',
            fontWeight: '500',
            formatter: (params) => {
              const childrenCount = params.data.children ? params.data.children.length : 0;
              return childrenCount > 0 ? `${params.name}(${childrenCount})` : `${params.name}(${params.value})`;
              0;
            },
          },
          levels: [
            {},
            {
              // 상위 (Category) 레벨: 라벨 표시
              label: {
                fontSize: 14,
              },
            },
            {
              // 하위 (Species) 레벨: 라벨 숨김 (툴팁으로 확인)
              label: {
                fontSize: 10,
              },
            },
          ],
        },
      };

      option && myChart.setOption(option);
    },
    setContentEditableInputForIncosheet(rowData, value, editEl) {
      const inputWrap = document.createElement('div');
      inputWrap.className = 'input-wrap contenteditable-wrap';

      const contenteditable = document.createElement('div');
      contenteditable.className = 'contenteditable';
      contenteditable.contentEditable = 'true';
      contenteditable.innerHTML = Utils.getEscapeHtml(value, ['i']);

      editEl.classList.add('sr-only');

      inputWrap.appendChild(contenteditable);
      inputWrap.appendChild(editEl);

      setTimeout(() => {
        contenteditable.focus();
        const selection = window.getSelection();
        if (selection) {
          const range = document.createRange();
          range.selectNodeContents(contenteditable);
          range.collapse(false);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      }, 10);

      return inputWrap;
    },
    getEscapeHtml(text, allowedTags = []) {
      const escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#039;',
      };

      // 허용 태그가 없으면 전체 escape
      if (!allowedTags.length) {
        return text.replace(/[&<>"']/g, (m) => escapeMap[m]);
      }

      // 허용된 태그들 임시 저장
      const savedTags = [];
      let result = text;

      // 허용 태그를 플레이스홀더로 교체
      allowedTags.forEach((tag) => {
        result = result.replace(new RegExp(`<\\/?${tag}[^>]*>`, 'gi'), (match) => {
          savedTags.push(match);
          return `__TAG_${savedTags.length - 1}__`;
        });
      });

      // HTML escape
      result = result.replace(/[&<>"']/g, (m) => escapeMap[m]);

      // 허용 태그 복원
      savedTags.forEach((tag, i) => {
        result = result.replace(`__TAG_${i}__`, tag);
      });

      return result;
    },
    setVideoSwiper(thumbsSwiperId, swiperId) {
      const fnGetDataURL = ($img) => {
        const ext = $img.attr('src').split('.').pop() === 'jpg' ? 'jpeg' : $img.attr('src').split('.').pop();

        // canvas 생성 및 이미지 그리기
        const canvas = document.createElement('canvas');
        canvas.width = $img[0].naturalWidth;
        canvas.height = $img[0].naturalHeight;

        const ctx = canvas.getContext('2d');
        ctx.drawImage($img[0], 0, 0);

        // data URL 얻기
        const dataURL = canvas.toDataURL(`image/${ext}`);

        return dataURL;
      };
      const thumbsSwiper = new Swiper(`#${thumbsSwiperId}`, {
        direction: 'vertical',
        spaceBetween: 12,
        slidesPerView: 6.5,
        freeMode: true,
        watchSlidesProgress: true,
        mousewheel: true,
        scrollbar: {
          el: `#${thumbsSwiperId} .swiper-scrollbar`,
          hide: true,
        },
      });
      const swiper = new Swiper(`#${swiperId}`, {
        spaceBetween: 24,
        pagination: {
          el: `#${swiperId} .swiper-pagination`,
          type: 'fraction',
        },
        thumbs: {
          swiper: thumbsSwiper,
        },
      });

      // 이미지 다운로드
      $(`.btn-img-download[data-target="#${swiperId}"]`).on('click', function () {
        const $img = $(`#${swiperId} .swiper-slide-active`).find('img');
        const ext = $img.attr('src').split('.').pop() === 'jpg' ? 'jpeg' : $img.attr('src').split('.').pop();
        const imgName = $img.attr('title');
        const dataURL = fnGetDataURL($img);
        const a = document.createElement('a');
        a.classList.add('sr-only');
        a.href = dataURL;
        a.download = `${imgName}.${ext}`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      });
      // 전체 이미지 다운로드
      $(`.btn-zip-download[data-target="#${swiperId}"]`).on('click', function () {
        const zip = new JSZip();
        const $imgList = $(`#${swiperId} .swiper-slide img`);
        const zipName = $(this).attr('data-name');

        $imgList.each(function () {
          const base64Data = fnGetDataURL($(this)).split(',')[1];
          const ext = $(this).attr('src').split('.').pop() === 'jpg' ? 'jpeg' : $(this).attr('src').split('.').pop();
          const imgName = `${$(this).attr('title')}.${ext}`;
          zip.file(imgName, base64Data, { base64: true });
        });

        zip.generateAsync({ type: 'blob' }).then((blob) => {
          const a = document.createElement('a');
          a.classList.add('sr-only');
          a.href = URL.createObjectURL(blob);
          a.download = `${zipName}.zip`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      });

      return {
        thumbsSwiper,
        swiper,
      };
    },
    /**
     * Set Image Preview (개체별 영상 프리뷰: 썸네일 + 메인, 원본/분석 결과 전환)
     * 컨테이너 내부: .swiper[thumbsSlider], .swiper(메인), .preview-entity, .preview-caption, .btn-entity-nav[data-dir], .ta-switch-wrap
     * 외부 버튼: .btn-entity-image[data-target="#id"][data-id="개체 아이디"] 클릭 시 해당 개체로 전환
     * @param {String} id 프리뷰 컨테이너 id
     * @param {Object} dataSet { entities: [{ id, caption, images: [{ origin, result }] }] }
     * @returns {Object} { thumbsSwiper, swiper, show(idx), showById(entityId), update(entities) }
     */
    setImagePreview(id, dataSet) {
      const $container = $(`#${id}`);
      if (!$container.length) return null;

      let entities = dataSet.entities || [];
      const $switch = $container.find('.ta-switch-wrap input[type="checkbox"]');
      const thumbsSwiperId = $container.find('.swiper[thumbsSlider]').attr('id');
      const swiperId = $container.find('.swiper').not('[thumbsSlider]').attr('id');
      const { thumbsSwiper, swiper } = Utils.setVideoSwiper(thumbsSwiperId, swiperId);
      let currentIdx = 0;

      // 개체 아이디 (현재/전체)
      const updateLabel = () => {
        const entity = entities[currentIdx];
        if (!entity) return;
        $container.find('.preview-entity').text(`${entity.id} (${swiper.activeIndex + 1}/${entity.images.length})`);
      };
      const show = (idx) => {
        const entity = entities[idx];
        if (!entity) return;
        currentIdx = idx;

        const key = $switch.is(':checked') ? 'result' : 'origin';
        const imgTag = (img, attrs) => `<img src="${img[key]}" data-origin="${img.origin}" data-result="${img.result}" ${attrs} />`;

        thumbsSwiper.removeAllSlides();
        swiper.removeAllSlides();
        thumbsSwiper.appendSlide(entity.images.map((img) => `
          <div class="swiper-slide">
            ${imgTag(img, `alt="${entity.id} 썸네일"`)}
          </div>
        `));
        swiper.appendSlide(entity.images.map((img, i) => `
          <div class="swiper-slide">
            ${imgTag(img, `alt="${entity.id} 영상 ${i + 1}" title="${entity.id}_${i + 1}"`)}
          </div>
        `));
        thumbsSwiper.slideTo(0, 0);
        swiper.slideTo(0, 0);

        $container.find('.preview-caption').text(entity.caption || '');
        updateLabel();
      };
      const showById = (entityId) => {
        const idx = entities.findIndex((e) => e.id === entityId);
        if (idx > -1) show(idx);
      };
      // 개체 목록 교체 (예: 모델 출력 변경 → 순서/캡션 갱신). 보고 있던 개체는 유지
      const update = (nextEntities) => {
        const currentId = entities[currentIdx] && entities[currentIdx].id;
        entities = nextEntities || [];
        const idx = entities.findIndex((e) => e.id === currentId);
        show(idx > -1 ? idx : 0);
      };

      swiper.on('slideChange', updateLabel);

      // 이전/다음 개체
      $container.find('.btn-entity-nav').off('click').on('click', function () {
        const dir = Number($(this).attr('data-dir'));
        show((currentIdx + dir + entities.length) % entities.length);
      });
      // 원본 / 분석 결과 전환
      $switch.off('change').on('change', function () {
        const key = $(this).is(':checked') ? 'result' : 'origin';
        $container.find('.swiper-slide img').each(function () {
          $(this).attr('src', $(this).attr(`data-${key}`));
        });
      });
      // 외부 버튼 (결과 테이블 '영상정보 상세보기') → 해당 개체로 전환 후 프리뷰로 이동
      $(document).off(`click.${id}`).on(`click.${id}`, `.btn-entity-image[data-target="#${id}"]`, function () {
        showById($(this).attr('data-id'));
        $container[0].scrollIntoView({ behavior: 'smooth', block: 'center' });
      });

      show(0);

      return {
        thumbsSwiper,
        swiper,
        show,
        showById,
        update,
      };
    },
    /**
     * Set Analysis Result (영상정보 분석 결과: 모델 1개 서브탭)
     * 분석 결과(result.json)를 그대로 받아 모델 출력 셀렉트·그래프·통계·개체별 영상 프리뷰·결과 테이블을 그림
     * - 모델 등록 데이터 타입(type)과 같은 type 의 outputs 만 사용. 2개 이상이면 '모델 출력' 셀렉트 표시 (초기값 첫 번째)
     * - 그래프 제목·표 열 이름은 outName 이 아니라 타겟 형질명(model.stdOntoNm)
     * - 수치형: 분포도(setDistChart) + 최댓값/최솟값/평균 / 항목형: 막대(setBarChart) + 항목별 유전자원 수 표
     * - 영상 프리뷰: images[indvdSn] 의 base(원본) / overlay(분석 결과, 분석 실패 이미지는 빈 문자열 → 원본)
     * 서브탭 안 마크업: .result-trait, .header-select select, .result-chart(id), .dist-count, .dist-stats,
     *   .count-head, .count-body, .image-preview-container(id), .result-table(id)
     * 숨겨진 탭은 차트 크기를 알 수 없으므로 탭이 보일 때 호출하고, 다시 보일 때는 반환값의 redraw() 호출
     * @param {String} id 모델 서브탭 id
     * @param {Object} dataSet { result: result.json, type: '수치형' | '항목형' }
     * @returns {Object} { redraw }
     */
    setAnalysisResult(id, dataSet) {
      const $container = $(`#${id}`);
      if (!$container.length) return null;

      const { result, type } = dataSet;
      const isNumeric = type === '수치형';
      const trait = result.model.stdOntoNm;
      const outputs = result.outputs.filter((o) => o.type === type);
      const chartId = $container.find('.result-chart').attr('id');
      const previewId = $container.find('.image-preview-container').attr('id');
      const tableId = $container.find('.result-table').attr('id');
      const $select = $container.find('.header-select select');
      let output = outputs[0];
      let preview = null;

      // 값이 없는 개체(이미지 전부 실패·미검출)는 '-' (Incosheet 는 null 을 '' 로 넘김)
      const isEmpty = (v) => v == null || v === '';
      const fmt = (v) => (isEmpty(v) ? '-' : Number(v).toLocaleString('ko-KR', { maximumFractionDigits: 1 }));
      const fmtUnit = (v) => (isEmpty(v) ? '-' : `${fmt(v)}${output.unit || ''}`);

      $container.find('.result-trait').text(trait);
      if (!output) return null;

      // 그래프 + 통계(수치형) / 항목별 유전자원 수 표(항목형)
      const drawChart = () => {
        if (isNumeric) {
          const { max, min, statistic, values } = output.distribution;
          $container.find('.dist-count').text(`(개체 ${fmt(values.length)}개)`);
          $container.find('.dist-stats').html(`
            <span><b class="label max">최댓값</b>${fmtUnit(max && max.value)} · ${max ? max.indvdId : '-'}</span>
            <span><b class="label min">최솟값</b>${fmtUnit(min && min.value)} · ${min ? min.indvdId : '-'}</span>
            <span><b class="label">평균</b>${fmtUnit(statistic && statistic.mean)}</span>
          `);
          // 통계 줄 수에 따라 차트 높이가 바뀌므로 통계를 채운 뒤 그림
          Utils.setDistChart(chartId, { unit: output.unit, ...output.distribution });
          return;
        }
        const { bars, rows } = output;
        Utils.setBarChart(chartId, {
          title: `${trait}(N: ${rows.length})`,
          xLabel: trait,
          yLabel: '유전자원 수',
          data: bars.map((b) => b.value),
          labels: bars.map((b) => b.label),
        });
        $container.find('.count-head').html([trait, ...bars.map((b) => b.label)].map((v) => `<th class="text-center">${v}</th>`).join(''));
        $container.find('.count-body').html(['유전자원 수', ...bars.map((b) => b.value)].map((v) => `<td class="text-center">${v}</td>`).join(''));
      };

      // 개체별 영상 프리뷰 (결과 테이블 순서, 캡션은 선택한 출력 값). 출력 변경 시 보던 개체 유지
      const drawPreview = () => {
        const entities = output.rows.filter((r) => result.images[r.indvdSn]).map((r) => ({
          id: r.indvdId,
          caption: isNumeric
            ? `${trait}: ${fmtUnit(r.value)}`
            : `${trait}: ${r.item} (확률 ${isEmpty(r.prob) ? '-' : r.prob})`,
          images: result.images[r.indvdSn].map((img) => ({ origin: img.base, result: img.overlay || img.base })),
        }));
        if (preview) {
          preview.update(entities);
        } else {
          preview = Utils.setImagePreview(previewId, { entities });
        }
      };

      // 결과 테이블 (출력 변경 시 열 이름·데이터가 바뀌므로 다시 생성)
      const drawTable = () => {
        const numericColumns = [
          {
            title: '순위', field: 'rank', type: 'number', width: 100, textAlign: 'center',
            // 값이 없는 개체는 순위 없이 맨 뒤
            formatter: (rowData, value) => (isEmpty(value) ? '-' : value),
          },
          { title: '개체 아이디', field: 'indvdId', type: 'text', width: 160, textAlign: 'center' },
          {
            title: `${trait}(${output.unit || ''})`, field: 'value', type: 'number', width: 160, textAlign: 'center',
            formatter: (rowData, value) => fmt(value),
          },
        ];
        const categoricalColumns = [
          { title: '개체 아이디', field: 'indvdId', type: 'text', width: 160, textAlign: 'center' },
          // 항목 설명은 모델·result.json 에 없으므로 툴팁은 확률(고정 문구)에만
          { title: trait, field: 'item', type: 'text', width: 140, textAlign: 'center' },
          {
            title: '확률', field: 'prob', type: 'number', width: 140, textAlign: 'center',
            titleFormatter: (colData, value) => {
              return `${value} <i class="material-icons" data-toggle="tooltip" title="개체가 해당 항목으로 판정될 확률을 의미합니다.">info</i>`;
            },
            formatter: (rowData, value) => (isEmpty(value) ? '-' : value),
          },
        ];

        $(`#${tableId}`).empty();
        return new Incosheet({
          'id': tableId,
          'rowHeight': 40,
          'pagination': {
            'currentPage': 1,
            'perPage': 20,
            'size': [20, 50, 100],
            'perGroup': 5,
          },
          'tools': {
            'view': false,
            'download': false,
          },
          'filters': [],
          'params': {},
          'columns': [
            ...(isNumeric ? numericColumns : categoricalColumns),
            {
              title: '영상정보 상세보기', field: 'imageCount', type: 'html', width: 160, textAlign: 'center',
              formatter: (rowData, value) => {
                return `<button type="button" class="btn-text btn-entity-image" data-target="#${previewId}" data-id="${rowData.indvdId}">상세보기 (${value}건)</button>`;
              },
            },
            {
              title: '등록', field: 'push', type: 'html', width: 120, textAlign: 'center',
              formatter: (rowData) => {
                return `<button type="button" class="btn btn-icon btn-text" data-toggle="modal" data-target="#pushModal"><i class="material-icons mr-6">add</i>등록</button>`;
              },
            },
          ],
          'data': output.rows.map((r) => ({ ...r, push: '' })),
        });
      };

      // 모델 출력 셀렉트: 출력이 2개 이상일 때만 표시
      $select.closest('.header-select').toggleClass('d-none', outputs.length < 2);
      $select
        .html(outputs.map((o) => `<option value="${o.outName}">${o.outName}</option>`).join(''))
        .trigger('change.select2')
        .off('change.analysisResult')
        .on('change.analysisResult', function () {
          output = outputs.find((o) => o.outName === $(this).val());
          drawChart();
          drawPreview();
          drawTable();
        });

      drawChart();
      drawPreview();
      drawTable();

      return {
        redraw: drawChart,
      };
    },
    setInputmask() {
      // phone
      $('.inputmask-phone').inputmask({
        mask: '9{8,11}',
        numericInput: false,
        showMaskOnHover: false,
        showMaskOnFocus: false,
        placeholder: '',
        clearIncomplete: true,
      });

      $('.inputmask-numeric').each(function () {
        const min = $(this).attr('data-min');
        const max = $(this).attr('data-max');
        // data-allow-minus: 하한 제한 없이 음수 입력만 허용.
        //  (data-min 은 쓰지 않는다 — inputmask 의 numeric onBeforeMask 가 min 비교를 문자열로 하기 때문에
        //   data-min="-99" 를 주면 "-100.0" < "-99" 가 참이 되어 값이 -99 로 조용히 잘린다)
        const allowMinus = $(this).is('[data-allow-minus]') || (min !== undefined && Number(min) < 0);

        $(this).inputmask({
          alias: 'numeric',
          groupSeparator: ',',
          autoGroup: true,
          digits: 20,
          digitsOptional: true,
          ...(min && {
            min,
          }),
          ...(max && {
            max,
          }),
          rightAlign: false,
          allowMinus,
          showMaskOnFocus: false,
          showMaskOnHover: false,
          placeholder: '',
        });
      });
      $('.inputmask-id').inputmask({
        numericInput: false,
        inputmode: 'numeric',
        mask: '9999999',
        digits: 0,
        digitsOptional: false,
        rightAlign: false,
        allowMinus: false,
        showMaskOnFocus: false,
        showMaskOnHover: false,
        placeholder: '',
      });

      // 공백제거
      $('.inputmask-no-space').on('input', (e) => {
        // 한글 조합 중엔 처리하지 않음
        if (e.isComposing) return;

        // 공백 제거
        if ($(e.target).hasClass('contenteditable')) {
          let value = $(e.target).html();
          let newValue = value.replace(/\s/g, '').replace(/&nbsp;/g, '');

          if (value !== newValue) {
            $(e.target).html(newValue);

            // 커서 제어용 객체 생성
            const range = document.createRange();
            const selection = window.getSelection();

            // contenteditable의 마지막 노드 기준
            range.selectNodeContents($(e.target)[0]);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);
          }
        } else {
          e.target.value = e.target.value.replace(/\s/g, '');
        }
      });

      // 영문만
      $('.inputmask-en').on('input', function () {
        let value = '';
        let newValue = '';

        if ($(this).hasClass('contenteditable')) {
          value = $(this).html();
          newValue = value.replace(/[^a-zA-Z\s~`!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/𝜶𝜷𝜸]/g, '').replaceAll('<div></div>', '<div><br></div>');

          if (value !== newValue) {
            $(this).html(newValue);

            // 커서 제어용 객체 생성
            const range = document.createRange();
            const selection = window.getSelection();

            // contenteditable의 마지막 노드 기준
            range.selectNodeContents($(this)[0]);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);
          }
        } else {
          value = $(this).val();
          newValue = value.replace(/[^a-zA-Z\s~`!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/𝜶𝜷𝜸]/g, '');

          if (value !== newValue) {
            $(this).val(newValue);
          }
        }
      });

      // 국문만
      let isComposing = false;

      $('.inputmask-ko').on('compositionstart', function () {
        isComposing = true;
      });

      $('.inputmask-ko').on('compositionend', function () {
        isComposing = false;
        filterKorean($(this));
      });

      $('.inputmask-ko').on('input', function () {
        if (!isComposing) {
          filterKorean($(this));
        }
      });

      function filterKorean($el) {
        let value = '';
        let newValue = '';

        if ($(this).hasClass('contenteditable')) {
          value = $(el).html();
          newValue = value.replace(/[^a-zA-Z\s~`!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/𝜶𝜷𝜸]/g, '').replaceAll('<div></div>', '<div><br></div>');

          if (value !== newValue) {
            $(el).html(newValue);

            // 커서 제어용 객체 생성
            const range = document.createRange();
            const selection = window.getSelection();

            // contenteditable의 마지막 노드 기준
            range.selectNodeContents($(el)[0]);
            range.collapse(false);

            selection.removeAllRanges();
            selection.addRange(range);
          }
        } else {
          value = $el.val();
          newValue = value.replace(/[^가-힣ㄱ-ㅎㅏ-ㅣ\s~`!@#$%^&*()_\-+={}[\]|\\:;"'<>,.?/𝜶𝜷𝜸]/g, '');

          if (value !== newValue) {
            $(el).val(newValue);
          }
        }
      }
    },
    /**
     * Step move event
     * ex) Utils.goStep('#step_1', '#step_2');
     * @param {String} startId
     * @param {String} targetId
     */
    goStep(startId, targetId) {
      setTimeout(() => {
        if (startId == targetId) {
          return;
        }
        const $container = $(startId).closest('.login-main, .step-main');
        const $containerInner = $(startId).closest('.login-main-inner, .step-main-inner');
        const $currentSectionForm = $(startId).closest('section').parent('form').length > 0 ? $(startId).closest('section').parent('form') : $(startId).closest('section');
        const $currentSection = $(startId).closest('section');
        const $targetForm = $(targetId).parent('form') ? $(targetId).parent() : $(targetId);
        const $target = $(targetId);

        $target.css('display', 'block');
        if ($targetForm.index() > 0) {
          $container.find('h1').css('display', 'none');
        } else {
          $container.find('h1').css('display', 'block');
        }
        if ($targetForm.index() > $currentSectionForm.index()) {
          $containerInner.css('transform', `translateX(-${$container.outerWidth()}px)`);
        } else {
          $containerInner.addClass('no-animate');
          $containerInner.css('transform', `translateX(-${$container.outerWidth()}px)`);
          setTimeout(function () {
            $containerInner.removeClass('no-animate');
            $containerInner.css('transform', 'translateX(0)');
          }, 10);
        }
        setTimeout(function () {
          $containerInner.addClass('no-animate');
          $currentSection.css('display', 'none');
          $containerInner.css('transform', 'translateX(0)');
          setTimeout(function () {
            $containerInner.removeClass('no-animate');
          }, 10);
        }, 300);
      }, 100);
    },
    /**
     * Set  Timer
     * ex) reset => Utils.setCodeTimer('#step_9');, end => Utils.setCodeTimer('#step_9', true);
     * @param {String} targetId
     * @param {Boolean} isEnd
     */
    setCodeTimer(targetId, isEnd) {
      const $target = $(targetId);

      if (global['timer'] != null) clearInterval(global['timer']);

      if (isEnd) {
        $target.find('input').attr('disabled', true);
        $target.find('hr').addClass('d-none');
        $target.find('.hide').removeClass('d-none');
      } else {
        $target.find('.count-container .count').text('3:00');
        Utils.setRefresh();

        $target.find('input').val('').attr('disabled', false);
        $target.find('.count-wrap').removeClass('text-warning');
        $target.find('.custom-invalid-feedback').css('display', 'none');
        $target.find('hr').removeClass('d-none');
        $target.find('.hide').addClass('d-none');

        setTimeout(function () {
          let minute = 3;
          let second = 0;

          $target.find('.number-list input').eq(0).trigger('focus');

          global['timer'] = setInterval(function () {
            if (second == 0) {
              if (minute == 0) {
                clearInterval(global['timer']);
                $target.find('input').attr('disabled', true);
                $target.find('.count-wrap').addClass('text-warning');
                $target.find('.custom-invalid-feedback').css('display', 'block');
              } else {
                minute = minute - 1;
                second = 59;
              }
            } else {
              second--;
            }

            let currentTime = minute + ':' + (second < 10 ? '0' + second : second);
            $target.find('.count-container .count').text(currentTime);
          }, 1000);
        }, 300);
      }
    },
    /**
     * Set Alert for Refresh
     */
    setRefresh() {
      let fnUnload = function (e) {
        e.preventDefault();
        return (e.returnValue = '');
      };
      $(window).on('beforeunload', fnUnload);
    },
    setToastr() {
      toastr.options = {
        closeButton: true,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
        showMethod: 'fadeIn',
        hideMethod: 'fadeOut',
        // progressBar: true,
        hideDuration: 3000,
      };
    },
    /**
     * Set Datepicker
     */
    // setDatepicker() {
    //   let $datepicker = $('.datepicker');
    //   $datepicker.datepicker({
    //     dateFormat: 'yy-mm-dd',
    //     prevText: '이전 달',
    //     nextText: '다음 달',
    //     monthNames: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    //     monthNamesShort: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
    //     dayNames: ['일', '월', '화', '수', '목', '금', '토'],
    //     dayNamesShort: ['일', '월', '화', '수', '목', '금', '토'],
    //     dayNamesMin: ['일', '월', '화', '수', '목', '금', '토'],
    //     showMonthAfterYear: true,
    //   });
    //   $datepicker.each(function () {
    //     new Cleave($(this)[0], {
    //       date: true,
    //       delimiter: '-',
    //       datePattern: ['Y', 'm', 'd']
    //     });
    //     $(this).on('change', function() {
    //       const parts = $(this).val().split('-');

    //       if (parts.length !== 3) return input;

    //       let [year, month, day] = parts;

    //       month = month.padStart(2, '0');
    //       day = day.padStart(2, '0');

    //       $(this).val(`${year}-${month}-${day}`);
    //     });
    //     if ($(this).hasClass('current')) {
    //       $(this).datepicker('setDate', 'today');
    //     }
    //     if ($(this).attr('data-min')) {
    //       if ($(this).attr('data-min') == 'current') {
    //         $(this).datepicker('option', 'minDate', 'today');
    //       } else {
    //         $(this).datepicker('option', 'minDate', $(this).attr('data-min'));
    //       }
    //     }
    //     if ($(this).attr('data-max')) {
    //       if ($(this).attr('data-max') == 'current') {
    //         $(this).datepicker('option', 'maxDate', 'today');
    //       } else {
    //         $(this).datepicker('option', 'maxDate', $(this).attr('data-max'));
    //       }
    //     }
    //   });
    // },
    setDatepicker() {
      let $datepicker = $('.datepicker');
      $datepicker.each(function () {
        new Cleave($(this)[0], {
          date: true,
          delimiter: '-',
          datePattern: ['Y', 'm', 'd'],
        });
        const datepicker = flatpickr($(this)[0], {
          allowInput: true,
          enableTime: false,
          dateFormat: 'Y-m-d',
          locale: {
            weekdays: {
              shorthand: ['일', '월', '화', '수', '목', '금', '토'],
              longhand: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
            },
            months: {
              shorthand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
              longhand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            },
            firstDayOfWeek: 0,
          },
          onChange: function (selectedDates, dateStr, instance) {
            const $el = $(instance.element);
            const $wrap = $el.closest('.ta-date-pair-wrap');
            if ($wrap.length > 0) {
              const isStart = $el.closest('.start').length > 0;
              const $otherInput = isStart ? $wrap.find('.end input') : $wrap.find('.start input');
              const otherInstance = $otherInput[0] ? $otherInput[0]._flatpickr : null;
              const maxRange = $wrap.attr('data-max-range');

              if (otherInstance && selectedDates.length > 0) {
                const selectedDate = selectedDates[0];
                if (isStart) {
                  otherInstance.set('minDate', selectedDate);
                  if (maxRange) {
                    const maxDate = Utils.getDateWithRange(selectedDate, maxRange, true);
                    otherInstance.set('maxDate', maxDate);
                  }
                } else {
                  otherInstance.set('maxDate', selectedDate);
                  if (maxRange) {
                    const minDate = Utils.getDateWithRange(selectedDate, maxRange, false);
                    otherInstance.set('minDate', minDate);
                  }
                }
              }
            }
          },
          onOpen: function (selectedDates, dateStr, instance) {
            const $el = $(instance.element);
            const $wrap = $el.closest('.ta-date-pair-wrap');
            if ($wrap.length > 0) {
              const isStart = $el.closest('.start').length > 0;
              const $otherInput = isStart ? $wrap.find('.end input') : $wrap.find('.start input');
              const otherInstance = $otherInput[0] ? $otherInput[0]._flatpickr : null;
              const maxRange = $wrap.attr('data-max-range');

              if (otherInstance && otherInstance.selectedDates.length > 0) {
                const otherDate = otherInstance.selectedDates[0];
                if (isStart) {
                  instance.set('maxDate', otherDate);
                  if (maxRange) {
                    const minDate = Utils.getDateWithRange(otherDate, maxRange, false);
                    instance.set('minDate', minDate);
                  }
                } else {
                  instance.set('minDate', otherDate);
                  if (maxRange) {
                    const maxDate = Utils.getDateWithRange(otherDate, maxRange, true);
                    instance.set('maxDate', maxDate);
                  }
                }
              }
            }
          },
        });
        if ($(this).hasClass('current')) {
          datepicker.setDate(new Date());
        }
        if ($(this).attr('data-min')) {
          if ($(this).attr('data-min') == 'current') {
            datepicker.set('minDate', new Date());
          } else {
            datepicker.set('minDate', new Date($(this).attr('data-min')));
          }
        }
        if ($(this).attr('data-max')) {
          if ($(this).attr('data-max') == 'current') {
            datepicker.set('maxDate', new Date());
          } else {
            datepicker.set('maxDate', new Date($(this).attr('data-max')));
          }
        }
      });
    },
    setDatetimepicker() {
      let $datetimepicker = $('.datetimepicker');
      $datetimepicker.each(function () {
        new Cleave($(this)[0], {
          delimiters: ['-', '-', ' ', ':', ':'],
          blocks: [4, 2, 2, 2, 2, 2],
          numericOnly: true,
        });
        const datetimepicker = flatpickr($(this)[0], {
          allowInput: true,
          enableTime: true,
          enableSeconds: true,
          time_24hr: true,
          defaultHour: 0,
          defaultMinute: 0,
          defaultSeconds: 0,
          dateFormat: 'Y-m-d H:i:S',
          locale: {
            weekdays: {
              shorthand: ['일', '월', '화', '수', '목', '금', '토'],
              longhand: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
            },
            months: {
              shorthand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
              longhand: ['1월', '2월', '3월', '4월', '5월', '6월', '7월', '8월', '9월', '10월', '11월', '12월'],
            },
            firstDayOfWeek: 0,
          },
          onReady: function (selectedDates, dateStr, instance) {
            // flatpickr selText(focus → .select() → focus) 무한 재귀 방지
            // .select()를 비동기로 실행하여 동기 재귀 루프를 끊음
            [instance.hourElement, instance.minuteElement, instance.secondElement].forEach(function (el) {
              if (!el) return;
              el.select = function () {
                var self = this;
                setTimeout(function () {
                  HTMLInputElement.prototype.select.call(self);
                }, 0);
              };
            });
          },
        });
        if ($(this).hasClass('current')) {
          datetimepicker.setDate(new Date());
        }
        if ($(this).attr('data-min')) {
          if ($(this).attr('data-min') == 'current') {
            datetimepicker.set('minDate', new Date());
          } else {
            datetimepicker.set('minDate', new Date($(this).attr('data-min')));
          }
        }
        if ($(this).attr('data-max')) {
          if ($(this).attr('data-max') == 'current') {
            datetimepicker.set('maxDate', new Date());
          } else {
            datetimepicker.set('maxDate', new Date($(this).attr('data-max')));
          }
        }
      });
    },
    /**
     * Set Validation
     */
    setValidation() {
      let elements = document.querySelectorAll('input, textarea');
      for (let i = 0; i < elements.length; i++) {
        elements[i].oninvalid = function (e) {
          e.target.setCustomValidity(' ');
          if (!e.target.validity.valid) {
            elements[i].classList.add('is-invalid');
          }
        };
        elements[i].oninput = function (e) {
          e.target.setCustomValidity(' ');
        };
        if ($(elements[i]).attr('required')) {
          elements[i].focusout = () => {
            // elements[i].classList.remove('is-valid');
            elements[i].classList.remove('is-invalid');
            if (elements[i].value == null || elements[i].value == '') {
              elements[i].classList.add('is-invalid');
            } else {
              // elements[i].classList.add('is-valid');
            }
          };
        }
      }
    },
    /**
     * Set Select2
     */
    setSelect2() {
      const $select2List = $('select.select2');
      $select2List.each(function () {
        let options = {
          dropdownParent: $(this).closest('.modal-content')[0] ? $(this).closest('.modal-content') : $('body'),
          allowClear: $(this).hasClass('allow-clear'),
          language: {
            noResults: () => {
              if ($(this).attr('data-search-placeholder')) {
                return $(this).attr('data-search-placeholder');
              } else {
                return '검색 결과가 없습니다.';
              }
            },
          },
        };
        $(this).select2(options);

        // mutilple select2 search input default is disabled
        // setTimeout(() => {
        //   if($(this).attr('multiple') == 'multiple') {
        //     const $select2Search = $('.select2-selection--multiple .select2-search');
        //     $select2Search.find('input').attr('disabled', true);
        //   }
        // }, 0);
      });

      $select2List.off('select2:open', onSelect2OpenEvent);
      $select2List.off('select2:select', onSelect2SelectEvent);
      $select2List.on('select2:open', onSelect2OpenEvent);
      $select2List.on('select2:select', onSelect2SelectEvent);
    },
    /**
     * Set Custom Select
     * if Change Select Call setCustomDropdownSelect(id);
     * @param {String} tagId
     */
    setCustomDropdownSelect(tagId = null) {
      const createCustomDropdownSelect = function (el) {
        let $originalSelect = $(el);
        let $originalOptgroupList = $originalSelect.find('optgroup');
        let $originalOptionList = $originalSelect.find('option');
        let placeholder = '선택';
        let isPlaceholder = false;
        if ($(el).parent().find('.custom-dropdown-select').length <= 0) {
          let newSelect = `
          <div class="dropdown custom-dropdown-select">
          <button class="btn dropdown-toggle" type="button" id="${$originalSelect.attr('id')}Dropdown" ${
            $originalSelect.attr('disabled') ? 'tabindex="-1"' : ''
          } data-toggle="dropdown" aria-expanded="false">
          ${placeholder}
          </button>
          <div class="dropdown-menu custom-dropdown-select" aria-labelledby="${$originalSelect.attr('id')}Dropdown">
          `;
          if ($originalOptgroupList.length > 0) {
            for (let i = 0; i < $originalOptgroupList.length; i++) {
              $originalOptionList = $originalOptgroupList.eq(i).find('option');
              newSelect += `
              <div class="dropdown-optgroup">
              <h6>${$originalOptgroupList[i].label}</h6>
              `;
              for (let j = 0; j < $originalOptionList.length; j++) {
                if ($originalOptionList[j].value == '') {
                  isPlaceholder = true;
                  placeholder = $originalOptionList[j].textContent;
                } else {
                  newSelect += `
                  <a href="javascript:void(0)"
                  class="dropdown-item ${$($originalOptionList[j]).prop('selected') ? 'active' : ''}"
                  data-value="${$originalOptionList[j].value}"
                  data-toggle="tooltip" data-placement="bottom"
                  title="${$originalOptionList[j].title}">
                  ${$originalOptionList[j].text}
                  </a>
                  `;
                }
              }
              newSelect += '</div>';
            }
          } else {
            for (let i = 0; i < $originalOptionList.length; i++) {
              if ($originalOptionList[i].value == '') {
                isPlaceholder = true;
                placeholder = $originalOptionList[i].textContent;
              } else {
                newSelect += `
                <a href="javascript:void(0)"
                class="dropdown-item ${$($originalOptionList[i]).prop('selected') ? 'active' : ''}"
                data-toggle="tooltip" data-placement="bottom"
                data-value="${$originalOptionList[i].value}"
                title="${$originalOptionList[i].title}">
                ${$originalOptionList[i].text}</a>
                `;
              }
            }
          }
          newSelect += `
          </div>
          </div>
          `;
          $originalSelect.after(newSelect);
          $originalSelect.next().find('.btn').text(placeholder);

          if ($(el).parent().find('a.dropdown-item.active').length > 0) {
            $('#' + $originalSelect.attr('id') + 'Dropdown').text($(el).parent().find('a.dropdown-item.active').text());
          } else {
            if (isPlaceholder) {
              $(el).parent().find('.custom-dropdown-select').addClass('dropdown-placeholder');
            }
          }
        }
      };
      if (tagId == null) {
        let $customSelect = $('.ta-custom-dropdown-select-wrap select:not(:disabled)');
        $(document).off('click', '.custom-dropdown-select .dropdown-item');
        $(document).on('click', '.custom-dropdown-select .dropdown-item', function () {
          let $this = $(this);
          setTimeout(function () {
            let $originalSelect = $this.parents('.ta-custom-dropdown-select-wrap').find('select');
            let $originalOptionList = $originalSelect.find('option:not([value=""]');
            let $index = $this.parents('.dropdown-menu').find('.dropdown-item').index($this);
            let $btn = $this.parents('.custom-dropdown-select').find('.btn');
            $originalOptionList.eq($index).prop('selected', true);
            $originalSelect.trigger('change');
            $btn.text($this.text());
            $btn.parent().removeClass('dropdown-placeholder');
            $this.parents('.dropdown-menu').find('.dropdown-item').removeClass('active');
            $this.addClass('active');
            $originalSelect.removeClass('is-invalid');
            $originalSelect.closest('div').parent().find('.invalid-feedback').remove();
          }, 0);
        });
        $customSelect.each((index, el) => {
          createCustomDropdownSelect(el);
        });
      } else {
        let $originalSelect = $(`#${tagId}`);
        $originalSelect.parent().find('.custom-dropdown-select').remove();
        createCustomDropdownSelect($(`#${tagId}`)[0]);
      }
    },
    /**
     * p-value 포맷: 소수점 3자리, 4자리부터 지수 표기법
     * ex) 0.01 → "0.010", 0.0001 → "1e-04"
     */
    formatPValue(val) {
      if (val == null) return '-';
      if (val === 0) return '0.000';
      if (Math.abs(val) >= 0.001) return val.toFixed(3);
      const exp = Math.floor(Math.log10(Math.abs(val)));
      const coeff = val / Math.pow(10, exp);
      return `${Math.round(coeff)}e${exp < 0 ? '-' : '+'}${String(Math.abs(exp)).padStart(2, '0')}`;
    },
    /**
     * 큰 배열에서 안전한 min/max (Math.min/max(...arr) 는 ~12만 개 넘으면 V8 스택 오버플로)
     * @param {Array<Number>} arr
     * @returns {{min: Number, max: Number}|null} 빈 배열이면 null
     */
    _safeMinMax(arr) {
      if (!arr || !arr.length) return null;
      let mn = Infinity;
      let mx = -Infinity;
      for (let i = 0; i < arr.length; i++) {
        const v = arr[i];
        if (v < mn) mn = v;
        if (v > mx) mx = v;
      }
      return { min: mn, max: mx };
    },
    /**
     * canvas 기반 텍스트 폭 측정 (한 번 만든 canvas 를 재사용)
     */
    _measureChartTextWidth(text, font) {
      if (!text) return 0;
      const canvas = Utils._measureCanvas || (Utils._measureCanvas = document.createElement('canvas'));
      const ctx = canvas.getContext('2d');
      ctx.font = font;
      return ctx.measureText(text).width;
    },
    /**
     * 공백 유무 + 토큰별 폭 기준으로 ECharts overflow 모드 결정
     * - 공백 없음 → 'breakAll' (한글 단일 어절이라 문자 단위로 끊을 수밖에 없음)
     * - 모든 토큰이 maxWidth 안에 들어옴 → 'break' (공백/구두점 기준 줄바꿈, 자연스러움)
     * - 한 토큰이라도 maxWidth 초과 → 'breakAll' (안 그러면 가로 overflow)
     */
    _chooseOverflowMode(text, maxWidth, font) {
      if (!text || !maxWidth) return 'breakAll';
      if (!/\s/.test(text)) return 'breakAll';
      const tokens = text.split(/\s+/);
      for (let i = 0; i < tokens.length; i++) {
        if (Utils._measureChartTextWidth(tokens[i], font) > maxWidth) return 'breakAll';
      }
      return 'break';
    },
    /**
     * 문자 단위 truncate (breakAll 용)
     */
    _truncateByChar(text, maxWidth, maxLines, font) {
      const safe = Math.max(0, maxWidth - 4);
      const total = Utils._measureChartTextWidth(text, font);
      if (total <= safe * maxLines) return text;
      const ellipsis = '...';
      const ellipsisW = Utils._measureChartTextWidth(ellipsis, font);
      const target = Math.max(0, safe * maxLines - ellipsisW);
      let lo = 0;
      let hi = text.length;
      while (lo < hi) {
        const mid = Math.ceil((lo + hi + 1) / 2);
        if (Utils._measureChartTextWidth(text.slice(0, mid), font) <= target) lo = mid;
        else hi = mid - 1;
      }
      if (lo <= 0) return ellipsis;
      return text.slice(0, lo).replace(/\s+$/, '') + ellipsis;
    },
    /**
     * 단어 단위 truncate (break 용) — 토큰을 그리디하게 줄에 채우고
     * maxLines 초과되는 시점에 마지막 줄을 잘라 '...' 붙임
     */
    _truncateByWord(text, maxWidth, maxLines, font) {
      const safe = Math.max(0, maxWidth - 4);
      const ellipsis = '...';
      const ellipsisW = Utils._measureChartTextWidth(ellipsis, font);
      const parts = text.split(/(\s+)/).filter(function (p) { return p !== ''; });
      const lines = [''];
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i];
        const isSpace = /^\s+$/.test(part);
        const candidate = lines[lines.length - 1] + part;
        if (Utils._measureChartTextWidth(candidate, font) <= safe) {
          lines[lines.length - 1] = candidate;
        } else {
          if (lines.length >= maxLines) {
            // 더 이상 줄을 추가할 수 없음 → 현재 줄 잘라서 ellipsis
            const cur = lines[lines.length - 1];
            const target = Math.max(0, safe - ellipsisW);
            let lo = 0;
            let hi = cur.length;
            while (lo < hi) {
              const mid = Math.ceil((lo + hi + 1) / 2);
              if (Utils._measureChartTextWidth(cur.slice(0, mid), font) <= target) lo = mid;
              else hi = mid - 1;
            }
            lines[lines.length - 1] = cur.slice(0, lo).replace(/\s+$/, '') + ellipsis;
            return lines.join('');
          }
          lines.push(isSpace ? '' : part);
        }
      }
      return lines.join('');
    },
    /**
     * 텍스트가 N줄(maxWidth 기준)을 초과하면 마지막에 '...' 붙여 잘라낸다
     * mode 에 따라 char/word 단위로 자름
     */
    _truncateChartText(text, maxWidth, maxLines, font, mode) {
      if (!text || !maxWidth || !maxLines) return text || '';
      if (mode === 'break') return Utils._truncateByWord(text, maxWidth, maxLines, font);
      return Utils._truncateByChar(text, maxWidth, maxLines, font);
    },
    /**
     * 차트 title echarts option 생성
     * @param {String|Object} title - 문자열 또는 { main, sub }
     *   - String: 단일 줄 title
     *   - { main: '첫째줄', sub: '둘째줄' }: 두 줄 title (sub는 작고 회색)
     * @param {Number} [maxWidth] - 넘기면 main 은 2줄까지 wrap 후 …, sub 는 1줄 후 … 처리
     * @returns {Object|undefined} echarts title option
     */
    buildChartTitle(title, maxWidth) {
      if (!title) return undefined;
      const mainFont = '600 17px Pretendard, sans-serif';
      const subFont = '500 15px Pretendard, sans-serif';
      if (typeof title === 'string') {
        const mode = maxWidth ? Utils._chooseOverflowMode(title, maxWidth, mainFont) : 'breakAll';
        const text = maxWidth ? Utils._truncateChartText(title, maxWidth, 2, mainFont, mode) : title;
        const mainWrap = maxWidth ? { width: maxWidth, overflow: mode } : {};
        return {
          text,
          left: 'center',
          top: 0,
          triggerEvent: !!maxWidth,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 600,
            lineHeight: 24,
            ...mainWrap,
          },
        };
      }
      const mainSrc = title.main || '';
      const subSrc = title.sub || '';
      const mainMode = maxWidth ? Utils._chooseOverflowMode(mainSrc, maxWidth, mainFont) : 'breakAll';
      const subMode = maxWidth ? Utils._chooseOverflowMode(subSrc, maxWidth, subFont) : 'breakAll';
      const mainText = maxWidth ? Utils._truncateChartText(mainSrc, maxWidth, 2, mainFont, mainMode) : mainSrc;
      const subText = maxWidth ? Utils._truncateChartText(subSrc, maxWidth, 1, subFont, subMode) : subSrc;
      const mainWrap = maxWidth ? { width: maxWidth, overflow: mainMode } : {};
      const subWrap = maxWidth ? { width: maxWidth, overflow: subMode } : {};
      return {
        text: mainText,
        subtext: subText,
        left: 'center',
        top: 0,
        triggerEvent: !!maxWidth,
        textStyle: {
          color: '#1d1f20',
          fontFamily: 'Pretendard',
          lineHeight: 24,
          fontSize: 17,
          fontWeight: 600,
          ...mainWrap,
        },
        subtextStyle: {
          color: '#79828d',
          fontFamily: 'Pretendard',
          fontSize: 15,
          fontWeight: 500,
          lineHeight: 20,
          ...subWrap,
        },
        itemGap: 4,
      };
    },
    /**
     * HTML title div 생성 (setPairPlotChart, setCrossPairPlotChart용)
     * @param {String|Object} title
     * @param {Number} [maxWidth] - 넘기면 main 2줄/sub 1줄 line-clamp + hover full text 적용
     * @returns {HTMLElement|null}
     */
    buildChartTitleHtml(title, maxWidth) {
      if (!title) return null;
      const escAttr = (s) =>
        String(s == null ? '' : s)
          .replace(/&/g, '&amp;')
          .replace(/"/g, '&quot;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
      const widthCss = maxWidth ? `max-width:${maxWidth}px; margin:0 auto;` : '';
      const clampMain =
        'display:-webkit-box; -webkit-line-clamp:2; -webkit-box-orient:vertical; overflow:hidden; word-break:break-all; line-height:1.3;';
      const clampSub =
        'display:-webkit-box; -webkit-line-clamp:1; -webkit-box-orient:vertical; overflow:hidden; word-break:break-all; line-height:1.3;';
      const el = document.createElement('div');
      el.style.cssText = 'text-align:center; padding:8px 0;';
      if (typeof title === 'string') {
        el.innerHTML = `<div title="${escAttr(title)}" style="color:#1d1f20; font-family:Pretendard; font-size:17px; font-weight:600; ${widthCss} ${clampMain}">${title}</div>`;
      } else {
        const m = title.main || '';
        const s = title.sub || '';
        el.innerHTML =
          `<div title="${escAttr(m)}" style="color:#1d1f20; font-family:Pretendard; font-size:17px; font-weight:600; ${widthCss} ${clampMain}">${m}</div>` +
          `<div title="${escAttr(s)}" style="color:#79828d; font-family:Pretendard; font-size:14px; font-weight:500; ${widthCss} ${clampSub}">${s}</div>`;
      }
      return el;
    },
    /**
     * title 유무에 따른 grid top 계산
     * main 은 최대 2줄까지 wrap 가능하다는 전제로 여유 공간 확보
     * @param {String|Object|undefined} title
     * @param {Number} base - title 없을 때 기본값
     * @returns {Number}
     */
    chartTitleTop(title, base) {
      if (!title) return base;
      // main 2줄(48) + 약간의 padding
      if (typeof title === 'object' && title.sub) return base + 80; // main 2줄 + itemGap + sub 1줄 + padding
      return base + 54;
    },
    /**
     * 차트 컨테이너 resize 시 title 폭을 다시 계산해서 setOption 으로 반영
     * 호출부에서 myChart.setOption(option) 직후 1회 호출하면 됨
     * @param {ECharts} myChart - echarts.init() 반환 인스턴스
     * @param {HTMLElement} chartDom - 차트 컨테이너
     * @param {String|Object|undefined} title
     * @param {Number} [padding] - 양옆 여백 (기본 32)
     */
    attachChartTitleResize(myChart, chartDom, title, padding = 32) {
      if (!myChart || !chartDom || !title) return;
      if (typeof ResizeObserver === 'undefined') return;
      // 기존 옵저버가 있으면 정리
      if (chartDom.__titleResizeObserver) {
        chartDom.__titleResizeObserver.disconnect();
      }
      const ro = new ResizeObserver(() => {
        if (!myChart || (typeof myChart.isDisposed === 'function' && myChart.isDisposed())) {
          ro.disconnect();
          return;
        }
        const w = Math.max(0, (chartDom.clientWidth || 0) - padding);
        if (!w) return;
        myChart.setOption({ title: Utils.buildChartTitle(title, w) });
      });
      ro.observe(chartDom);
      chartDom.__titleResizeObserver = ro;
    },
    /**
     * X축 category 라벨이 슬롯 폭을 넘으면 15도 단계로 회전(-30 → -45 → -60 → -75 → -90).
     * 음수 각도(시계방향)로 회전하여 라벨이 우측 아래로 기울어짐.
     * - 모든 라벨 강제 표시(interval: 0)
     * - 회전 시 grid.bottom / xAxis.nameGap 자동 보정
     * @param {Object} params
     *   - categories: {Array<String>} 카테고리 라벨
     *   - chartWidth: {Number} 차트 컨테이너 가로 px
     *   - gridLeft: {Number} grid.left (default 80)
     *   - gridRight: {Number} grid.right (default 30)
     *   - fontSize: {Number} 라벨 폰트 크기 (default 14)
     *   - fontWeight: {Number|String} (default 500)
     *   - fontFamily: {String} (default 'Pretendard')
     *   - baseBottom: {Number} grid.bottom 기본값 (default 80)
     *   - baseNameGap: {Number} xAxis.nameGap 기본값. >0 이면 회전 시 nameGap 도 같이 키움 (default 0 = 적용 안 함)
     *   - stages: {Array<Number>} 회전 단계 (default [-30, -45, -60, -75, -90])
     * @returns {Object} { rotate, interval, bottom, nameGap }
     */
    computeCategoryAxisFit(params) {
      const opts = params || {};
      const categories = Array.isArray(opts.categories) ? opts.categories : [];
      const chartWidth = Number(opts.chartWidth) || 0;
      const gridLeft = Number.isFinite(opts.gridLeft) ? opts.gridLeft : 80;
      const gridRight = Number.isFinite(opts.gridRight) ? opts.gridRight : 30;
      const fontSize = Number.isFinite(opts.fontSize) ? opts.fontSize : 14;
      const fontWeight = opts.fontWeight != null ? opts.fontWeight : 500;
      const fontFamily = opts.fontFamily || 'Pretendard';
      const baseBottom = Number.isFinite(opts.baseBottom) ? opts.baseBottom : 80;
      const baseNameGap = Number.isFinite(opts.baseNameGap) ? opts.baseNameGap : 0;
      const stages = Array.isArray(opts.stages) && opts.stages.length ? opts.stages : [-30, -45, -60, -75, -90];

      const result = (rotate, extra) => ({
        rotate,
        interval: 0,
        bottom: baseBottom + extra,
        nameGap: baseNameGap > 0 ? baseNameGap + extra : baseNameGap,
      });

      if (!categories.length || chartWidth <= 0) return result(0, 0);

      const font = `${fontWeight} ${fontSize}px ${fontFamily}, sans-serif`;
      const plot = Math.max(0, chartWidth - gridLeft - gridRight);
      const slot = plot / categories.length;

      let maxLabel = 0;
      for (let i = 0; i < categories.length; i++) {
        const txt = categories[i] == null ? '' : String(categories[i]);
        const w = Utils._measureChartTextWidth(txt, font);
        if (w > maxLabel) maxLabel = w;
      }
      const padding = 8; // 라벨 간 여백
      const usable = Math.max(0, slot - padding);
      if (maxLabel <= usable) return result(0, 0);

      let rotate = stages[stages.length - 1];
      for (let i = 0; i < stages.length; i++) {
        const r = stages[i];
        const cos = Math.abs(Math.cos((r * Math.PI) / 180));
        if (maxLabel * cos <= usable) {
          rotate = r;
          break;
        }
      }
      const sin = Math.abs(Math.sin((rotate * Math.PI) / 180));
      const labelHeight = Math.ceil(maxLabel * sin);
      const baseHeight = Math.ceil(fontSize * 1.4);
      const extra = Math.max(0, labelHeight - baseHeight);
      return result(rotate, extra);
    },
    /**
     * X축 category 라벨 회전 적용 + resize 시 자동 재계산.
     * 호출부에서 myChart.setOption(option) 직후 1회 호출.
     * @param {ECharts} myChart
     * @param {HTMLElement} chartDom
     * @param {Object} opts - computeCategoryAxisFit 와 동일 (categories 필수)
     */
    attachCategoryAxisFit(myChart, chartDom, opts) {
      if (!myChart || !chartDom) return;
      const o = opts || {};
      const useNameGap = Number.isFinite(o.baseNameGap) && o.baseNameGap > 0;

      const apply = () => {
        if (!myChart || (typeof myChart.isDisposed === 'function' && myChart.isDisposed())) return;
        const w = chartDom.clientWidth || 0;
        if (!w) return;
        const fit = Utils.computeCategoryAxisFit(Object.assign({}, o, { chartWidth: w }));
        const xAxisPatch = { axisLabel: { rotate: fit.rotate, interval: fit.interval } };
        if (useNameGap) xAxisPatch.nameGap = fit.nameGap;
        myChart.setOption({
          xAxis: xAxisPatch,
          grid: { bottom: fit.bottom },
        });
      };
      apply();

      if (typeof ResizeObserver === 'undefined') return;
      if (chartDom.__categoryAxisFitObserver) chartDom.__categoryAxisFitObserver.disconnect();
      const ro = new ResizeObserver(() => {
        if (!myChart || (typeof myChart.isDisposed === 'function' && myChart.isDisposed())) {
          ro.disconnect();
          return;
        }
        apply();
      });
      ro.observe(chartDom);
      chartDom.__categoryAxisFitObserver = ro;
    },
    /**
     * y축 value 라벨 폭을 측정해 nameGap 을 동적으로 보정 → 회전·가운데 y축 타이틀이
     * 라벨과 겹치지 않게 함. 라벨이 넓어지면 nameGap 과 grid.left 를 함께 키운다.
     * (x축 attachCategoryAxisFit 과 동일하게 myChart.setOption(option) 직후 1회 호출)
     * - axis.getViewLabels() 로 실제 렌더된 틱 문자열을 읽어 측정(formatter/interval 반영)
     * - 라벨/타이틀 폰트·margin·기준 nameGap·grid.left 는 차트 모델에서 직접 읽음
     * - 라벨이 좁으면 기준 nameGap(예: 56) 아래로는 줄이지 않음(다른 차트와 시각적 일관)
     * @param {ECharts} myChart
     * @param {HTMLElement} chartDom
     * @param {Object} [opts]
     *   - yAxisIndex: {Number} 대상 y축 인덱스 (default 0)
     *   - extra: {Number} 라벨과 타이틀 사이 추가 여백 px (default 6)
     *   - baseGridLeft: {Number} 모델에서 grid.left 를 못 읽을 때 하한 (default 80)
     */
    attachValueAxisNameFit(myChart, chartDom, opts) {
      if (!myChart || !chartDom) return;
      const o = opts || {};
      const yAxisIndex = Number.isFinite(o.yAxisIndex) ? o.yAxisIndex : 0;
      const extra = Number.isFinite(o.extra) ? o.extra : 6;
      const isDead = () => typeof myChart.isDisposed === 'function' && myChart.isDisposed();

      const apply = () => {
        if (isDead()) return;
        let model, axisModel, axis;
        try {
          model = myChart.getModel();
          axisModel = model && model.getComponent('yAxis', yAxisIndex);
          axis = axisModel && axisModel.axis;
        } catch (e) {
          return;
        }
        // name 이 없거나 getViewLabels 미지원이면 보정 불필요
        if (!axis || typeof axis.getViewLabels !== 'function') return;
        if (!axisModel.get('name')) return;

        // 보정 전 원본 nameGap / grid.left 를 1회 캡처(리사이즈 시 누적 방지)
        const store = chartDom.__valueAxisNameFit || (chartDom.__valueAxisNameFit = {});
        if (store.baseNameGap == null) {
          const ng = axisModel.get('nameGap');
          store.baseNameGap = Number.isFinite(ng) ? ng : 56;
        }
        if (store.baseGridLeft == null) {
          let gl;
          try { gl = model.getComponent('grid', 0).get('left'); } catch (e) {}
          store.baseGridLeft = Number.isFinite(gl) ? gl : (Number.isFinite(o.baseGridLeft) ? o.baseGridLeft : 80);
        }

        // 라벨 폰트/여백을 모델에서 그대로 읽어 측정 정확도 확보
        const labelModel = axisModel.getModel('axisLabel');
        const fontSize = labelModel.get('fontSize') || 14;
        const fontWeight = labelModel.get('fontWeight') || 'normal';
        const fontFamily = labelModel.get('fontFamily') || 'Pretendard';
        const mg = labelModel.get('margin');
        const margin = Number.isFinite(mg) ? mg : 8;
        const font = `${fontWeight} ${fontSize}px ${fontFamily}, sans-serif`;

        const labels = axis.getViewLabels() || [];
        if (!labels.length) return;
        let maxLabel = 0;
        for (let i = 0; i < labels.length; i++) {
          const e = labels[i];
          const txt = e == null
            ? ''
            : (typeof e === 'string'
              ? e
              : (e.formattedLabel != null
                ? String(e.formattedLabel)
                : (e.rawLabel != null ? String(e.rawLabel) : '')));
          const w = Utils._measureChartTextWidth(txt, font);
          if (w > maxLabel) maxLabel = w;
        }

        const nameFontSize = axisModel.getModel('nameTextStyle').get('fontSize') || 14;
        // 회전한 타이틀의 가로 절반 폭. 회전 텍스트의 가로 폭은 폰트 라인하이트(≈fontSize*1.4)에
        // 가까우므로 fontSize/2 가 아니라 fontSize*0.7 로 잡아야 잘림/겹침을 막을 수 있다.
        const half = Math.ceil(nameFontSize * 0.7);

        // 라벨폭 + 라벨margin + 타이틀 절반폭 + 여백 만큼 띄움(기준값 미만으로는 안 줄임)
        const nameGap = Math.max(store.baseNameGap, Math.ceil(maxLabel + margin + half + extra));
        // 타이틀이 좌측 컨테이너 밖으로 잘리지 않도록 grid.left 보정
        // (타이틀 중심 = grid.left - nameGap 이므로, 왼쪽 여백 = gridLeft-nameGap-half = 아래 상수)
        const gridLeft = Math.max(store.baseGridLeft, Math.ceil(nameGap + half + 12));

        // 값이 그대로면 setOption 생략(무한 루프 방지)
        if (store.nameGap === nameGap && store.gridLeft === gridLeft) return;
        store.nameGap = nameGap;
        store.gridLeft = gridLeft;

        const yAxisPatch = [];
        for (let i = 0; i <= yAxisIndex; i++) yAxisPatch.push(i === yAxisIndex ? { nameGap } : {});
        myChart.setOption({ yAxis: yAxisPatch, grid: { left: gridLeft } });
      };

      apply();

      if (typeof ResizeObserver === 'undefined') return;
      if (chartDom.__valueAxisNameFitObserver) chartDom.__valueAxisNameFitObserver.disconnect();
      const ro = new ResizeObserver(() => {
        if (isDead()) {
          ro.disconnect();
          return;
        }
        apply();
      });
      ro.observe(chartDom);
      chartDom.__valueAxisNameFitObserver = ro;
    },
    /**
     * value/time x축 라벨이 겹치면 회전시키는 보정. category 축의 attachCategoryAxisFit 과
     * 동일한 UX(라벨 기울임 + grid.bottom / xAxis.nameGap 자동 보정)를 value/time 축에도 일괄 적용.
     * - category 축은 categories 배열이 있지만 value/time 축은 자동 생성 숫자/시간 라벨이므로
     *   axis.getViewLabels() 로 실제 렌더된 라벨을 읽어 computeCategoryAxisFit 에 넘긴다.
     * - 회전할 때만 interval:0(전부 표시), 회전이 필요 없으면 interval:'auto'(겹치면 ECharts 가 솎음)
     * - myChart.setOption(option) 직후 1회 호출 (attachCategoryAxisFit 과 동일)
     * @param {ECharts} myChart
     * @param {HTMLElement} chartDom
     * @param {Object} [opts]
     *   - xAxisIndex: {Number} 대상 x축 인덱스 (default 0)
     *   - stages: {Array<Number>} 회전 단계 (computeCategoryAxisFit 기본값 사용)
     */
    attachValueAxisXFit(myChart, chartDom, opts) {
      if (!myChart || !chartDom) return;
      const o = opts || {};
      const xAxisIndex = Number.isFinite(o.xAxisIndex) ? o.xAxisIndex : 0;
      const isDead = () => typeof myChart.isDisposed === 'function' && myChart.isDisposed();

      const apply = () => {
        if (isDead()) return;
        const w = chartDom.clientWidth || 0;
        if (!w) return;
        let model, axisModel, axis;
        try {
          model = myChart.getModel();
          axisModel = model && model.getComponent('xAxis', xAxisIndex);
          axis = axisModel && axisModel.axis;
        } catch (e) {
          return;
        }
        if (!axis || typeof axis.getViewLabels !== 'function') return;

        // 기준 grid/nameGap 1회 캡처(리사이즈 시 누적 방지)
        const store = chartDom.__valueAxisXFit || (chartDom.__valueAxisXFit = {});
        const readGrid = (key, fallback) => {
          let v;
          try { v = model.getComponent('grid', 0).get(key); } catch (e) {}
          return Number.isFinite(v) ? v : fallback;
        };
        if (store.baseBottom == null) store.baseBottom = readGrid('bottom', 80);
        if (store.baseGridLeft == null) store.baseGridLeft = readGrid('left', 80);
        if (store.baseGridRight == null) store.baseGridRight = readGrid('right', 30);
        if (store.baseNameGap == null) {
          const ng = axisModel.get('name') ? axisModel.get('nameGap') : 0;
          store.baseNameGap = Number.isFinite(ng) ? ng : 0;
        }

        const labelModel = axisModel.getModel('axisLabel');
        const fontSize = labelModel.get('fontSize') || 14;
        const fontWeight = labelModel.get('fontWeight') || 500;
        const fontFamily = labelModel.get('fontFamily') || 'Pretendard';

        const labels = (axis.getViewLabels() || []).map((e) =>
          e == null
            ? ''
            : (typeof e === 'string'
              ? e
              : (e.formattedLabel != null
                ? String(e.formattedLabel)
                : (e.rawLabel != null ? String(e.rawLabel) : ''))));
        if (!labels.length) return;

        const fit = Utils.computeCategoryAxisFit({
          categories: labels,
          chartWidth: w,
          gridLeft: store.baseGridLeft,
          gridRight: store.baseGridRight,
          fontSize,
          fontWeight,
          fontFamily,
          baseBottom: store.baseBottom,
          baseNameGap: store.baseNameGap,
          stages: o.stages,
        });

        // 값이 그대로면 setOption 생략(무한 루프 방지)
        if (store.rotate === fit.rotate && store.bottom === fit.bottom && store.nameGap === fit.nameGap) return;
        store.rotate = fit.rotate;
        store.bottom = fit.bottom;
        store.nameGap = fit.nameGap;

        // 회전할 때만 모든 라벨 강제 표시, 아니면 ECharts 자동 솎음에 맡김
        const interval = fit.rotate !== 0 ? 0 : 'auto';
        const xAxisPatch = [];
        for (let i = 0; i <= xAxisIndex; i++) {
          if (i !== xAxisIndex) {
            xAxisPatch.push({});
            continue;
          }
          const patch = { axisLabel: { rotate: fit.rotate, interval } };
          if (store.baseNameGap > 0) patch.nameGap = fit.nameGap;
          xAxisPatch.push(patch);
        }
        myChart.setOption({ xAxis: xAxisPatch, grid: { bottom: fit.bottom } });
      };

      apply();

      if (typeof ResizeObserver === 'undefined') return;
      if (chartDom.__valueAxisXFitObserver) chartDom.__valueAxisXFitObserver.disconnect();
      const ro = new ResizeObserver(() => {
        if (isDead()) {
          ro.disconnect();
          return;
        }
        apply();
      });
      ro.observe(chartDom);
      chartDom.__valueAxisXFitObserver = ro;
    },
    /**
     * Get Global Variable
     */
    getGlobal() {
      return global;
    },
    /**
     * Get CSS Breakpoint
     */
    getBreakpoint() {
      let breakpoint = getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content');
      breakpoint = breakpoint.replaceAll('"', '');
      return breakpoint;
    },
    /**
     * Get input[type=file] detail
     * @param {Element} elmnt
     * @returns {Object}
     */
    getFileDetail(file, isUsefirstDot = false) {
      // 파일 전체명
      let originalFileName = file.name;
      //파일확장자 앞 .의 index
      let dot = isUsefirstDot ? originalFileName.indexOf('.') : originalFileName.lastIndexOf('.');
      //파일명 : .으로 나눈 앞부분
      let fileName = originalFileName.substring(0, dot);
      //파일 확장자 : .으로 나눈 뒷부분
      let fileExt = originalFileName.substring(dot + 1, originalFileName.length).toLowerCase();
      //파일 크기
      let fileSize = file.size;

      let object = {
        originalName: originalFileName,
        name: fileName,
        ext: fileExt,
        size: fileSize,
      };

      return object;
    },
    /**
     * Start Loading
     */
    startLoading() {
      let wrapElmnt = document.querySelector('.spinner-wrap');

      if (wrapElmnt) {
        wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) + 1;
      } else {
        wrapElmnt = document.createElement('div');
        wrapElmnt.classList.add('spinner-wrap');
        wrapElmnt.dataset.task = 1;
        let loadingElmnt = document.createElement('div');
        loadingElmnt.classList.add('spinner-border');
        let span = document.createElement('span');
        span.classList.add('sr-only');
        span.innerHTML = 'Loading...';
        loadingElmnt.appendChild(span);
        wrapElmnt.appendChild(loadingElmnt);

        let body = document.getElementsByTagName('body')[0];
        body.appendChild(wrapElmnt);
      }
    },
    /**
     * End Loading
     */
    endLoading() {
      setTimeout(function () {
        let wrapElmnt = document.querySelector('.spinner-wrap');

        if (wrapElmnt) {
          let taskCount = wrapElmnt.dataset.task;

          if (taskCount > 1) {
            wrapElmnt.dataset.task = Number(wrapElmnt.dataset.task) - 1;
          } else {
            wrapElmnt.style.opacity = 0;
            setTimeout(function () {
              wrapElmnt.remove();
            }, 300);
            let body = document.getElementsByTagName('body')[0];
          }
        }
      }, 300);
    },
    /**
     * Number to KRW format
     * ex) 1000000 -> 1,000,000
     * @param {Number} value
     * @returns {String}
     */
    numberFormatter(value) {
      if (value != '' && value != null && typeof value == 'number') {
        value = String(value)
          .replace(/[^\d]+/g, '')
          .replace(/(^0+)/, '')
          .replace(/(\d)(?=(?:\d{3})+(?!\d))/g, '$1,');
      } else {
        value = 0;
      }
      return value === '' ? 'NaN' : value;
    },
    /**
     * Byte to size
     * return ex) 5 GB
     * @param {Number} byte
     * @returns {String}
     */
    byteFormatter(byte) {
      let sizes = ['Byte', 'KB', 'MB', 'GB', 'TB'];
      if (byte == 0) return '0Byte';
      let i = parseInt(Math.floor(Math.log(byte) / Math.log(1024)));
      return Math.round(byte / Math.pow(1024, i), 2) + sizes[i];
    },
    /**
     * Set date format
     * @param {String} date
     * @returns {Object}
     */
    dateFormatter(date) {
      if ((date == '' || date == null) && typeof date == 'string') {
        return '';
      }
      const addZero = (num, digits) => {
        var zero = '';
        num = num.toString();

        if (num.length < digits) {
          for (var i = 0; i < digits - num.length; i++) {
            zero += '0';
          }
        }
        return zero + num;
      };

      let newDate;
      if (date instanceof Date) {
        newDate = date;
      } else if (typeof date === 'string') {
        // Safari Invalid Date 로 인한 replace
        let dateStr = date;
        // 밀리초 형태 제거 (.123 또는 .123Z)
        dateStr = dateStr.replace(/\.\d{1,3}(Z)?$/i, '');
        
        if (dateStr.includes('.')) {
          // 끝에 있는 점 제거 (ex: 2026. 2. 25.)
          dateStr = dateStr.replace(/\.$/, '');
          // 점을 슬래시로 변환 (ex: 2026. 2. 25 -> 2026/2/25)
          dateStr = dateStr.replace(/\.\s*/g, '/');
          
          if (dateStr.includes('오후')) {
            dateStr = dateStr.replace(/\/오후\s*/, ' ');
            dateStr = dateStr.replace(/ (\d{1,2}):/, (match, p1) => {
              let h = parseInt(p1);
              if (h < 12) h += 12;
              return ` ${h}:`;
            });
          } else if (dateStr.includes('오전')) {
            dateStr = dateStr.replace(/\/오전\s*/, ' ');
            dateStr = dateStr.replace(/ (\d{1,2}):/, (match, p1) => {
              let h = parseInt(p1);
              if (h === 12) h = 0;
              return ` ${h}:`;
            });
          } else {
            // 시간 앞의 슬래시를 공백으로 변환 (ex: 2026/2/25/15:46:38 -> 2026/2/25 15:46:38)
            dateStr = dateStr.replace(/\/(\d{1,2}:\d{1,2})/, ' $1');
          }
        }
        dateStr = dateStr.replace(/-/g, '/').replace('T', ' ');
        newDate = new Date(dateStr);
      } else {
        newDate = new Date(date);
      }

      const yyyy = newDate.getFullYear();
      const mm = addZero(newDate.getMonth() + 1, 2);
      const m = newDate.getMonth() + 1;
      const dd = addZero(newDate.getDate(), 2);
      const d = newDate.getDate();

      const object = {
        slash: yyyy + '/' + mm + '/' + dd,
        dot: yyyy + '.' + mm + '.' + dd,
        dash: yyyy + '-' + mm + '-' + dd,
        word: yyyy + '년 ' + m + '월 ' + d + '일',
      };

      return object;
    },
    /**
     * Set Area Chart
     * @param {String} id
     * @param {String} title
     * @param {Array} data // [[dateString|date, number], ...]
     */
    setAreaChart(id, title, data) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // Ensure minimum axis range even with empty data
      const hasData = data && data.length > 0;

      // 하단 그룹 라벨(월/연도)을 축 아래 2단으로 그리므로 여유 있는 bottom 확보
      const gridBottom = 80;

      const formattedData = (data || [])
        .map(item => [new Date(item[0]).getTime(), item[1]])
        .filter(item => Number.isFinite(item[0]) && item[1] !== undefined && item[1] !== null)
        .sort((a, b) => a[0] - b[0]);

      // 데이터가 없을 때 기본 시간 범위 설정
      const now = new Date().getTime();
      const oneDay = 24 * 60 * 60 * 1000;

      const firstTime = formattedData.length > 0 ? formattedData[0][0] : now - 30 * oneDay;
      const lastTime = formattedData.length > 0 ? formattedData[formattedData.length - 1][0] : now;
      const oneMonthApprox = 30 * oneDay;
      const oneYearApprox = 365.25 * oneDay;
      const diffMs = lastTime - firstTime;

      // ---------------------------------------------------------------------------
      // labelMode
      // - < 1개월: day
      // - >= 1년: year
      // - else: month
      // ---------------------------------------------------------------------------
      let labelMode = 'month';
      if (diffMs < oneMonthApprox) labelMode = 'day';
      else if (diffMs >= oneYearApprox) labelMode = 'year';

      // ---------------------------------------------------------------------------
      // utils
      // ---------------------------------------------------------------------------
      const pad2 = n => String(n).padStart(2, '0');

      const formatYMD = t => {
        const d = new Date(t);
        return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      };

      // 지정한 단위(month/year)의 구간을 [firstTime, lastTime] 범위 안에서 만들고,
      // 각 구간의 (보이는 영역) 중앙 좌표와 라벨을 반환한다.
      const buildUnitSegments = (unit) => {
        const segments = [];
        const firstDate = new Date(firstTime);
        const lastDate = new Date(lastTime);

        if (unit === 'year') {
          const startYear = firstDate.getFullYear();
          const endYear = lastDate.getFullYear();

          for (let y = startYear; y <= endYear; y += 1) {
            const start = new Date(y, 0, 1).getTime();
            const end = new Date(y, 11, 31, 23, 59, 59).getTime();
            const visibleStart = Math.max(start, firstTime);
            const visibleEnd = Math.min(end, lastTime);

            if (visibleStart <= visibleEnd) {
              segments.push({ center: (visibleStart + visibleEnd) / 2, start: visibleStart, label: `${y}` });
            }
          }
          return segments;
        }

        // unit === 'month'
        const temp = new Date(firstDate.getFullYear(), firstDate.getMonth(), 1);
        while (temp <= lastDate) {
          const start = new Date(temp.getFullYear(), temp.getMonth(), 1).getTime();
          const end = new Date(temp.getFullYear(), temp.getMonth() + 1, 0, 23, 59, 59).getTime();
          const visibleStart = Math.max(start, firstTime);
          const visibleEnd = Math.min(end, lastTime);

          if (visibleStart <= visibleEnd) {
            segments.push({ center: (visibleStart + visibleEnd) / 2, start: visibleStart, year: temp.getFullYear(), label: `${temp.getMonth() + 1}월` });
          }
          temp.setMonth(temp.getMonth() + 1);
        }
        return segments;
      };

      // labelMode 별 라벨 단 구성 (위 → 아래 순서)
      // - 모든 라벨은 컬럼 중앙(anchor) 기준으로 그린다.
      // - 연도 등 상위 그룹(isGroup)은 해당 그룹의 '첫 월 컬럼' 중앙에 작게 표기
      // - day:   상단=일(네이티브 축라벨),  그룹=[월] (연도 경계가 있으면 [월, 연도])
      // - month: [월(각 월 중앙), 연도(첫 월 컬럼 중앙)]
      // - year:  [연도(각 연도 중앙)]
      const buildTiers = () => {
        const monthSegs = buildUnitSegments('month');

        // 연도 단: 각 연도의 '첫 월' 컬럼 중앙에 표기
        const buildYearTier = () => {
          const seen = new Set();
          const out = [];
          monthSegs.forEach((m) => {
            if (!seen.has(m.year)) {
              seen.add(m.year);
              out.push({ anchor: m.center, label: `${m.year}` });
            }
          });
          return out;
        };

        if (labelMode === 'day') {
          // 월 그룹은 각 월의 '첫 날'(첫 데이터) 라벨 위치에 맞춰 표기
          const tiers = [{
            segments: monthSegs.map((m) => ({ anchor: m.start, label: m.label })),
            isGroup: true,
          }];
          const yearTier = buildYearTier();
          if (yearTier.length > 1) tiers.push({ segments: yearTier, isGroup: true }); // 연도가 바뀔 때만 추가
          return tiers;
        }
        if (labelMode === 'month') {
          return [
            { segments: monthSegs.map((m) => ({ anchor: m.center, label: m.label })), isGroup: false },
            { segments: buildYearTier(), isGroup: true },
          ];
        }
        const yearSegs = buildUnitSegments('year');
        return [{ segments: yearSegs.map((y) => ({ anchor: y.center, label: y.label })), isGroup: false }];
      };

      // 라벨(월/연도)을 축 아래 단(段)별로 직접 그리기(graphic)
      const renderCenterLabels = () => {
        if (!hasData) {
          myChart.setOption({ graphic: [] });
          return;
        }

        const tiers = buildTiers();
        const axisY = chartDom.clientHeight - gridBottom; // x축 라인의 y 좌표
        const rowGap = 22;
        // day 모드는 네이티브 '일' 라벨 아래에서 시작, 그 외는 축 바로 아래에서 시작
        const firstRowY = axisY + (labelMode === 'day' ? 42 : 26);

        const elements = [];
        tiers.forEach((tier, tierIdx) => {
          const y = firstRowY + tierIdx * rowGap;
          const { segments, isGroup } = tier;
          segments.forEach((seg, idx) => {
            const x = myChart.convertToPixel({ xAxisIndex: 0 }, seg.anchor);
            elements.push({
              id: `center_label_${tierIdx}_${idx}`,
              type: 'text',
              silent: true,
              style: {
                text: seg.label,
                fontFamily: 'Pretendard',
                // 연도 등 그룹 라벨은 월과 같은 색, 살짝 작은 크기
                fontSize: isGroup ? 12 : 14,
                fontWeight: 500,
                fill: '#79828d',
                align: 'center',
                verticalAlign: 'middle',
              },
              x,
              y,
            });
          });
        });

        myChart.setOption({ graphic: elements });
      };

      // ---------------------------------------------------------------------------
      // option
      // ---------------------------------------------------------------------------
      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        // ✅ 라벨 잘림 방지: 하단 여백 확보
        grid: {
          left: 70,
          right: 30,
          top: 80,
          bottom: gridBottom,
          containLabel: false,
        },

        tooltip: {
          trigger: hasData ? 'axis' : 'none',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          position(pt) {
            return [pt[0], '10%'];
          },
          axisPointer: {
            type: hasData ? 'line' : 'none',
          },
          // ✅ 시간 제거: 날짜만 표시
          formatter(params) {
            if (!params || !params.length) return '';
            const axisValue = params[0].axisValue;
            const t = typeof axisValue === 'number' ? axisValue : new Date(axisValue).getTime();
            const dateText = Number.isFinite(t) ? formatYMD(t) : '';

            const lines = params.map(p => `${p.marker}${title}: ${p.data?.[1] ? new Intl.NumberFormat('ko-KR').format(p.data?.[1]) : ''}`);
            return [dateText, ...lines].join('<br/>');
          },
        },

        xAxis: {
          type: 'time',
          boundaryGap: false,
          min: firstTime,
          max: lastTime,
          axisTick: { show: true, lineStyle: { color: '#e0e0e0' } },
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          splitLine: { show: false },

          // day 모드만 xAxis 라벨 사용 (1일 2일 ...)
          axisLabel: {
            show: labelMode === 'day' && hasData,
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
            hideOverlap: true,
            showMinLabel: true,
            showMaxLabel: true,

            formatter(value) {
              if (!hasData) return '';
              const t = typeof value === 'number' ? value : new Date(value).getTime();
              if (!Number.isFinite(t)) return '';
              const d = new Date(t);
              return `${d.getDate()}일`;
            },
          },

          // day 모드일 때 너무 촘촘하면 알아서 간격을 잡게 (최소 1일)
          minInterval: oneDay,
        },

        yAxis: {
          type: 'value',
          boundaryGap: [0, '100%'],
          min: 0,
          max: hasData ? null : 100,
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },

        title: {
          text: title,
          left: 'center',
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 600,
          },
        },

        series: [
          {
            name: 'Data',
            type: 'line',
            smooth: true,
            symbol: 'none',
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(54, 180, 110, 1)' },
                { offset: 1, color: 'rgba(54, 180, 110, 0.3)' },
              ]),
            },
            itemStyle: { color: '#35b46e' },
            data: formattedData,
          },
        ],
      };

      myChart.setOption(option);

      // ✅ setOption 이후에 convertToPixel이 제대로 먹어서 라벨 그릴 수 있음
      renderCenterLabels();

      $(window).off(`resize.${id}`).on(`resize.${id}`, () => {
        myChart.resize();
        renderCenterLabels();
      });
    },
    /**
     * Set Density Chart (KDE)
     * basic_statistic_graph_input.json 의 원시 값(values)에서 통계량을 계산하여 정규분포 밀도 곡선을 렌더링
     * @param {String} id
     * @param {Object} input { title, yLabel, unitNm, values } — values 는 배열 또는 { total|groupN: [...] } 객체
     */
    setDensityChart(id, input) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // values: 배열 또는 { total, groupN } 객체 → 배열로 정규화
      let rawValues = [];
      if (Array.isArray(input && input.values)) {
        rawValues = input.values;
      } else if (input && input.values && typeof input.values === 'object') {
        rawValues = input.values.total
          || input.values.group1
          || input.values[Object.keys(input.values)[0]]
          || [];
      }
      const nums = rawValues.filter((v) => typeof v === 'number' && Number.isFinite(v));

      const count = nums.length;
      const hasData = count > 0;

      let mean = 0, std = 0, min = 0, max = 0;
      if (hasData) {
        mean = nums.reduce((a, b) => a + b, 0) / count;
        const variance = count > 1
          ? nums.reduce((acc, v) => acc + (v - mean) * (v - mean), 0) / (count - 1)
          : 0;
        std = Math.sqrt(variance);
        min = Math.min.apply(null, nums);
        max = Math.max.apply(null, nums);
      }

      // 정규분포 밀도 곡선 데이터 생성
      const data = [];
      let xMin = null; // null = 자동(반올림된 예쁜 눈금). 스파이크·빈값일 때만 명시
      let xMax = null;
      let yMax = null; // null = 자동(곡선 있을 때), 그 외엔 축만 보이도록 명시
      if (hasData && std > 0) {
        const padding = std * 0.5;
        const curveMin = min - padding;
        const curveMax = max + padding;
        const step = (curveMax - curveMin) / 200;
        for (let x = curveMin; x <= curveMax; x += step) {
          const xVal = x;
          const density = (1 / (std * Math.sqrt(2 * Math.PI))) * Math.exp(-0.5 * Math.pow((xVal - mean) / std, 2));
          data.push([xVal, density]);
        }
      } else if (hasData) {
        // 모든 값이 동일(std === 0) → 곡선을 그릴 수 없어 평균 지점에 스파이크 표시
        const padding = Math.max(Math.abs(mean) * 0.5, 1);
        xMin = mean - padding;
        xMax = mean + padding;
        yMax = 1;
        data.push([mean, 0], [mean, 1]);
      } else {
        // 데이터 없음 → 곡선 없이 x, y축만 표시
        xMin = 0;
        xMax = 1;
        yMax = 1;
      }

      // 제목/축 라벨: 원시 title 에 N 을 부가, xLabel 은 title + (unitNm)
      const baseTitle = input && input.title ? input.title : '';
      const displayTitle = baseTitle
        ? (hasData ? `${baseTitle}(N: ${new Intl.NumberFormat('ko-KR').format(count)})` : baseTitle)
        : '';
      const xLabel = baseTitle
        ? (input && input.unitNm ? `${baseTitle}(${input.unitNm})` : baseTitle)
        : '';

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(displayTitle, chartDom.clientWidth - 32),
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(displayTitle, 30), bottom: 80 },
        xAxis: {
          type: 'value',
          min: xMin,
          max: xMax,
          name: xLabel,
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: yMax,
          name: (input && input.yLabel) || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: [
          {
            name: 'Density',
            type: 'line',
            smooth: true,
            symbol: 'none',
            silent: true,
            areaStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                { offset: 0, color: 'rgba(57, 184, 82, 1)' },
                { offset: 1, color: 'rgba(57, 184, 82, 0.3)' },
              ]),
            },
            lineStyle: {
              color: '#39b852',
              width: 1,
            },
            itemStyle: { color: '#39b852' },
            data: data,
          },
        ],
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, displayTitle);
      Utils.attachValueAxisNameFit(myChart, chartDom);
      Utils.attachValueAxisXFit(myChart, chartDom);
      $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
    },
    /**
     * Set Growth Chart (성장성 차트)
     * @param {String} id
     * @param {String} title
     * @param {Object} dataSet { labels: [...], series: [{ name, data, highlight, color }] }
     *   - labels: x축 카테고리 (ex: ['2014', '2015', ...])
     *   - series[].name: 개체명
     *   - series[].data: 값 배열
     *   - series[].highlight: true이면 강조 라인
     *   - series[].color: 강조 라인일 때 색상 (ex: 'red', 'blue')
     */
    setGrowthChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      // individual_growth_rate_graph_input.json 구조 → (labels, series) 정규화
      // - labels: 모든 개체 clctYmd 의 합집합 (오름차순)
      // - series: indvdId 별 시계열, top_5/bottom_5_individuals 는 highlight 처리
      if (Array.isArray(dataSet.individual_values)) {
        const dateSet = new Set();
        dataSet.individual_values.forEach((ind) => {
          (ind.values || []).forEach((v) => { if (v && v.clctYmd) dateSet.add(v.clctYmd); });
        });
        const labels = Array.from(dateSet).sort();

        const topIds = new Set((dataSet.top_5_individuals || []).map((t) => t.indvdId));
        const bottomIds = new Set((dataSet.bottom_5_individuals || []).map((t) => t.indvdId));

        let topLegendSet = false;
        let bottomLegendSet = false;
        const normal = [];
        const tops = [];
        const bottoms = [];
        dataSet.individual_values.forEach((ind) => {
          const valueMap = {};
          (ind.values || []).forEach((v) => { if (v && v.clctYmd) valueMap[v.clctYmd] = v.value; });
          const data = labels.map((lbl) => (Object.prototype.hasOwnProperty.call(valueMap, lbl) ? valueMap[lbl] : null));
          const item = { name: ind.indvdId, data };
          if (topIds.has(ind.indvdId)) {
            item.highlight = true;
            item.color = 'green';
            if (!topLegendSet) { item.legendLabel = 'Top 5'; topLegendSet = true; }
            tops.push(item);
          } else if (bottomIds.has(ind.indvdId)) {
            item.highlight = true;
            item.color = 'blue';
            if (!bottomLegendSet) { item.legendLabel = 'Bottom 5'; bottomLegendSet = true; }
            bottoms.push(item);
          } else {
            normal.push(item);
          }
        });

        dataSet = Object.assign({}, dataSet, { labels, series: normal.concat(tops, bottoms) });
      }

      if (!dataSet.series) dataSet.series = [];
      if (!dataSet.labels) dataSet.labels = [];
      const hasData = dataSet.series.length > 0 && dataSet.labels.length > 0;

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];
      const namedColorMap = {
        green: '#39b852', blue: '#2863ff', lightblue: '#22b5ff', red: '#f54a4a',
        orange: '#ffa431', cyan: '#37cec6', navy: '#342fe5', indigo: '#a307dd',
        purple: '#7528f0', yellow: '#f0cb00', magenta: '#ff6ff9', gray: '#8b9496',
      };
      let hlIdx = 0;

      const series = dataSet.series.map((item) => {
        const isHighlight = item.highlight === true;
        const color = isHighlight
          ? (namedColorMap[item.color] || chartColors[hlIdx++ % chartColors.length])
          : '#d1d5db';

        return {
          name: item.name,
          type: 'line',
          smooth: true,
          symbol: 'none',
          silent: !isHighlight,
          connectNulls: true,
          lineStyle: {
            width: 2,
            color: color,
            opacity: isHighlight ? 1 : 0.4,
          },
          itemStyle: { color: color, opacity: 0 },
          z: isHighlight ? 10 : 1,
          data: item.data,
        };
      });

      // 같은 color의 highlight 시리즈를 그룹으로 묶어 범례 표시
      const colorGroups = {};
      dataSet.series.forEach((item) => {
        if (!item.highlight) return;
        const key = item.color || 'red';
        if (!colorGroups[key]) colorGroups[key] = { names: [], label: item.legendLabel };
        colorGroups[key].names.push(item.name);
      });

      // 대표 시리즈 → 그룹 내 전체 시리즈 매핑
      const legendData = [];
      const legendFormatter = {};
      const groupMap = {};
      Object.keys(colorGroups).forEach((key) => {
        const group = colorGroups[key];
        const representative = group.names[0];
        const label = group.label || representative;
        legendData.push(representative);
        legendFormatter[representative] = label;
        groupMap[representative] = group.names;
      });

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(dataSet.title, chartDom.clientWidth - 32),
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (!params || !params.length) return '';
            // 강조(Top/Bottom) 개체만 툴팁 대상
            const highlighted = params.filter((p) => {
              const s = dataSet.series[p.seriesIndex];
              return s && s.highlight;
            });
            if (!highlighted.length) return '';

            const rows = [];
            highlighted.forEach((p) => {
              const s = dataSet.series[p.seriesIndex];
              const data = (s && s.data) || [];
              const i = p.dataIndex;
              const v = data[i];

              let display;
              if (v != null) {
                // 값 있음
                display = v;
              } else {
                // 값 없음: connectNulls 로 선이 이 지점을 지나가는지(앞뒤로 값 존재) 확인
                const hasBefore = data.slice(0, i).some((d) => d != null);
                const hasAfter = data.slice(i + 1).some((d) => d != null);
                if (!(hasBefore && hasAfter)) return; // 선이 지나가지 않는 개체 → 제외
                display = 'NA'; // 선은 있으나 해당 시점 값 없음
              }

              const color = p.color;
              const marker = `<span style="display:inline-block;margin-right:6px;width:16px;height:2px;background:${color};vertical-align:middle;"></span>`;
              rows.push(`${marker}${p.seriesName}: ${display}`);
            });

            // 선이 지나가는 강조 개체가 하나도 없으면(전체 값 없음) 툴팁 표시 안 함
            if (!rows.length) return '';
            return `${highlighted[0].axisValue}<br/>${rows.join('<br/>')}`;
          },
        },
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, 50), bottom: 80 },
        legend: {
          data: legendData,
          top: Utils.chartTitleTop(dataSet.title, 0),
          left: 'center',
          itemWidth: 25,
          itemHeight: 3,
          formatter: (name) => legendFormatter[name] || name,
          textStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
        },
        xAxis: {
          type: 'category',
          data: dataSet.labels,
          boundaryGap: false,
          name: dataSet.xLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 100,
          name: dataSet.yLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: series,
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, dataSet.title);
      Utils.attachCategoryAxisFit(myChart, chartDom, {
        categories: dataSet.labels || [],
        gridLeft: 80, gridRight: 30, fontSize: 14, fontWeight: 500,
        baseBottom: 80, baseNameGap: 56,
      });
      Utils.attachValueAxisNameFit(myChart, chartDom);

      // 범례 클릭 시 같은 그룹 시리즈 일괄 토글
      myChart.on('legendselectchanged', function (params) {
        const name = params.name;
        const siblings = groupMap[name];
        if (!siblings || siblings.length <= 1) return;

        const selected = params.selected[name];
        const batch = {};
        siblings.forEach((s) => { batch[s] = selected; });
        myChart.setOption({ legend: { selected: Object.assign({}, params.selected, batch) } });
      });

      $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
    },
    /**
     * Set Bar Chart
     * @param {String} id
     * @param {Object} dataSet { title, data, labels, colors }
     */
    setBarChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // Ensure minimum axis range even with empty data
      const hasData = dataSet.data && dataSet.data.length > 0;

      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(dataSet.title, chartDom.clientWidth - 32),
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, 30), bottom: 80 },
        xAxis: {
          type: 'category',
          data: dataSet.labels && dataSet.labels.length > 0 ? dataSet.labels : [''],
          name: dataSet.xLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 100,
          name: dataSet.yLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: [
          {
            // 실제 데이터 바 시리즈
            data: dataSet.data.map((val, idx) => {
              const namedColorMap = {
                green: '#39b852', blue: '#2863ff', lightblue: '#22b5ff', red: '#f54a4a',
                orange: '#ffa431', cyan: '#37cec6', navy: '#342fe5', indigo: '#a307dd',
                purple: '#7528f0', yellow: '#f0cb00', magenta: '#ff6ff9', gray: '#8b9496',
              };
              const hexColor = dataSet.colors && dataSet.colors[idx]
                ? (namedColorMap[dataSet.colors[idx]] || dataSet.colors[idx])
                : chartColors[0];

              const hexToRgba = (hex, opacity) => {
                if (!hex || hex.indexOf('#') !== 0) return hex;
                let r = 0, g = 0, b = 0;
                if (hex.length === 4) {
                  r = parseInt(hex[1] + hex[1], 16);
                  g = parseInt(hex[2] + hex[2], 16);
                  b = parseInt(hex[3] + hex[3], 16);
                } else if (hex.length === 7) {
                  r = parseInt(hex.substring(1, 3), 16);
                  g = parseInt(hex.substring(3, 5), 16);
                  b = parseInt(hex.substring(5, 7), 16);
                }
                return `rgba(${r}, ${g}, ${b}, ${opacity})`;
              };

              return {
                value: val,
                itemStyle: {
                  color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                    { offset: 0, color: hexToRgba(hexColor, 1) },
                    { offset: 1, color: hexToRgba(hexColor, 0.3) },
                  ]),
                  borderColor: hexColor,
                  borderWidth: 2,
                  borderRadius: [8, 8, 0, 0],
                },
              };
            }),
            type: 'bar',
            barWidth: 48,
            silent: true,
            label: {
              show: true,
              position: 'top',
              color: '#676e78',
              fontFamily: 'Pretendard',
              fontSize: 14,
              fontWeight: 500,
              formatter(params) {
                const total = dataSet.data.reduce((sum, v) => sum + v, 0);
                const pct = total > 0 ? ((params.value / total) * 100).toFixed(1) : '0.0';
                return `${params.value}\n(${pct}%)`;
              },
            },
          },
        ],
      };
      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, dataSet.title);
      Utils.attachCategoryAxisFit(myChart, chartDom, {
        categories: dataSet.labels || [],
        gridLeft: 80, gridRight: 30, fontSize: 14, fontWeight: 500,
        baseBottom: 80, baseNameGap: 56,
      });
      Utils.attachValueAxisNameFit(myChart, chartDom);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },
    /**
     * Set Distribution Chart (수치형 분포도: 구간별 개체 수 히스토그램 + 개체 산점도)
     * 영상 분석 결과 outputs[].distribution 을 그대로 받아 렌더링. 컨테이너 높이는 호출부에서 inline style 로 지정
     * - 구간 폭: 정수값이고 범위가 20 이하이면 1 (값마다 막대 1개), 아니면 Sturges 구간 수 기준 1·2·5×10^n
     * - x축: 막대가 영역을 꽉 채우지 않도록 최소 10칸 확보 (정수 단위, 구간 [n, n+1)) / 양쪽 한 구간씩 여유 (그 외)
     * - x축 눈금은 구간 경계마다, 라벨은 구간이 6개 넘으면 2칸마다
     * - 점: 개체별 값 (해당 구간 막대 안에 흩뿌림), 최댓값/최솟값 개체는 파랑/빨강
     * - 평균: 점선
     * @param {String} id
     * @param {Object} dataSet { unit, values: [{ indvdId, value }], max: { indvdId, value }, min: { indvdId, value }, statistic: { mean } }
     */
    setDistChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const unit = dataSet.unit || '';
      const values = (dataSet.values || []).filter((v) => Number.isFinite(v.value));
      const nums = values.map((v) => v.value);
      const minV = nums.length ? Math.min(...nums) : 0;
      const maxV = nums.length ? Math.max(...nums) : 0;
      const span = maxV - minV;
      const maxId = dataSet.max && dataSet.max.indvdId;
      const minId = dataSet.min && dataSet.min.indvdId;
      const mean = dataSet.statistic && Number.isFinite(dataSet.statistic.mean)
        ? dataSet.statistic.mean
        : (nums.length ? nums.reduce((s, v) => s + v, 0) / nums.length : 0);

      // 구간 폭
      const isUnitBin = nums.every(Number.isInteger) && span <= 20;
      let step = 1;
      if (!isUnitBin) {
        const raw = (span || 1) / (Math.ceil(Math.log2(nums.length || 1)) + 1);
        const mag = 10 ** Math.floor(Math.log10(raw));
        step = [1, 2, 5, 10].map((m) => m * mag).find((s) => s >= raw);
      }

      // x축 범위 (구간 경계). 음수가 없는 값은 0 미만으로 넓히지 않음
      let start;
      let end;
      if (isUnitBin) {
        const slots = Math.max(10, span + 3);
        start = minV - Math.floor((slots - span - 1) / 2);
        if (minV >= 0 && start < 0) start = 0;
        end = Math.max(start + slots, maxV + 2);
      } else {
        start = (Math.floor(minV / step) - 1) * step;
        if (minV >= 0 && start < 0) start = 0;
        end = (Math.floor(maxV / step) + 2) * step;
      }
      const round = (v) => Number(v.toPrecision(12));
      const binCount = Math.round((end - start) / step);
      const edge = (i) => round(start + step * i);
      const bins = Array.from({ length: binCount }, () => []);
      values.forEach((v) => {
        bins[Math.min(binCount - 1, Math.floor(round((v.value - start) / step)))].push(v);
      });

      // 개체 점: 막대 안에 흩뿌림 (개체 아이디 해시 기반이라 다시 그려도 위치 고정)
      // y = 구간 안 순서를 해시로 섞은 뒤 칸(높이 1)마다 1개씩, 칸 안에서 위아래 흩뿌림 → 점끼리 겹치지 않음
      // x = 정수 단위는 값이 모두 구간 시작이라 막대 폭 안에서 좌우로 흩뿌림, 그 외는 실제 값 (구간 경계의 값은 막대 안으로)
      const jitter = (s) => {
        let h = 2166136261;
        for (let k = 0; k < s.length; k += 1) h = Math.imul(h ^ s.charCodeAt(k), 16777619);
        return (Math.abs(h) % 1000) / 1000;
      };
      const points = bins.flatMap((bin, i) => [...bin]
        .sort((a, b) => jitter(`${a.indvdId}|k`) - jitter(`${b.indvdId}|k`))
        .map((v, k) => ({
          value: [
            isUnitBin
              ? edge(i) + step * (0.15 + jitter(`${v.indvdId}|x`) * 0.7)
              : Math.min(Math.max(v.value, edge(i) + step * 0.15), edge(i + 1) - step * 0.15),
            k + 0.25 + jitter(`${v.indvdId}|y`) * 0.5,
          ],
          raw: v.value,
          indvdId: v.indvdId,
        })));
      const pointsOf = (filter) => points.filter((p) => filter(p.indvdId));
      const pointSeries = (color, size, opacity, filter) => ({
        type: 'scatter',
        symbolSize: size,
        z: 3,
        itemStyle: { color, opacity, borderColor: '#fff', borderWidth: 1 },
        emphasis: { scale: 1.4 },
        data: pointsOf(filter),
      });

      // 큰 값(면적 px 등)은 천 단위 콤마, 소수 1자리까지
      const fmt = (v) => Number(v).toLocaleString('ko-KR', { maximumFractionDigits: 1 });
      const axisLabelStyle = {
        color: '#79828d',
        fontFamily: 'Pretendard',
        fontSize: 13,
        fontWeight: 500,
      };

      const option = {
        tooltip: {
          trigger: 'item',
          appendToBody: true,
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (params.seriesType === 'custom') {
              const [lo, hi, count] = params.value;
              const range = isUnitBin ? `${fmt(lo)}${unit}` : `${fmt(lo)} ~ ${fmt(hi)}${unit}`;
              return `${range}<br/>개체 수: ${count}`;
            }
            return `${params.marker}${params.data.indvdId}<br/>${fmt(params.data.raw)}${unit}`;
          },
        },
        // 오른쪽 여백: 마지막 x 라벨(예: 3,000,000)의 절반 폭이 잘리지 않도록
        grid: { left: 44, right: Math.max(16, fmt(end).length * 4 + 4), top: 56, bottom: 56 },
        xAxis: {
          type: 'value',
          min: start,
          max: end,
          // 눈금: 구간 경계마다 / 라벨: 구간 경계마다 (구간이 6개 넘으면 2칸마다)
          interval: step,
          name: unit ? `(${unit})` : '',
          nameLocation: 'center',
          nameGap: 36,
          nameTextStyle: axisLabelStyle,
          axisLine: { show: true, lineStyle: { color: '#dcdedf' } },
          axisTick: {
            show: true,
            lineStyle: { color: '#dcdedf' },
            customValues: Array.from({ length: binCount + 1 }, (_, i) => edge(i)),
          },
          splitLine: { show: false },
          axisLabel: {
            ...axisLabelStyle,
            customValues: Array.from({ length: binCount + 1 }, (_, i) => edge(i))
              .filter((v) => binCount <= 6 || Math.round(v / step) % 2 === 0),
            formatter: (v) => fmt(v),
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          boundaryGap: [0, '20%'], // 막대 위 여유 (평균 라벨 공간)
          minInterval: 1,
          name: '개체 수',
          nameLocation: 'end',
          nameGap: 32,
          nameTextStyle: { ...axisLabelStyle, align: 'left', padding: [0, 0, 0, -30] },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: true, lineStyle: { color: '#f2f2f2' } },
          axisLabel: axisLabelStyle,
        },
        series: [
          {
            // 구간별 개체 수 막대 [구간 시작, 구간 끝, 개체 수]
            type: 'custom',
            z: 1,
            encode: { x: [0, 1], y: 2 },
            data: bins.map((bin, i) => [edge(i), edge(i + 1), bin.length]),
            renderItem(_, api) {
              if (!api.value(2)) return null;
              const [x0, y0] = api.coord([api.value(0), api.value(2)]);
              const [x1, yBase] = api.coord([api.value(1), 0]);
              // 막대 사이 2px 간격
              const gap = 1;
              return {
                type: 'rect',
                shape: { x: x0 + gap, y: y0, width: Math.max(x1 - x0 - gap * 2, 1), height: yBase - y0 },
                style: { fill: '#d6ecd9' },
              };
            },
          },
          {
            ...pointSeries('#3f8f55', 8, 0.6, (indvdId) => indvdId !== maxId && indvdId !== minId),
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: { color: '#33363c', type: [4, 3], width: 1.5 },
              label: {
                position: 'end',
                formatter: `평균 ${fmt(mean)}`,
                color: '#33363c',
                fontFamily: 'Pretendard',
                fontSize: 13,
                fontWeight: 700,
              },
              data: [{ xAxis: mean }],
            },
          },
          pointSeries('#2863ff', 12, 1, (indvdId) => indvdId === maxId),
          // 모든 값이 같아 최댓값·최솟값 개체가 같으면 최댓값 점만 표시
          pointSeries('#f54a4a', 12, 1, (indvdId) => indvdId === minId && indvdId !== maxId),
        ],
      };
      myChart.setOption(option);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
      // 컨테이너가 남는 높이를 채우는 경우(아래 통계 줄바꿈, 폰트 로딩, TOC 접기/펴기) 크기 변화에도 맞춤
      if (typeof ResizeObserver === 'undefined') return;
      if (chartDom.__distResizeObserver) chartDom.__distResizeObserver.disconnect();
      const ro = new ResizeObserver(() => {
        if (myChart.isDisposed()) {
          ro.disconnect();
          return;
        }
        myChart.resize();
      });
      ro.observe(chartDom);
      chartDom.__distResizeObserver = ro;
    },
    /**
     * Set Group Bar Chart
     * @param {String} id
     * @param {Array} dataSet [{ name: '가지과', children: [{ name: '가지', value: 45 }, ...] }, ...]
     * 홀수/짝수 그룹 인덱스에 따라 두 가지 색상으로 구분
     */
    setGroupBarChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      if (!Array.isArray(dataSet) || dataSet.length === 0) dataSet = [];

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();

      // 색상: 홀수/짝수 그룹 구분
      const COLOR_EVEN = '#589172'; // 짝수 그룹 (0, 2, 4, ...)
      const COLOR_ODD  = '#A1D86D'; // 홀수 그룹 (1, 3, 5, ...)

      // 각 그룹별 메타 정보 저장 (startIndex, endIndex, color)
      const groupMeta = [];
      const xLabels   = [];
      const barData   = [];

      dataSet.forEach((group, groupIdx) => {
        const isEven    = groupIdx % 2 === 0;
        const color     = isEven ? COLOR_EVEN : COLOR_ODD;
        const startIndex = xLabels.length;

        group.children.forEach((child) => {
          xLabels.push(child.name);
          barData.push({
            value: child.value,
            _origValue: child.value,   // 원본값 보존
            _groupName: group.name,    // 그룹명 보존 (tooltip용)
            itemStyle: { color, borderRadius: [6, 6, 0, 0] },
          });
        });

        groupMeta.push({
          name: group.name,
          startIndex,
          endIndex: xLabels.length - 1,
          color,
          visible: true,
        });
      });


      // ── 체크박스 리스트 동적 렌더링 ──────────────────────────────
      // echarts-legend[data-target="#id"] 탐색, 없으면 chartDom.parentElement로 fallback
      const legendEl = document.querySelector(`.echarts-legend[data-target="#${id}"]`);

      // 재호출 시 기존 ul 제거 (data-chart-id 속성으로 안전하게 탐색)
      const existingFilter = (legendEl || chartDom.parentElement).querySelector(`ul[data-chart-id="${id}"]`);
      if (existingFilter) existingFilter.remove();

      const filterListEl = document.createElement('ul');
      filterListEl.className = 'custom-checked-list echarts-checked-list';
      filterListEl.setAttribute('data-chart-id', id);
      filterListEl.innerHTML = groupMeta.map((g, i) => `
        <li class="custom-checked-item">
          <div class="ta-checkbox-wrap">
            <input type="checkbox" name="${id}Filter" id="${id}Filter_${i}" class="sr-only" checked data-group-index="${i}">
            <label for="${id}Filter_${i}"><span class="text-truncate">${g.name}</span>(${(g.endIndex - g.startIndex + 1).toLocaleString()})</label>
          </div>
        </li>
      `).join('');

      // if(legendEl) 블록 밖에서도 참조할 수 있도록 먼저 선언
      let syncAllCheckbox = () => {};

      if (legendEl) {
        // 기존 구조 초기화
        legendEl.innerHTML = '';

        // ── 전체 선택 체크박스 ─────────────────────────────────────
        const allCheckWrap = document.createElement('div');
        allCheckWrap.className = 'echarts-legend-all';
        allCheckWrap.innerHTML = `
          <div class="ta-checkbox-wrap">
            <input type="checkbox" id="${id}FilterAll" class="sr-only" checked>
            <label for="${id}FilterAll">전체(${barData.length.toLocaleString()})</label>
          </div>
        `;
        legendEl.appendChild(allCheckWrap);
        const allCheckInput = allCheckWrap.querySelector(`#${id}FilterAll`);

        // 전체 체크박스 상태 동기화 (checked / indeterminate / unchecked)
        syncAllCheckbox = () => {
          const checkedCount = groupMeta.filter((m) => m.visible).length;
          const total = groupMeta.length;
          if (checkedCount === 0) {
            allCheckInput.checked       = false;
            allCheckInput.indeterminate = false;
          } else if (checkedCount === total) {
            allCheckInput.checked       = true;
            allCheckInput.indeterminate = false;
          } else {
            allCheckInput.checked       = false;
            allCheckInput.indeterminate = true;
          }
        };

        // 전체 체크박스 클릭 → 모든 그룹 일괄 선택/해제
        // 하나라도 선택돼 있으면 → 전체 해제
        // 아무것도 선택 안 됐을 때만 → 전체 선택
        allCheckInput.addEventListener('change', () => {
          const anyVisible = groupMeta.some((m) => m.visible);
          const willCheck  = !anyVisible; // 모두 해제 상태일 때만 전체 선택

          allCheckInput.checked       = willCheck;
          allCheckInput.indeterminate = false;

          groupMeta.forEach((m) => { m.visible = willCheck; });
          filterListEl.querySelectorAll(`input[name="${id}Filter"]`).forEach((inp) => {
            inp.checked = willCheck;
          });
          updateChart();
        });

        // ── body 래퍼 (overflow: hidden) ────────────────────────────
        const legendBody = document.createElement('div');
        legendBody.className = 'echarts-legend-body';
        legendBody.appendChild(filterListEl);
        legendEl.appendChild(legendBody);

        // ── 페이지네이션 nav ────────────────────────────────────────
        const legendNav = document.createElement('div');
        legendNav.className = 'echarts-legend-nav';
        legendNav.innerHTML = `
          <button class="echarts-legend-nav-prev" type="button" disabled aria-label="이전">
            <i class="material-icons">arrow_drop_up</i>
          </button>
          <span class="echarts-legend-nav-page">1 / 1</span>
          <button class="echarts-legend-nav-next" type="button" aria-label="다음">
            <i class="material-icons">arrow_drop_down</i>
          </button>
        `;
        legendEl.appendChild(legendNav);

        const prevBtn  = legendNav.querySelector('.echarts-legend-nav-prev');
        const nextBtn  = legendNav.querySelector('.echarts-legend-nav-next');
        const pageText = legendNav.querySelector('.echarts-legend-nav-page');

        let currentPage = 0;
        let pageOffsets  = [0]; // 각 페이지의 translateY offset (px)

        // 아이템의 offsetTop 기준으로 페이지 경계를 계산
        const buildPageOffsets = () => {
          const bodyHeight = legendBody.clientHeight;
          if (bodyHeight === 0) return;

          const items = Array.from(filterListEl.querySelectorAll('li'));
          pageOffsets = [0];
          let pageStart = 0; // 현재 페이지 시작 기준점 (filterListEl 내 좌표)

          items.forEach((item) => {
            const itemBottom = item.offsetTop + item.offsetHeight;
            // 아이템 하단이 현재 페이지 가시 영역을 벗어나면 → 새 페이지 시작
            if (itemBottom - pageStart > bodyHeight) {
              pageStart = item.offsetTop;
              pageOffsets.push(pageStart);
            }
          });
        };

        const updateLegendPage = () => {
          const bodyHeight = legendBody.clientHeight;
          const listHeight = filterListEl.scrollHeight;
          if (bodyHeight === 0) return;

          buildPageOffsets();

          const totalPages = pageOffsets.length;
          currentPage = Math.min(currentPage, totalPages - 1);

          const offset = pageOffsets[currentPage];
          filterListEl.style.transform  = `translateY(-${offset}px)`;
          filterListEl.style.transition = 'transform 0.25s ease';

          pageText.textContent = `${currentPage + 1} / ${totalPages}`;
          prevBtn.disabled     = currentPage === 0;
          nextBtn.disabled     = currentPage >= totalPages - 1;

          // 한 페이지에 다 들어오면 nav 숨김
          legendNav.style.display = listHeight > bodyHeight ? '' : 'none';
        };

        prevBtn.addEventListener('click', () => {
          if (currentPage > 0) { currentPage--; updateLegendPage(); }
        });
        nextBtn.addEventListener('click', () => {
          if (currentPage < pageOffsets.length - 1) { currentPage++; updateLegendPage(); }
        });

        // 렌더 후 계산 (DOM 높이가 확정된 다음 프레임에서 실행)
        requestAnimationFrame(() => {
          requestAnimationFrame(updateLegendPage);
        });

        $(window).off(`resize.legend_${id}`).on(`resize.legend_${id}`, () => {
          currentPage = 0;
          updateLegendPage();
        });

      } else {
        chartDom.parentElement.insertBefore(filterListEl, chartDom);
      }

      // ── 차트 초기화 ───────────────────────────────────────────────
      const ITEM_SLOT    = 44;
      const LEFT_MARGIN  = 60;
      const RIGHT_MARGIN = 20;
      const minChartWidth = xLabels.length * ITEM_SLOT + LEFT_MARGIN + RIGHT_MARGIN;

      const parent = chartDom.parentElement;

      const containerWidth = parent.clientWidth || 600;
      const chartWidth = Math.max(containerWidth, minChartWidth);
      chartDom.style.width = chartWidth + 'px';

      myChart = echarts.init(chartDom);

      const buildOption = () => ({
        grid: {
          left: LEFT_MARGIN,
          right: RIGHT_MARGIN,
          top: 32,
          bottom: 16,
          containLabel: true,
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (!params || !params.length) return '';
            const p = params[0];
            const groupName = p.data && p.data._groupName ? p.data._groupName : '';
            const label = groupName ? `${groupName} / ${p.name}` : p.name;
            return `${label}<br/>${p.marker} ${p.value}`;
          },
        },
        xAxis: {
          type: 'category',
          data: xLabels,
          axisLine: { lineStyle: { color: '#e0e0e0' } },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 12,
            fontWeight: 500,
            interval: 0,
            rotate: 90,
            margin: 12,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: barData.length === 0 ? 100 : null,
          interval: barData.length === 0 ? 20 : null,
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          splitLine: {
            lineStyle: { color: '#f0f0f0', type: 'dashed' },
          },
        },
        series: [
          {
            type: 'bar',
            barWidth: 20,
            data: barData.map((d) => ({
              value: d.value,
              _groupName: d._groupName,
              itemStyle: d.itemStyle,
            })),
            label: {
              show: true,
              position: 'top',
              color: '#676e78',
              fontFamily: 'Pretendard',
              fontSize: 11,
              fontWeight: 500,
              formatter: (params) => params.value === 0 ? '' : params.value,
            },
          },
        ],
      });

      // ── 그룹 경계 border 렌더링 ────────────────────────────────────
      // visibleGroupSizes: 현재 화면에 보이는 그룹별 bar 개수 배열
      let currentGroupSizes = groupMeta.map((m) => m.endIndex - m.startIndex + 1);
      let prevBorderCount = 0; // 직전 렌더에서 그린 border 선 수

      const renderGroupBorders = () => {
        if (!myChart) return;

        // grid rect 추출 (ECharts 내부 모델 사용)
        let gridRect;
        try {
          gridRect = myChart.getModel().getComponent('grid', 0).coordinateSystem.getRect();
        } catch (e) {
          return;
        }

        const yTop    = gridRect.y;
        const yBottom = gridRect.y + gridRect.height;
        const totalBars = currentGroupSizes.reduce((a, b) => a + b, 0);

        // 바 간격(px)
        const getX = (idx) => myChart.convertToPixel({ xAxisIndex: 0 }, idx);
        const interval = totalBars > 1 ? Math.abs(getX(1) - getX(0)) : ITEM_SLOT;
        const half = interval / 2;

        // 각 그룹의 좌/우 경계 x 좌표를 수집 (중복 제거: 인접 경계는 하나의 선)
        const boundaryXSet = new Set();
        let barIdx = 0;
        currentGroupSizes.forEach((count) => {
          boundaryXSet.add(Math.round(getX(barIdx) - half));            // 그룹 왼쪽
          boundaryXSet.add(Math.round(getX(barIdx + count - 1) + half)); // 그룹 오른쪽
          barIdx += count;
        });

        // 맨 처음(왼쪽 끝) · 맨 마지막(오른쪽 끝) border 제거 → 그룹 사이 선만 유지
        const boundaryXList = totalBars > 0 ? Array.from(boundaryXSet).slice(1, -1) : [];

        // 신규 border 요소
        const newElements = boundaryXList.map((x, i) => ({
          id: `group_border_${i}`,
          type: 'line',
          silent: true,
          shape: { x1: x, y1: yTop, x2: x, y2: yBottom },
          style: { stroke: '#e0e0e0', lineWidth: 1 },
          z: 0,
        }));

        // 이전 렌더에서 더 많이 그렸던 border는 명시적으로 제거
        // (ECharts graphic은 id 기반으로 누적되므로 직접 삭제 필요)
        const removeElements = [];
        for (let i = newElements.length; i < prevBorderCount; i++) {
          removeElements.push({ id: `group_border_${i}`, $action: 'remove' });
        }

        prevBorderCount = newElements.length;
        myChart.setOption({ graphic: [...removeElements, ...newElements] });
      };

      // 초기 렌더 후 border 그리기
      requestAnimationFrame(() => renderGroupBorders());

      myChart.setOption(buildOption());

      // ── 체크박스 toggle: visible 그룹만 필터링해서 x축·데이터 재구성 ──
      const updateChart = () => {
        const visibleLabels  = [];
        const visibleBarData = [];
        const newGroupSizes  = [];

        // 화면에 표시되는 순서(visibleGroupIndex) 기준으로 홀짝 색상 재배정
        let visibleGroupIndex = 0;
        groupMeta.forEach((meta) => {
          if (!meta.visible) return;
          const color = visibleGroupIndex % 2 === 0 ? COLOR_EVEN : COLOR_ODD;
          visibleGroupIndex++;

          const count = meta.endIndex - meta.startIndex + 1;
          newGroupSizes.push(count);

          for (let i = meta.startIndex; i <= meta.endIndex; i++) {
            visibleLabels.push(xLabels[i]);
            visibleBarData.push({
              value: barData[i]._origValue,
              _groupName: barData[i]._groupName,
              itemStyle: { ...barData[i].itemStyle, color, borderRadius: [6, 6, 0, 0] },
            });
          }
        });

        // 차트 폭 재계산
        const visibleItemCount = visibleLabels.length;
        const newMinWidth = visibleItemCount * ITEM_SLOT + LEFT_MARGIN + RIGHT_MARGIN;
        const newChartWidth = Math.max(parent.clientWidth || 600, newMinWidth);
        chartDom.style.width = newChartWidth + 'px';
        myChart.resize();

        // 데이터가 없으면 y축 0~100 기본값, 있으면 자동
        const isEmpty = visibleLabels.length === 0;
        myChart.setOption({
          xAxis: { data: visibleLabels },
          yAxis: isEmpty
            ? { min: 0, max: 100, interval: 20 }
            : { min: 0, max: null, interval: null },
          series: [{ data: visibleBarData }],
        });

        // 그룹 사이즈 갱신 후 border 재렌더링
        currentGroupSizes = newGroupSizes;
        requestAnimationFrame(() => renderGroupBorders());
      };

      $(filterListEl).off('change').on('change', `input[name="${id}Filter"]`, function () {
        const groupIdx = parseInt($(this).data('group-index'));
        groupMeta[groupIdx].visible = this.checked;
        if (legendEl) syncAllCheckbox();
        updateChart();
      });

      $(window).off('resize.' + id).on('resize.' + id, () => {
        const visibleCount = groupMeta.reduce((acc, m) => acc + (m.visible ? (m.endIndex - m.startIndex + 1) : 0), 0);
        const newMinWidth = visibleCount * ITEM_SLOT + LEFT_MARGIN + RIGHT_MARGIN;
        const newChartWidth = Math.max(parent.clientWidth || 600, newMinWidth);
        chartDom.style.width = newChartWidth + 'px';
        myChart.resize();
        requestAnimationFrame(() => renderGroupBorders());
      });
    },
    /**
     * Set Pair Plot Chart (상관성 분석 매트릭스)
     * 대각선: 히스토그램, 상삼각: 상관계수 텍스트, 하삼각: 산점도+회귀선
     * correlation_graph_input.json 형식을 그대로 받아 grdvList/correlation.pearson 로부터 매트릭스를 구성.
     * @param {String} id - 컨테이너 요소 ID
     * @param {Object} dataSet
     *   - traits: {String[]} 형질명 배열 (생략 시 correlation.pearson[] 에서 고유값 추출)
     *   - grdvList: [{ indvdId, clctYmd, tme, value: {trait: number} }]  — 산점도/히스토그램 원본
     *     또는 data: 2D 배열 (legacy)
     *   - correlation: { pearson: [{ comparative1, comparative2, corr, p_value, ... }] }
     *     또는 correlations/pValues: 2D 행렬 (legacy)
     */
    setPairPlotChart(id, dataSet) {
      const container = document.getElementById(id);
      if (!container) return;

      // 재호출 시 직전 ECharts 인스턴스들 정리 (n² 인스턴스가 누적되지 않도록)
      if (Array.isArray(container.__pairPlotInstances)) {
        container.__pairPlotInstances.forEach((c) => {
          try { if (c && typeof c.dispose === 'function' && !c.isDisposed()) c.dispose(); } catch (e) {}
        });
        container.__pairPlotInstances = null;
      }
      if (container.__pairPlotObserver) {
        try { container.__pairPlotObserver.disconnect(); } catch (e) {}
        container.__pairPlotObserver = null;
      }
      container.__pairPlotInitAll = null;

      // ---- graph_input 구조 → (traits, data, correlations, pValues) 매트릭스 정규화 ----
      const pearsonList = (dataSet.correlation && Array.isArray(dataSet.correlation.pearson))
        ? dataSet.correlation.pearson
        : null;

      let traits = Array.isArray(dataSet.traits) ? dataSet.traits.slice() : [];
      if (traits.length === 0 && pearsonList) {
        const seen = new Set();
        pearsonList.forEach((p) => {
          if (p.comparative1 && !seen.has(p.comparative1)) { seen.add(p.comparative1); traits.push(p.comparative1); }
          if (p.comparative2 && !seen.has(p.comparative2)) { seen.add(p.comparative2); traits.push(p.comparative2); }
        });
      }

      let data = Array.isArray(dataSet.data) ? dataSet.data : null;
      if (!data && Array.isArray(dataSet.grdvList)) {
        data = dataSet.grdvList.map((item) => traits.map((t) => (item.value ? item.value[t] : undefined)));
      }
      data = data || [];

      let correlations = Array.isArray(dataSet.correlations) ? dataSet.correlations : null;
      let pValues = Array.isArray(dataSet.pValues) ? dataSet.pValues : null;
      if ((!correlations || !pValues) && pearsonList) {
        const idx = {};
        traits.forEach((t, i) => { idx[t] = i; });
        const N = traits.length;
        const corrM = Array.from({ length: N }, (_, i) => Array.from({ length: N }, (_, j) => (i === j ? 1 : 0)));
        const pvM = Array.from({ length: N }, () => Array(N).fill(0));
        pearsonList.forEach((p) => {
          const i = idx[p.comparative1];
          const j = idx[p.comparative2];
          if (i === undefined || j === undefined) return;
          corrM[i][j] = corrM[j][i] = p.corr;
          pvM[i][j] = pvM[j][i] = p.p_value;
        });
        correlations = correlations || corrM;
        pValues = pValues || pvM;
      }
      correlations = correlations || [];
      pValues = pValues || [];

      // pair 단위 line/confidence_band/regression 조회용 lookup
      // (서버가 내려준 곡선 데이터를 재계산 없이 그대로 사용하기 위함)
      const pairLookup = {};
      if (pearsonList) {
        pearsonList.forEach((p) => {
          if (!p.comparative1 || !p.comparative2) return;
          if (!pairLookup[p.comparative1]) pairLookup[p.comparative1] = {};
          pairLookup[p.comparative1][p.comparative2] = p;
        });
      }

      const n = traits.length;
      if (n === 0) {
        container.innerHTML = '';
        container.style.cssText = 'width:100%; height:100%;';
        const emptyChart = echarts.init(container);
        emptyChart.setOption({
          title: Utils.buildChartTitle(dataSet.title, container.clientWidth - 32),
          grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, 30), bottom: 80 },
          xAxis: { type: 'value', axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500 } },
          yAxis: { type: 'value', min: 0, max: 1, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500 } },
          series: [],
        });
        Utils.attachChartTitleResize(emptyChart, container, dataSet.title);
        $(window).off(`resize.${id}`).on(`resize.${id}`, () => emptyChart.resize());
        return;
      }

      container.innerHTML = '';
      container.className = 'scroll-wrap';
      container.style.cssText = '';

      // title
      const titleEl = Utils.buildChartTitleHtml(dataSet.title, container.clientWidth - 32);
      if (titleEl) container.appendChild(titleEl);

      const CELL_MIN = 263;
      const YLABEL_W = 48;
      const minWidth = YLABEL_W + n * CELL_MIN + (n) * 8;

      const grid = document.createElement('div');
      grid.className = 'echarts-pairplot';
      grid.style.gridTemplateColumns = `${YLABEL_W}px repeat(${n}, minmax(${CELL_MIN}px, 1fr))`;
      grid.style.minWidth = minWidth + 'px';
      container.appendChild(grid);

      // 기존 resize 핸들러 제거
      $(window).off(`resize.${id}`);

      const chartInstances = [];
      container.__pairPlotInstances = chartInstances;

      // significance 별표 계산
      const getSignificanceStars = (pVal) => {
        if (!pVal && pVal !== 0) return '';
        if (pVal <= 0.001) return '***';
        if (pVal <= 0.01) return '**';
        if (pVal <= 0.05) return '*';
        return '';
      };

      // 단순 선형 회귀
      const linearRegression = (xArr, yArr) => {
        const len = xArr.length;
        let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0;
        for (let i = 0; i < len; i++) {
          sumX += xArr[i];
          sumY += yArr[i];
          sumXY += xArr[i] * yArr[i];
          sumX2 += xArr[i] * xArr[i];
        }
        const slope = (len * sumXY - sumX * sumY) / (len * sumX2 - sumX * sumX);
        const intercept = (sumY - slope * sumX) / len;

        // 잔차 표준오차
        let ssRes = 0;
        for (let i = 0; i < len; i++) {
          const res = yArr[i] - (slope * xArr[i] + intercept);
          ssRes += res * res;
        }
        const se = Math.sqrt(ssRes / (len - 2));
        const meanX = sumX / len;
        let ssX = 0;
        for (let i = 0; i < len; i++) ssX += (xArr[i] - meanX) * (xArr[i] - meanX);

        return { slope, intercept, se, meanX, ssX, n: len };
      };

      // 셀별 지연 init 작업 (브라우저 부담 완화: 화면에 들어온 셀만 init)
      const lazyInitTasks = new Map();

      for (let row = 0; row < n; row++) {
        // Y축 라벨 셀 (각 row 왼쪽)
        const labelDiv = document.createElement('div');
        labelDiv.className = 'echarts-pairplot-ylabel';
        labelDiv.textContent = traits[row];
        grid.appendChild(labelDiv);

        for (let col = 0; col < n; col++) {
          const cellId = `${id}_cell_${row}_${col}`;
          const cellDiv = document.createElement('div');
          cellDiv.id = cellId;
          cellDiv.className = 'echarts-pairplot-cell';
          grid.appendChild(cellDiv);

          // ── 상삼각: 상관계수 텍스트 — ECharts 인스턴스 대신 plain HTML 로 렌더링 ──
          if (row < col) {
            const corr = correlations[row][col];
            const pVal = pValues ? pValues[row][col] : null;
            const stars = getSignificanceStars(pVal);
            const absFontSize = Math.min(Math.abs(corr) * 20 + 14, 28);

            const corrDiv = document.createElement('div');
            corrDiv.className = 'echarts-pairplot-corr';

            const corrLabel = document.createElement('span');
            corrLabel.className = 'echarts-pairplot-corr-label';
            corrLabel.textContent = 'Corr';
            corrDiv.appendChild(corrLabel);

            const corrValue = document.createElement('span');
            corrValue.className = 'echarts-pairplot-corr-value';
            corrValue.style.fontSize = absFontSize + 'px';
            corrValue.textContent = corr.toFixed(3) + stars;
            corrDiv.appendChild(corrValue);

            cellDiv.appendChild(corrDiv);
            continue;
          }

          const chartDiv = document.createElement('div');
          chartDiv.className = 'echarts-pairplot-chart';
          cellDiv.appendChild(chartDiv);

          const isLeft = col === 0;
          const isBottom = row === n - 1;
          const cellRow = row;
          const cellCol = col;

          // ── 지연 init: 뷰포트에 들어왔을 때 echarts.init + setOption 호출 ──
          const initFn = () => {
            const myChart = echarts.init(chartDiv);
            chartInstances.push(myChart);

            const silentTooltip = { show: false };
            let option;

            if (cellRow === cellCol) {
              // ── 대각선: 히스토그램 ──
              const values = data.map((d) => d[cellCol]);
              const mm = Utils._safeMinMax(values);
              const min = mm ? mm.min : 0;
              const max = mm ? mm.max : 1;
              const binCount = 7;
              const binWidth = (max - min) / binCount;
              const bins = new Array(binCount).fill(0);
              const binLabels = [];
              for (let i = 0; i < binCount; i++) {
                const lo = min + i * binWidth;
                binLabels.push(Math.round((lo + binWidth / 2) * 10) / 10);
              }
              values.forEach((v) => {
                let idx = Math.floor((v - min) / binWidth);
                if (idx >= binCount) idx = binCount - 1;
                if (idx < 0) idx = 0;
                bins[idx]++;
              });

              option = {
                color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
                tooltip: silentTooltip,
                grid: { left: isLeft ? 40 : 16, right: 16, top: 16, bottom: isBottom ? 40 : 16, containLabel: false },
                xAxis: {
                  type: 'category',
                  data: binLabels,
                  axisLine: { show: false },
                  axisTick: { show: false },
                  splitLine: { show: false },
                  axisLabel: {
                    show: isBottom,
                    color: '#79828d',
                    fontFamily: 'Pretendard',
                    fontSize: 14,
                    fontWeight: 500,
                    margin: 16,
                  },
                },
                yAxis: {
                  type: 'value',
                  axisLine: { show: false },
                  axisTick: { show: false },
                  axisLabel: {
                    show: isLeft,
                    color: '#79828d',
                    fontFamily: 'Pretendard',
                    fontSize: 14,
                    fontWeight: 500,
                  },
                },
                series: [{
                  type: 'bar',
                  data: bins,
                  barWidth: '70%',
                  silent: true,
                  itemStyle: {
                    color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                      { offset: 0, color: 'rgba(57, 184, 82, 1)' },
                      { offset: 1, color: 'rgba(57, 184, 82, 0.3)' },
                    ]),
                    borderColor: '#39b852',
                    borderWidth: 2,
                    borderRadius: [6, 6, 0, 0],
                  },
                }],
              };
            } else {
              // ── 하삼각: 산점도 + 회귀선 ──
              const xValues = data.map((d) => d[cellCol]);
              const yValues = data.map((d) => d[cellRow]);
              const scatterData = xValues.map((x, i) => [x, yValues[i]]);

              // 회귀선·신뢰구간 데이터 (category xAxis용)
              const bandXLabels = [];
              const regLineY = [];
              const lowerBandY = [];
              const bandWidthY = [];

              // 서버가 내려준 line[]/confidence_band.points[]을 우선 사용
              // (comparative1=x, comparative2=y 방향이 셀과 일치하는 경우에만)
              const xTrait = traits[cellCol];
              const yTrait = traits[cellRow];
              const serverPair = pairLookup[xTrait] && pairLookup[xTrait][yTrait];
              const hasServerCurves = serverPair
                && Array.isArray(serverPair.line) && serverPair.line.length > 0
                && serverPair.confidence_band
                && Array.isArray(serverPair.confidence_band.points)
                && serverPair.confidence_band.points.length > 0;

              if (hasServerCurves) {
                const cbPoints = serverPair.confidence_band.points;
                const linePoints = serverPair.line;
                const sameGrid = linePoints.length === cbPoints.length;
                const slope = serverPair.regression && typeof serverPair.regression.slope === 'number' ? serverPair.regression.slope : null;
                const intercept = serverPair.regression && typeof serverPair.regression.intercept === 'number' ? serverPair.regression.intercept : null;

                cbPoints.forEach((p, i) => {
                  bandXLabels.push(Math.round(p.x * 100) / 100);
                  lowerBandY.push(p.y_lower);
                  bandWidthY.push(p.y_upper - p.y_lower);
                  if (sameGrid) {
                    regLineY.push(linePoints[i].y);
                  } else if (slope !== null && intercept !== null) {
                    regLineY.push(slope * p.x + intercept);
                  } else {
                    regLineY.push(null);
                  }
                });
              } else {
                // fallback: 서버 데이터 없거나 방향 불일치 시 클라이언트에서 계산
                const reg = linearRegression(xValues, yValues);
                const xmm = Utils._safeMinMax(xValues);
                const xMin = xmm ? xmm.min : 0;
                const xMax = xmm ? xmm.max : 1;
                const step = (xMax - xMin) / 50;
                const t = 1.96;

                for (let x = xMin; x <= xMax; x += step) {
                  bandXLabels.push(Math.round(x * 100) / 100);
                  const y = reg.slope * x + reg.intercept;
                  regLineY.push(y);
                  const seY = reg.se * Math.sqrt(1 / reg.n + ((x - reg.meanX) * (x - reg.meanX)) / reg.ssX);
                  lowerBandY.push(y - t * seY);
                  bandWidthY.push(2 * t * seY);
                }
              }

              option = {
                color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
                tooltip: silentTooltip,
                grid: { left: isLeft ? 40 : 8, right: 16, top: 16, bottom: isBottom ? 40 : 8, containLabel: false },
                xAxis: [
                  {
                    // xAxis[0]: scatter용 value축
                    type: 'value',
                    scale: true,
                    splitNumber: 5,
                    axisLine: { show: false },
                    axisTick: { show: false },
                    splitLine: { show: false },
                    axisLabel: {
                      show: isBottom,
                      color: '#79828d',
                      fontFamily: 'Pretendard',
                      fontSize: 14,
                      fontWeight: 500,
                      margin: 16,
                    },
                  },
                  {
                    // xAxis[1]: 밴드·회귀선용 category축 (숨김)
                    type: 'category',
                    data: bandXLabels,
                    boundaryGap: false,
                    show: false,
                  },
                ],
                yAxis: {
                  type: 'value',
                  scale: true,
                  splitNumber: 5,
                  axisLine: { show: false },
                  axisTick: { show: false },
                  axisLabel: {
                    show: isLeft,
                    color: '#79828d',
                    fontFamily: 'Pretendard',
                    fontSize: 14,
                    fontWeight: 500,
                  },
                },
                series: [
                  {
                    // lower 베이스 (투명)
                    type: 'line',
                    xAxisIndex: 1,
                    data: lowerBandY,
                    smooth: false,
                    symbol: 'none',
                    lineStyle: { opacity: 0 },
                    areaStyle: { color: 'transparent' },
                    stack: 'band',
                    silent: true,
                    z: 2,
                  },
                  {
                    // upper - lower 차이 (색상 밴드)
                    type: 'line',
                    xAxisIndex: 1,
                    data: bandWidthY,
                    smooth: false,
                    symbol: 'none',
                    lineStyle: { opacity: 0 },
                    areaStyle: { color: 'rgba(245, 74, 74, 0.15)' },
                    stack: 'band',
                    silent: true,
                    z: 2,
                  },
                  {
                    type: 'scatter',
                    xAxisIndex: 0,
                    data: scatterData,
                    symbolSize: 5,
                    itemStyle: { color: '#ffa431', opacity: 0.7 },
                    silent: true,
                    z: 8,
                  },
                  {
                    // 회귀선
                    type: 'line',
                    xAxisIndex: 1,
                    data: regLineY,
                    smooth: false,
                    symbol: 'none',
                    lineStyle: { color: '#f54a4a', width: 2 },
                    silent: true,
                    z: 10,
                  },
                ],
              };
            }

            myChart.setOption(option);
          };

          lazyInitTasks.set(chartDiv, initFn);
        }
      }

      // x축 라벨 (하단 행)
      grid.appendChild(document.createElement('div')); // 왼쪽 빈 셀
      for (let col = 0; col < n; col++) {
        const label = document.createElement('div');
        label.className = 'echarts-pairplot-xlabel';
        label.textContent = traits[col];
        grid.appendChild(label);
      }

      // 보류 중인 모든 셀을 즉시 init (PDF 익스포트 등에서 호출)
      container.__pairPlotInitAll = () => {
        lazyInitTasks.forEach((fn) => fn());
        lazyInitTasks.clear();
        if (container.__pairPlotObserver) {
          try { container.__pairPlotObserver.disconnect(); } catch (e) {}
          container.__pairPlotObserver = null;
        }
      };

      // 뷰포트에 들어온 셀만 init 하여 초기 렌더 부담 완화
      if (typeof IntersectionObserver !== 'undefined' && lazyInitTasks.size > 0) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const fn = lazyInitTasks.get(entry.target);
            if (fn) {
              fn();
              lazyInitTasks.delete(entry.target);
            }
            io.unobserve(entry.target);
          });
        }, { rootMargin: '200px' });
        lazyInitTasks.forEach((_, chartDiv) => io.observe(chartDiv));
        container.__pairPlotObserver = io;
      } else {
        container.__pairPlotInitAll();
      }

      // 리사이즈 핸들러 (debounce: 90개 차트가 매 이벤트마다 동시에 resize 되는 것 방지)
      let resizeTimer = null;
      $(window).on(`resize.${id}`, () => {
        if (resizeTimer) clearTimeout(resizeTimer);
        resizeTimer = setTimeout(() => {
          chartInstances.forEach((c) => {
            try { if (c && !c.isDisposed()) c.resize(); } catch (e) {}
          });
        }, 120);
      });
    },
    /**
     * Set Cross Pair Plot Chart (표현형-환경 상관성 매트릭스)
     * 모든 셀이 산점도 + 회귀선 + 신뢰구간 + Corr 텍스트
     * correlation_graph_input.json 형식을 그대로 받아 dataList/correlation.pearson 로부터 매트릭스를 구성.
     * comparative1 → 행(yTraits, 표현형), comparative2 → 열(xTraits, 환경요소)
     * @param {String} id - 컨테이너 요소 ID
     * @param {Object} dataSet
     *   - title: {String|Object} 차트 제목 (optional)
     *   - dataList: [{ indvdId, clctYmd, value: { trait: number } }] — 산점도 원본
     *     또는 data: 2D 배열 (legacy, [x1,x2,...,y1,y2,...])
     *   - correlation: { pearson: [{ comparative1, comparative2, corr, p_value, regression, line, confidence_band }] }
     *     또는 correlations/pValues: 2D 행렬 (legacy)
     *   - xTraits/yTraits: 명시 시 사용, 생략 시 correlation.pearson[] 의 comparative2/comparative1 에서 자동 추출
     */
    setCrossPairPlotChart(id, dataSet) {
      const container = document.getElementById(id);
      if (!container) return;

      // 재호출 시 직전 ECharts 인스턴스들 정리 (n² 인스턴스가 누적되지 않도록)
      if (Array.isArray(container.__pairPlotInstances)) {
        container.__pairPlotInstances.forEach((c) => {
          try { if (c && typeof c.dispose === 'function' && !c.isDisposed()) c.dispose(); } catch (e) {}
        });
        container.__pairPlotInstances = null;
      }

      // ---- graph_input 구조 → (xTraits, yTraits, data, pearsonByPair) 정규화 ----
      const pearsonList = (dataSet.correlation && Array.isArray(dataSet.correlation.pearson))
        ? dataSet.correlation.pearson
        : null;

      let yTraits = Array.isArray(dataSet.yTraits) ? dataSet.yTraits.slice() : [];
      let xTraits = Array.isArray(dataSet.xTraits) ? dataSet.xTraits.slice() : [];
      if ((yTraits.length === 0 || xTraits.length === 0) && pearsonList) {
        const ySeen = new Set(yTraits);
        const xSeen = new Set(xTraits);
        pearsonList.forEach((p) => {
          if (p.comparative1 && !ySeen.has(p.comparative1)) { ySeen.add(p.comparative1); yTraits.push(p.comparative1); }
          if (p.comparative2 && !xSeen.has(p.comparative2)) { xSeen.add(p.comparative2); xTraits.push(p.comparative2); }
        });
      }

      let data = Array.isArray(dataSet.data) ? dataSet.data : null;
      if (!data && Array.isArray(dataSet.dataList)) {
        data = dataSet.dataList.map((item) => {
          const v = item && item.value ? item.value : {};
          const row = [];
          xTraits.forEach((t) => row.push(v[t]));
          yTraits.forEach((t) => row.push(v[t]));
          return row;
        });
      }
      data = data || [];

      const pearsonByPair = {};
      if (pearsonList) {
        pearsonList.forEach((p) => {
          if (!p.comparative1 || !p.comparative2) return;
          if (!pearsonByPair[p.comparative1]) pearsonByPair[p.comparative1] = {};
          pearsonByPair[p.comparative1][p.comparative2] = p;
        });
      }

      const correlations = Array.isArray(dataSet.correlations) ? dataSet.correlations : [];
      const pValues = Array.isArray(dataSet.pValues) ? dataSet.pValues : [];
      const nCols = xTraits.length;
      const nRows = yTraits.length;
      if (nCols === 0 || nRows === 0) {
        container.innerHTML = '';
        container.style.cssText = 'width:100%; height:100%;';
        const emptyChart = echarts.init(container);
        emptyChart.setOption({
          title: Utils.buildChartTitle(dataSet.title, container.clientWidth - 32),
          grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, 30), bottom: 80 },
          xAxis: { type: 'value', axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500 } },
          yAxis: { type: 'value', min: 0, max: 1, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500 } },
          series: [],
        });
        Utils.attachChartTitleResize(emptyChart, container, dataSet.title);
        $(window).off(`resize.${id}`).on(`resize.${id}`, () => emptyChart.resize());
        return;
      }

      container.innerHTML = '';
      container.className = 'scroll-wrap';
      container.style.cssText = '';

      const titleEl = Utils.buildChartTitleHtml(dataSet.title, container.clientWidth - 32);
      if (titleEl) container.appendChild(titleEl);

      const CELL_MIN = 263;
      const YLABEL_W = 48;
      const minWidth = YLABEL_W + nCols * CELL_MIN + nCols * 8;

      const grid = document.createElement('div');
      grid.className = 'echarts-pairplot';
      grid.style.gridTemplateColumns = `${YLABEL_W}px repeat(${nCols}, minmax(${CELL_MIN}px, 1fr))`;
      grid.style.minWidth = minWidth + 'px';
      container.appendChild(grid);

      $(window).off(`resize.${id}`);
      const chartInstances = [];
      container.__pairPlotInstances = chartInstances;

      const getSignificanceStars = (pVal) => {
        if (!pVal && pVal !== 0) return '';
        if (pVal <= 0.001) return '***';
        if (pVal <= 0.01) return '**';
        if (pVal <= 0.05) return '*';
        return '';
      };

      const linearRegression = (xArr, yArr) => {
        const len = xArr.length;
        let sumX = 0, sumY = 0, sumXY = 0, sumX2 = 0;
        for (let i = 0; i < len; i++) {
          sumX += xArr[i]; sumY += yArr[i]; sumXY += xArr[i] * yArr[i]; sumX2 += xArr[i] * xArr[i];
        }
        const slope = (len * sumXY - sumX * sumY) / (len * sumX2 - sumX * sumX);
        const intercept = (sumY - slope * sumX) / len;
        let ssRes = 0;
        for (let i = 0; i < len; i++) { const res = yArr[i] - (slope * xArr[i] + intercept); ssRes += res * res; }
        const se = Math.sqrt(ssRes / (len - 2));
        const meanX = sumX / len;
        let ssX = 0;
        for (let i = 0; i < len; i++) ssX += (xArr[i] - meanX) * (xArr[i] - meanX);
        return { slope, intercept, se, meanX, ssX, n: len };
      };

      // pearson 엔트리의 confidence_band/line/regression 으로부터 카테고리 Y축(=comparative1=표현형) 기준
      // 셀 X축(=comparative2=환경요소) 회귀선·신뢰구간을 구성
      const buildBandFromPearson = (entry) => {
        if (!entry) return null;
        const points = entry.confidence_band && Array.isArray(entry.confidence_band.points)
          ? entry.confidence_band.points : null;
        if (!points || points.length === 0) return null;
        const slope = entry.regression && typeof entry.regression.slope === 'number' ? entry.regression.slope : null;
        const intercept = entry.regression && typeof entry.regression.intercept === 'number' ? entry.regression.intercept : null;
        const lineArr = Array.isArray(entry.line) ? entry.line : null;
        const cats = points.map((p) => Math.round(p.x * 100) / 100);
        const lower = points.map((p) => p.y_lower);
        const widths = points.map((p) => p.y_upper - p.y_lower);
        let regLine;
        if (slope !== null && intercept !== null) {
          regLine = points.map((p) => slope * p.x + intercept);
        } else if (lineArr && lineArr.length === points.length) {
          regLine = lineArr.map((q) => q.y);
        } else {
          regLine = points.map((p) => (p.y_lower + p.y_upper) / 2);
        }
        return { cats, lower, widths, regLine };
      };

      // dataList/legacy data 만 있을 때(JSON 의 line/confidence_band 가 없을 때) 동일 레이아웃으로
      // 회귀선·신뢰구간을 폴백 계산. swap 레이아웃에 맞게 phenotype(Y)을 독립변수로 회귀.
      const fallbackBandFromCell = (envValues, phenotypeValues) => {
        if (!envValues.length || envValues.length < 2) return null;
        const reg = linearRegression(phenotypeValues, envValues);
        if (!isFinite(reg.slope) || !isFinite(reg.intercept) || !isFinite(reg.se)) return null;
        const ymm = Utils._safeMinMax(phenotypeValues);
        if (!ymm) return null;
        const yMin = ymm.min;
        const yMax = ymm.max;
        if (yMin === yMax) return null;
        const step = (yMax - yMin) / 50;
        const cats = [];
        const lower = [];
        const widths = [];
        const regLine = [];
        const t = 1.96;
        for (let y = yMin; y <= yMax; y += step) {
          cats.push(Math.round(y * 100) / 100);
          const x = reg.slope * y + reg.intercept;
          regLine.push(x);
          const seX = reg.se * Math.sqrt(1 / reg.n + ((y - reg.meanX) * (y - reg.meanX)) / reg.ssX);
          lower.push(x - t * seX);
          widths.push(2 * t * seX);
        }
        return { cats, lower, widths, regLine };
      };

      const silentTooltip = { show: false };

      for (let row = 0; row < nRows; row++) {
        // Y축 라벨 (comparative1 = 표현형)
        const labelDiv = document.createElement('div');
        labelDiv.className = 'echarts-pairplot-ylabel';
        labelDiv.textContent = yTraits[row];
        grid.appendChild(labelDiv);

        for (let col = 0; col < nCols; col++) {
          const cellId = `${id}_cell_${row}_${col}`;
          const cellDiv = document.createElement('div');
          cellDiv.id = cellId;
          cellDiv.className = 'echarts-pairplot-cell';
          grid.appendChild(cellDiv);

          const chartDiv = document.createElement('div');
          chartDiv.className = 'echarts-pairplot-chart';
          cellDiv.appendChild(chartDiv);

          const myChart = echarts.init(chartDiv);
          chartInstances.push(myChart);

          const isLeft = col === 0;
          const isBottom = row === nRows - 1;

          // 산점도 데이터: X = 환경요소(xTraits[col]=comparative2), Y = 표현형(yTraits[row]=comparative1)
          const xValues = data.map((d) => d[col]);
          const yValues = data.map((d) => d[nCols + row]);
          const scatterData = xValues.map((x, i) => [x, yValues[i]]);

          // pearson 매핑: comparative1=표현형(yTraits[row]), comparative2=환경요소(xTraits[col])
          const pearsonEntry = pearsonByPair[yTraits[row]] && pearsonByPair[yTraits[row]][xTraits[col]];
          const band = buildBandFromPearson(pearsonEntry) || fallbackBandFromCell(xValues, yValues);

          // Corr/pValue: pearson 엔트리 우선, 없으면 legacy 매트릭스 사용
          let corr = 0;
          let pVal = null;
          if (pearsonEntry && typeof pearsonEntry.corr === 'number') {
            corr = pearsonEntry.corr;
            pVal = typeof pearsonEntry.p_value === 'number' ? pearsonEntry.p_value : null;
          } else {
            corr = correlations[row] ? correlations[row][col] : 0;
            pVal = pValues[row] ? pValues[row][col] : null;
          }
          const stars = getSignificanceStars(pVal);
          const corrText = (typeof corr === 'number' ? corr.toFixed(3) : '0.000') + stars;

          const series = [];
          if (band) {
            series.push(
              { type: 'line', yAxisIndex: 1, stack: 'band', symbol: 'none', lineStyle: { opacity: 0 }, areaStyle: { opacity: 0 }, data: band.lower, silent: true, z: 1 },
              { type: 'line', yAxisIndex: 1, stack: 'band', symbol: 'none', lineStyle: { opacity: 0 }, areaStyle: { color: 'rgba(245, 74, 74, 0.15)' }, data: band.widths, silent: true, z: 1 },
              { type: 'line', yAxisIndex: 1, symbol: 'none', smooth: true, lineStyle: { color: '#f54a4a', width: 2 }, itemStyle: { color: '#f54a4a' }, data: band.regLine, silent: true, z: 5 },
            );
          }
          series.push({
            type: 'scatter', yAxisIndex: 0,
            data: scatterData, symbolSize: 6, silent: true,
            itemStyle: { color: '#ffa431', opacity: 0.7 },
            z: 3,
          });

          const option = {
            color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
            tooltip: silentTooltip,
            grid: { left: isLeft ? 40 : 16, right: 16, top: 40, bottom: isBottom ? 40 : 16, containLabel: false },
            graphic: [{
              type: 'text',
              left: 10,
              top: 2,
              silent: true,
              style: {
                text: `Corr: ${corrText}`,
                fill: '#79828d',
                fontSize: 13,
                fontFamily: 'Pretendard',
                fontWeight: 500,
              },
            }],
            xAxis: {
              type: 'value',
              scale: true,
              splitNumber: 5,
              axisLine: { show: false },
              axisTick: { show: false },
              splitLine: { show: false },
              axisLabel: {
                show: isBottom,
                color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500, margin: 16,
              },
            },
            yAxis: [
              {
                type: 'value',
                scale: true,
                splitNumber: 5,
                axisLine: { show: false },
                axisTick: { show: false },
                axisLabel: {
                  show: isLeft,
                  color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500,
                },
              },
              { type: 'category', data: band ? band.cats : [], show: false, boundaryGap: false },
            ],
            series,
          };

          myChart.setOption(option);
        }
      }

      // x축 라벨 (하단 행)
      grid.appendChild(document.createElement('div'));
      for (let col = 0; col < nCols; col++) {
        const label = document.createElement('div');
        label.className = 'echarts-pairplot-xlabel';
        label.textContent = xTraits[col];
        grid.appendChild(label);
      }

      $(window).on(`resize.${id}`, () => {
        chartInstances.forEach((c) => c.resize());
      });
    },
    /**
     * Set PCA Scatter Chart
     * @param {String} id - DOM element id
     * @param {Object} dataSet - clustering_graph_input.json 원본 형식을 그대로 지원
     *   권장(raw):
     *   - title: {String} chart title (optional)
     *   - pca_explained_variance_ratio: { PC1: Number, PC2: Number }
     *   - clusters: { clusterN: [{ indvdId, PC1, PC2, traits }, ...], ... }
     *   레거시(변환 완료 형식) 도 호환:
     *   - xLabel / yLabel: {String}
     *   - clusters: [{ name, color, data: [[x,y], ...] }, ...]
     */
    setPcaScatterChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // raw(clustering_graph_input.json) → 내부 렌더 형식으로 정규화
      const normalized = Utils._normalizePcaScatterDataSet(dataSet);
      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];
      const hasData = (normalized.clusters || []).some((c) => c.data && c.data.length > 0);

      const series = [];
      (normalized.clusters || []).forEach((cluster, idx) => {
        const clusterColor = cluster.color || chartColors[idx % chartColors.length];
        series.push({
          name: cluster.name,
          type: 'scatter',
          data: cluster.data,
          symbolSize: 8,
          itemStyle: {
            color: clusterColor,
            opacity: 0.8,
          },
        });
        // centroid 자동 계산 (데이터 평균)
        // if (cluster.data && cluster.data.length > 0) {
        //   const cx = cluster.data.reduce((s, d) => s + d[0], 0) / cluster.data.length;
        //   const cy = cluster.data.reduce((s, d) => s + d[1], 0) / cluster.data.length;
        //   series.push({
        //     name: cluster.name + ' centroid',
        //     type: 'scatter',
        //     data: [[Math.round(cx * 100) / 100, Math.round(cy * 100) / 100]],
        //     symbol: 'path://M13.414,12l6.293-6.293c.391-.391.391-1.023,0-1.414s-1.023-.391-1.414,0l-6.293,6.293-6.293-6.293c-.391-.391-1.023-.391-1.414,0s-.391,1.023,0,1.414l6.293,6.293-6.293,6.293c-.391.391-.391,1.023,0,1.414.195.195.451.293.707.293s.512-.098.707-.293l6.293-6.293,6.293,6.293c.195.195.451.293.707.293s.512-.098.707-.293c.391-.391.391-1.023,0-1.414l-6.293-6.293Z',
        //     symbolSize: 14,
        //     itemStyle: {
        //       color: clusterColor,
        //     },
        //     z: 10,
        //   });
        // }
      });

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(normalized.title, chartDom.clientWidth - 32),
        legend: {
          top: Utils.chartTitleTop(normalized.title, 0),
          textStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter: (params) => {
            const isCentroid = params.seriesName.endsWith('centroid');
            const color = params.color;
            const marker = isCentroid
              ? `<span style="display:inline-block;margin-right:6px;color:${color};font-size:14px;font-weight:700;line-height:1;vertical-align:middle;">✕</span>`
              : params.marker;
            const indvdId = params.data && params.data.indvdId;
            return `${marker}${params.seriesName}<br/>` +
              (indvdId ? `개체 아이디: ${indvdId}<br/>` : '') +
              `${normalized.xLabel || 'PC1'}: ${params.value[0]}<br/>` +
              `${normalized.yLabel || 'PC2'}: ${params.value[1]}`;
          },
        },
        xAxis: {
          type: 'value',
          min: hasData ? null : -1,
          max: hasData ? null : 1,
          name: normalized.xLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: true, lineStyle: { color: '#e0e0e0' } },
          axisTick: { show: false },
          splitLine: { show: true, lineStyle: { color: '#f0f0f0' } },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        yAxis: {
          type: 'value',
          min: hasData ? null : -1,
          max: hasData ? null : 1,
          name: normalized.yLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: true, lineStyle: { color: '#e0e0e0' } },
          axisTick: { show: false },
          splitLine: { show: true, lineStyle: { color: '#f0f0f0' } },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(normalized.title, 50), bottom: 80 },
        series,
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, normalized.title);
      Utils.attachValueAxisNameFit(myChart, chartDom);
      Utils.attachValueAxisXFit(myChart, chartDom);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },

    /**
     * cluster key/name (예: 'cluster1', 'cluster 1', 'cluster12') → 고정 팔레트 색상.
     * cluster 번호 N 을 추출해 항상 같은 색을 반환하므로 PCA 산점도와 덴드로그램이 동일 색을 공유한다.
     */
    _clusterColor(key) {
      const palette = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];
      const m = String(key == null ? '' : key).match(/(\d+)/);
      if (m) {
        const n = parseInt(m[1], 10);
        if (n >= 1) return palette[(n - 1) % palette.length];
      }
      return '#8b9496'; // 번호 없는 cluster(unknown 등) → 회색
    },

    /**
     * clustering_graph_input.json 원본 구조를 setPcaScatterChart 가 사용하는
     * { xLabel, yLabel, clusters: [{ name, color, data: [[x,y], ...] }] } 형태로 변환.
     * 이미 변환된 형식이면 그대로 반환.
     */
    _normalizePcaScatterDataSet(dataSet) {
      if (!dataSet) return { clusters: [] };

      const isRaw = dataSet.pca_explained_variance_ratio
        && dataSet.clusters
        && !Array.isArray(dataSet.clusters)
        && typeof dataSet.clusters === 'object';

      if (!isRaw) return dataSet;

      const pca = dataSet.pca_explained_variance_ratio || {};
      // cluster 번호 오름차순 정렬 (cluster10 이 cluster2 뒤로 가도록 숫자 비교) + 번호 기준 고정 색상
      const clusterNum = (k) => { const m = String(k).match(/(\d+)/); return m ? parseInt(m[1], 10) : Infinity; };
      const clusters = Object.entries(dataSet.clusters)
        .sort((a, b) => clusterNum(a[0]) - clusterNum(b[0]))
        .map(([key, items]) => ({
          name: /^cluster\d+$/.test(key) ? key.replace(/^cluster(\d+)$/, 'cluster $1') : key,
          color: Utils._clusterColor(key),
          data: (items || []).map((it) => (
            it.indvdId != null
              ? { value: [it.PC1, it.PC2], indvdId: it.indvdId }
              : [it.PC1, it.PC2]
          )),
        }));

      return {
        title: dataSet.title,
        xLabel: pca.PC1 != null ? `PC1 (${pca.PC1}%)` : 'PC1',
        yLabel: pca.PC2 != null ? `PC2 (${pca.PC2}%)` : 'PC2',
        clusters,
      };
    },

    /**
     * Set Dendrogram Chart
     * @param {String} id - DOM element id
     * @param {Object} dataSet - clustering_graph_input.json 원본 형식도 지원
     *   권장(raw):
     *   - dendrogram: { echarts_tree: { name, nodeId, height, sampleCount, children: [...] }, labels, linkage_matrix }
     *   - clusters (선택): { clusterN: [{ indvdId, ... }, ...] } → leaf 색상 자동 매핑
     *   또는 최상위에 `echarts_tree` 키만 전달해도 됨.
     *   레거시:
     *   - data, orient, leafColors, maxDistance, title
     */
    setDendrogramChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // raw(clustering_graph_input.json) → 내부 렌더 형식으로 정규화
      const normalized = Utils._normalizeDendrogramDataSet(dataSet);

      // 빈 데이터: 빈 차트만 렌더
      if (!normalized.data || !normalized.data.children || normalized.data.children.length === 0) {
        myChart.setOption({
          title: Utils.buildChartTitle(normalized.title, chartDom.clientWidth - 32),
          grid: { left: 80, right: 30, top: Utils.chartTitleTop(normalized.title, 30), bottom: 80 },
          xAxis: { type: 'value', axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500 } },
          yAxis: { type: 'value', min: 0, max: 1, axisLine: { show: false }, axisTick: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 14, fontWeight: 500 } },
          series: [],
        });
        Utils.attachChartTitleResize(myChart, chartDom, normalized.title);
        $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
        return;
      }

      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];

      // leafColors의 색 이름을 고유 순서대로 팔레트에 매핑
      const isVertical = (normalized.orient || 'TB') === 'TB';
      const leafColors = normalized.leafColors || [];
      const uniqueColors = [...new Set(leafColors)];
      const colorMap = {};
      uniqueColors.forEach((name, idx) => {
        colorMap[name] = chartColors[idx % chartColors.length];
      });

      // 모든 리프를 동일 깊이로 정렬 (x축에 일렬 배치)
      function getMaxDepth(node, depth) {
        if (!node.children || node.children.length === 0) return depth;
        return Math.max(...node.children.map((c) => getMaxDepth(c, depth + 1)));
      }
      function padToDepth(node, currentDepth, maxDepth) {
        if (!node.children || node.children.length === 0) {
          let wrapped = node;
          for (let i = currentDepth; i < maxDepth; i++) {
            wrapped = { name: '', children: [wrapped] };
          }
          return wrapped;
        }
        node.children = node.children.map((c) => padToDepth(c, currentDepth + 1, maxDepth));
        return node;
      }
      if (normalized.data) {
        const maxDepth = getMaxDepth(normalized.data, 0);
        padToDepth(normalized.data, 0, maxDepth);
      }
      // 리프 노드 색상 할당
      //  - raw: leaf 자신의 개체 ID 가 속한 cluster 색 (트리 DFS 순서와 무관하게 항상 일치)
      //  - 레거시(leafColors): 기존 위치 기반 방식 유지
      let leafIdx = 0;
      function assignColors(node) {
        if (!node.children || node.children.length === 0) {
          let resolved = null;
          if (node.clusterKey) {
            resolved = Utils._clusterColor(node.clusterKey);
          } else if (leafIdx < leafColors.length) {
            const c = leafColors[leafIdx];
            resolved = colorMap[c] || c;
          }
          if (resolved) {
            node.itemStyle = { color: resolved };
            node.label = { color: resolved };
          }
          leafIdx++;
        } else {
          node.children.forEach(assignColors);
        }
      }
      if (normalized.data) assignColors(normalized.data);

      // 리프 개수에 따라 최소 너비 보장 (가로스크롤)
      const MIN_LEAF_WIDTH = 20;
      function countLeaves(node) {
        if (!node.children || node.children.length === 0) return 1;
        return node.children.reduce((sum, c) => sum + countLeaves(c), 0);
      }
      const leafCount = normalized.data ? countLeaves(normalized.data) : 0;
      const minWidth = leafCount * MIN_LEAF_WIDTH + 100;
      const parentEl = chartDom.parentElement;
      if (parentEl && minWidth > parentEl.clientWidth) {
        $(parentEl).addClass('scroll-wrap');
        chartDom.style.width = minWidth + 'px';
      }
      myChart.resize();

      const maxDistance = normalized.maxDistance || 50;

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(normalized.title, chartDom.clientWidth - 32),
        tooltip: false,
        grid: {
          top: Utils.chartTitleTop(normalized.title, -10),
          bottom: 80,
          left: 80,
          right: 20,
        },
        xAxis: {
          type: 'value',
          show: false,
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: maxDistance,
          inverse: false,
          name: 'Distance',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: true, lineStyle: { color: '#e0e0e0' } },
          axisTick: { show: true, lineStyle: { color: '#e0e0e0' } },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 12,
            fontWeight: 500,
          },
        },
        series: [
          {
            type: 'tree',
            data: normalized.data ? [normalized.data] : [],
            orient: isVertical ? 'TB' : 'LR',
            top: isVertical ? -10 : 20,
            bottom: isVertical ? 80 : 20,
            left: isVertical ? 88 : 80,
            right: isVertical ? 20 : 20,
            symbol: 'none',
            symbolSize: 0,
            edgeShape: 'polyline',
            edgeForkPosition: '50%',
            initialTreeDepth: -1,
            silent: true,
            emphasis: { disabled: true },
            lineStyle: {
              color: '#8b9496',
              width: 1.5,
            },
            label: {
              show: false,
            },
            leaves: {
              symbol: 'circle',
              symbolSize: 8,
              label: {
                show: true,
                position: 'bottom',
                distance: 4,
                verticalAlign: 'middle',
                align: 'right',
                fontSize: 11,
                fontFamily: 'Pretendard',
                fontWeight: 500,
                color: '#79828d',
                rotate: 90,
              },
            },
            animationDurationUpdate: 750,
          },
        ],
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, normalized.title);
      Utils.attachValueAxisNameFit(myChart, chartDom);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },

    /**
     * clustering_graph_input.json 원본 구조를 setDendrogramChart 가 사용하는
     * { data, maxDistance, leafColors, orient, title } 형태로 변환.
     * raw 탐지:
     *   - dataSet.dendrogram.echarts_tree 가 있으면 전체 clustering_graph_input 객체
     *   - dataSet.echarts_tree 만 있으면 dendrogram 객체
     *   - 둘 다 없으면 레거시로 간주하고 그대로 반환.
     */
    _normalizeDendrogramDataSet(dataSet) {
      if (!dataSet) return { data: null };

      const dendro = dataSet.dendrogram && dataSet.dendrogram.echarts_tree
        ? dataSet.dendrogram
        : dataSet.echarts_tree
          ? dataSet
          : null;

      if (!dendro) return dataSet; // 레거시 포맷

      // clusters 가 있으면 개체 ID → clusterKey 매핑 (leaf 색상용)
      let idToCluster = null;
      if (dataSet.clusters && typeof dataSet.clusters === 'object') {
        idToCluster = {};
        Object.entries(dataSet.clusters).forEach(([key, items]) => {
          (items || []).forEach((it) => {
            if (it && it.indvdId) idToCluster[it.indvdId] = key;
          });
        });
      }

      // echarts_tree → 렌더 트리 (intermediate node name 제거, leaf는 nodeId 를 라벨로)
      // leaf 의 cluster 는 labels 순서가 아니라 leaf 자신의 ID 로 매핑해야 트리(DFS) 순서와 어긋나지 않음
      function convert(node) {
        const isLeaf = !node.children || node.children.length === 0;
        if (isLeaf) {
          const label = node.name != null ? String(node.name) : (node.nodeId || '');
          const leaf = { name: label, value: 1 };
          if (idToCluster) leaf.clusterKey = idToCluster[label] || 'unknown';
          return leaf;
        }
        return {
          name: '',
          children: node.children.map(convert),
        };
      }

      const data = convert(dendro.echarts_tree);
      const maxDistance = dendro.echarts_tree.height
        ? Math.ceil(dendro.echarts_tree.height * 1.05)
        : 50;

      return {
        title: dataSet.title,
        orient: dataSet.orient || 'TB',
        data,
        maxDistance,
      };
    },

    /**
     * Set Silhouette Score Chart
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - labels: {Array} x축 라벨 (군집 수, e.g. [2, 3, 4, ...])
     *   - data: {Array} 실루엣 점수 값
     *   - xLabel: {String} x축 라벨 (default: 'No. of clusters (k)')
     *   - yLabel: {String} y축 라벨 (default: 'Silhouette Score')
     */
    setSilhouetteChart(id, dataSet, renderOptions) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      renderOptions = renderOptions || {};
      if (!dataSet.data) dataSet.data = [];
      if (!dataSet.labels) dataSet.labels = [];
      const hasData = dataSet.data.length > 0;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const maxIdx = hasData ? dataSet.data.indexOf(Math.max(...dataSet.data)) : -1;

      const option = {
        animation: renderOptions.animation !== false,
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(dataSet.title, chartDom.clientWidth - 32),
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (!params || !params.length) return '';
            const p = params[0];
            return `${p.marker}k = ${p.name}<br/>Silhouette Score: ${p.value}`;
          },
        },
        grid: { left: 80, right: 20, top: Utils.chartTitleTop(dataSet.title, 30), bottom: 80 },
        xAxis: {
          type: 'category',
          data: dataSet.labels,
          name: dataSet.xLabel || 'Number of clusters (K)',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 1,
          name: dataSet.yLabel || 'Silhouette score',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: [
          {
            type: 'line',
            data: dataSet.data,
            lineStyle: { color: '#39b852', width: 2 },
            showSymbol: false,
            markLine: {
              silent: true,
              symbol: 'none',
              lineStyle: {
                color: '#1d1f20',
                width: 2,
                type: 'dashed',
              },
              data: [{ xAxis: maxIdx }],
              label: { show: false },
            },
          },
          {
            type: 'scatter',
            data: dataSet.data,
            symbol: 'circle',
            symbolSize: 8,
            itemStyle: { color: '#39b852' },
            silent: true,
            z: 10,
          },
        ],
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, dataSet.title);
      Utils.attachCategoryAxisFit(myChart, chartDom, {
        categories: dataSet.labels || [],
        gridLeft: 80, gridRight: 20, fontSize: 14, fontWeight: 500,
        baseBottom: 80, baseNameGap: 56,
      });
      Utils.attachValueAxisNameFit(myChart, chartDom);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },

    /**
     * Set Boxplot Chart
     * clustering_graph_input.json > clusters.clusterN[].traits.<형질> 원시값에서 5-number summary 를 계산해 렌더링
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - title: {String} chart title (생략 시 `${traitTitle}(${unitNm})` 자동)
     *   - traitTitle: {String} 원예형질명 (예: '과실길이')
     *   - unitNm: {String} 단위
     *   - clusters: [{ name, color, values: number[] }] — 개체별 형질값 배열
     *   - (legacy) categories, data, colors 도 허용
     */
    setBoxplotChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // 원시값 배열 → [min, Q1, median, Q3, max] (linear interpolation, numpy 기본)
      function fiveNumberSummary(values) {
        const nums = (values || [])
          .filter((v) => typeof v === 'number' && Number.isFinite(v))
          .slice()
          .sort((a, b) => a - b);
        if (nums.length === 0) return [0, 0, 0, 0, 0];
        const quantile = (arr, q) => {
          const pos = (arr.length - 1) * q;
          const base = Math.floor(pos);
          const rest = pos - base;
          return arr[base + 1] !== undefined
            ? arr[base] + rest * (arr[base + 1] - arr[base])
            : arr[base];
        };
        const round2 = (v) => Math.round(v * 100) / 100;
        return [
          round2(nums[0]),
          round2(quantile(nums, 0.25)),
          round2(quantile(nums, 0.5)),
          round2(quantile(nums, 0.75)),
          round2(nums[nums.length - 1]),
        ];
      }

      // clusters(원시값) → categories/data/colors 로 정규화
      if (Array.isArray(dataSet.clusters) && dataSet.clusters.length > 0) {
        const cs = dataSet.clusters;
        dataSet.categories = cs.map((c) => c.name || '');
        dataSet.data = cs.map((c) =>
          Array.isArray(c.summary) && c.summary.length === 5
            ? c.summary
            : fiveNumberSummary(c.values),
        );
        dataSet.colors = cs.map((c) => c.color);
      }

      // title 자동 조립
      if (!dataSet.title && dataSet.traitTitle) {
        dataSet.title = dataSet.unitNm
          ? `${dataSet.traitTitle}(${dataSet.unitNm})`
          : dataSet.traitTitle;
      }

      const hasData = (dataSet.data || []).length > 0;

      const colorMap = {
        blue: '#2863ff',
        lightblue: '#22b5ff',
        navy: '#342fe5',
        indigo: '#a307dd',
        purple: '#7528f0',
        pink: '#e83e8c',
        red: '#f54a4a',
        orange: '#ffa431',
        yellow: '#f0cb00',
        green: '#39b852',
        teal: '#20c997',
        cyan: '#37cec6',
        magenta: '#ff6ff9',
        gray: '#8b9496',
      };

      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];
      const hexToRgba = (hex, opacity) => {
        const r = parseInt(hex.substring(1, 3), 16);
        const g = parseInt(hex.substring(3, 5), 16);
        const b = parseInt(hex.substring(5, 7), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      const seriesData = (dataSet.data || []).map((item, idx) => {
        const rawColor = (dataSet.colors || [])[idx];
        const hexColor = colorMap[rawColor] || (typeof rawColor === 'string' && rawColor.indexOf('#') === 0 ? rawColor : chartColors[idx % chartColors.length]);
        return {
          value: item,
          itemStyle: {
            color: hexToRgba(hexColor, 0.25),
            borderColor: hexColor,
            borderWidth: 2,
          },
        };
      });

      const option = {
        color: chartColors,
        tooltip: {
          trigger: 'item',
          appendToBody: true,
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            const d = params.data.value || params.data;
            return `${params.marker}${params.name}<br/>` +
              `Max: ${d[4]}<br/>Q3: ${d[3]}<br/>Median: ${d[2]}<br/>Q1: ${d[1]}<br/>Min: ${d[0]}`;
          },
        },
        title: {
          text: dataSet.title || '',
          left: 'center',
          top: 0,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
        },
        grid: { left: 30, right: 30, top: Utils.chartTitleTop(dataSet.title, 30), bottom: 30 },
        xAxis: {
          type: 'category',
          data: dataSet.categories || [],
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 100,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: true, lineStyle: { color: '#f0f0f0' } },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: [
          {
            type: 'boxplot',
            data: seriesData,
            boxWidth: ['30%', '50%'],
            emphasis: {
              disabled: true,
            },
          },
        ],
      };

      myChart.setOption(option);
      Utils.attachCategoryAxisFit(myChart, chartDom, {
        categories: dataSet.categories || [],
        gridLeft: 30, gridRight: 30, fontSize: 14, fontWeight: 500,
        baseBottom: 30,
      });
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },

    /**
     * Set Multi Density Chart (군집별 KDE Overlay)
     * basic_statistic_graph_input.json 형식을 받아 각 그룹의 원시 values 로부터 통계량을 계산해 렌더링
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - title: {String|Object} 차트 타이틀
     *   - traitTitle: {String} 원예형질명 (예: '과실길이'). xLabel 자동 조립에 사용
     *   - yLabel: {String} y축 라벨 (default: 'Density')
     *   - unitNm: {String} 단위 (예: 'cm')
     *   - xLabel: {String} x축 라벨 (생략 시 `${traitTitle}(${unitNm})` 자동 조립)
     *   - clusters: [{ key, name, color, values }] — 각 그룹의 원시 관측값 배열
     *       · (legacy) {name, color, mean, std, min, max} 도 여전히 허용
     *       · color: 명명된 키(green/blue/red/orange/yellow/lightblue/navy/indigo/purple/pink/teal/cyan/magenta/gray) | hex 코드(#RRGGBB / #RGB) | 생략 시 자동 팔레트
     *   - showTotal: {Boolean} 전체 분포 점선 표시 여부 (default: true)
     *   - totalName: {String} 전체 라벨 (생략 시 '전체 (N: <합>)' 자동)
     *   - totalValues: {Array} 전체 원시값 (선택; 없으면 각 그룹 values 병합)
     */
    setMultiDensityChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      // 정규분포 밀도 함수
      function gaussianDensity(x, mean, std) {
        return (1 / (std * Math.sqrt(2 * Math.PI))) * Math.exp(-0.5 * Math.pow((x - mean) / std, 2));
      }

      // 원시값 배열로부터 count/mean/std/min/max 계산
      function computeStats(values) {
        const nums = (values || []).filter((v) => typeof v === 'number' && Number.isFinite(v));
        const count = nums.length;
        if (count === 0) return { count: 0, mean: 0, std: 0, min: 0, max: 0 };
        const mean = nums.reduce((a, b) => a + b, 0) / count;
        const variance = count > 1
          ? nums.reduce((acc, v) => acc + (v - mean) * (v - mean), 0) / (count - 1)
          : 0;
        return {
          count,
          mean,
          std: Math.sqrt(variance),
          min: Math.min.apply(null, nums),
          max: Math.max.apply(null, nums),
        };
      }

      // 각 cluster 정규화: values 가 있으면 통계 계산, 없으면 legacy 필드 사용
      const clusters = (dataSet.clusters || [])
        .map((c) => {
          if (Array.isArray(c.values)) {
            const s = computeStats(c.values);
            const displayName = /\(N\s*:/.test(c.name || '')
              ? c.name
              : `${c.name || c.key || ''}${s.count > 0 ? ` (N: ${new Intl.NumberFormat('ko-KR').format(s.count)})` : ''}`;
            return { ...c, name: displayName, ...s };
          }
          return c;
        })
        .filter((c) => c.std > 0);

      const hasData = clusters.length > 0;
      let globalMin = 0, globalMax = 1;
      if (hasData) {
        globalMin = Infinity;
        globalMax = -Infinity;
        clusters.forEach((c) => {
          const pad = c.std * 0.5;
          if (c.min - pad < globalMin) globalMin = c.min - pad;
          if (c.max + pad > globalMax) globalMax = c.max + pad;
        });
      }
      const step = (globalMax - globalMin) / 200;

      // xLabel 자동 조립 (graph_input 방식: traitTitle + unitNm)
      if (!dataSet.xLabel && dataSet.traitTitle) {
        dataSet.xLabel = dataSet.unitNm
          ? `${dataSet.traitTitle}(${dataSet.unitNm})`
          : dataSet.traitTitle;
      }

      // totalName 자동 조립
      if (dataSet.showTotal !== false && !dataSet.totalName) {
        const totalN = Array.isArray(dataSet.totalValues)
          ? dataSet.totalValues.filter((v) => typeof v === 'number' && Number.isFinite(v)).length
          : clusters.reduce((sum, c) => sum + (c.count || 0), 0);
        if (totalN > 0) dataSet.totalName = `전체 (N: ${new Intl.NumberFormat('ko-KR').format(totalN)})`;
      }

      const series = [];

      // 각 클러스터 밀도 곡선
      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];
      const colorMap = {
        blue: '#2863ff',
        lightblue: '#22b5ff',
        navy: '#342fe5',
        indigo: '#a307dd',
        purple: '#7528f0',
        pink: '#e83e8c',
        red: '#f54a4a',
        orange: '#ffa431',
        yellow: '#f0cb00',
        green: '#39b852',
        teal: '#20c997',
        cyan: '#37cec6',
        magenta: '#ff6ff9',
        gray: '#8b9496',
      };
      const hexToRgba = (hex, opacity) => {
        if (!hex || hex.indexOf('#') !== 0) return hex;
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
          r = parseInt(hex[1] + hex[1], 16);
          g = parseInt(hex[2] + hex[2], 16);
          b = parseInt(hex[3] + hex[3], 16);
        } else if (hex.length === 7) {
          r = parseInt(hex.substring(1, 3), 16);
          g = parseInt(hex.substring(3, 5), 16);
          b = parseInt(hex.substring(5, 7), 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      clusters.forEach((cluster, idx) => {
        const rawColor = cluster.color;
        const lineColor = colorMap[rawColor] || (typeof rawColor === 'string' && rawColor.indexOf('#') === 0 ? rawColor : chartColors[idx % chartColors.length]);
        const fillColor = hexToRgba(lineColor, 0.15);
        const densityData = [];
        for (let x = globalMin; x <= globalMax; x += step) {
          const xVal = x;
          densityData.push([xVal, gaussianDensity(xVal, cluster.mean, cluster.std)]);
        }
        series.push({
          name: cluster.name,
          type: 'line',
          smooth: true,
          symbol: 'none',
          lineStyle: { color: lineColor, width: 1 },
          areaStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: fillColor.replace('0.15)', '0.6)') },
              { offset: 1, color: fillColor },
            ]),
          },
          itemStyle: { color: lineColor, opacity: 0 },
          data: densityData,
        });
      });

      // 전체 분포 점선
      if (dataSet.showTotal !== false && clusters.length > 1) {
        const totalData = [];
        for (let x = globalMin; x <= globalMax; x += step) {
          const xVal = x;
          let totalDensity = 0;
          clusters.forEach((c) => { totalDensity += gaussianDensity(xVal, c.mean, c.std); });
          totalDensity /= clusters.length;
          totalData.push([xVal, totalDensity]);
        }
        series.push({
          name: dataSet.totalName || '전체',
          type: 'line',
          smooth: true,
          symbol: 'none',
          lineStyle: { color: '#1d1f20', width: 1, type: 'dashed' },
          areaStyle: { opacity: 0 },
          data: totalData,
        });
      }

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        tooltip: {
          trigger: 'axis',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (!params || !params.length) return '';
            let result = `${Math.round(params[0].value[0] * 100) / 100}`;
            params.forEach((p) => {
              const s = series[p.seriesIndex];
              const lineColor = s ? s.lineStyle.color : (p.borderColor || p.color);
              const isDashed = s && s.lineStyle && s.lineStyle.type === 'dashed';
              const markerStyle = isDashed
                ? `width:16px;height:0;border-top:2px dashed ${lineColor};`
                : `width:16px;height:2px;background:${lineColor};`;
              const marker = `<span style="display:inline-block;margin-right:6px;${markerStyle}vertical-align:middle;"></span>`;
              result += `<br/>${marker}${p.seriesName}: ${Math.round(p.value[1] * 10000) / 10000}`;
            });
            return result;
          },
        },
        title: Utils.buildChartTitle(dataSet.title, chartDom.clientWidth - 32),
        legend: {
          top: Utils.chartTitleTop(dataSet.title, 0),
          itemWidth: 25,
          itemHeight: 3,
          data: [
            ...clusters.map((c) => ({ name: c.name })),
            ...(dataSet.showTotal !== false && clusters.length > 1
              ? [{
                  name: dataSet.totalName || '전체',
                  icon: 'path://M0,0 L6,0 L6,3 L0,3 Z M10,0 L16,0 L16,3 L10,3 Z M20,0 L26,0 L26,3 L20,3 Z',
                  itemStyle: { color: '#1d1f20' },
                }]
              : []),
          ],
          textStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
        },
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, 50), bottom: 80 },
        xAxis: {
          type: 'value',
          name: dataSet.xLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 1,
          name: dataSet.yLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: true, lineStyle: { color: '#f0f0f0' } },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series,
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, dataSet.title);
      Utils.attachValueAxisNameFit(myChart, chartDom);
      Utils.attachValueAxisXFit(myChart, chartDom);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },

    /**
     * Set Category Grouped Bar Chart (항목형 데이터 그룹별 비교)
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - categories: {Array} x축 카테고리 (e.g. ['미성숙', '반성숙', '성숙'])
     *   - series: [{name, color, data}, ...] 각 그룹 데이터
     *   - xLabel: {String} x축 라벨
     *   - yLabel: {String} y축 라벨
     */
    setCategoryBarChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();

      // series 개수와 카테고리 개수에 따라 최소 너비 보장 (가로스크롤)
      const BAR_WIDTH = 48;
      const BAR_GAP = 5;
      const CATEGORY_GAP = 40;
      const seriesCount = (dataSet.series || []).length;
      const catLen = (dataSet.categories || []).length;
      const perCat = seriesCount * BAR_WIDTH + Math.max(0, seriesCount - 1) * BAR_GAP + CATEGORY_GAP;
      const minWidth = catLen * perCat + 110; // grid left 80 + right 30
      const parentEl = chartDom.parentElement;
      // parent가 이전 렌더에서 scroll-wrap+넓은 chartDom을 가졌다면 clientWidth가 부풀려질 수 있으므로 초기화 후 측정
      if (parentEl) {
        $(parentEl).removeClass('scroll-wrap');
        parentEl.style.overflowX = '';
        parentEl.style.minWidth = '';
      }
      chartDom.style.width = '';
      const availWidth = parentEl ? parentEl.clientWidth : 0;
      if (parentEl && minWidth > availWidth) {
        $(parentEl).addClass('scroll-wrap');
        parentEl.style.overflowX = 'auto';
        parentEl.style.minWidth = '0'; // flex item min-width:auto 무력화
        chartDom.style.width = minWidth + 'px';
      }

      myChart = echarts.init(chartDom);

      const colorMap = {
        blue: '#2863ff',
        lightblue: '#22b5ff',
        navy: '#342fe5',
        indigo: '#a307dd',
        purple: '#7528f0',
        pink: '#e83e8c',
        red: '#f54a4a',
        orange: '#ffa431',
        yellow: '#f0cb00',
        green: '#39b852',
        teal: '#20c997',
        cyan: '#37cec6',
        magenta: '#ff6ff9',
        gray: '#8b9496',
      };

      const hexToRgba = (hex, opacity) => {
        if (!hex || hex.indexOf('#') !== 0) return hex;
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
          r = parseInt(hex[1] + hex[1], 16);
          g = parseInt(hex[2] + hex[2], 16);
          b = parseInt(hex[3] + hex[3], 16);
        } else if (hex.length === 7) {
          r = parseInt(hex.substring(1, 3), 16);
          g = parseInt(hex.substring(3, 5), 16);
          b = parseInt(hex.substring(5, 7), 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];

      const hasData = (dataSet.series || []).some((s) => (s.data || []).some((v) => v > 0));

      const series = (dataSet.series || []).map((item, idx) => {
        const rawColor = item.color;
        const hexColor = colorMap[rawColor] || (typeof rawColor === 'string' && rawColor.indexOf('#') === 0 ? rawColor : chartColors[idx % chartColors.length]);
        const seriesTotal = (item.data || []).reduce((sum, v) => sum + v, 0);
        return {
          name: item.name,
          type: 'bar',
          data: item.data,
          barGap: '10%',
          barMaxWidth: 48,
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: hexToRgba(hexColor, 1) },
              { offset: 1, color: hexToRgba(hexColor, 0.3) },
            ]),
            borderColor: hexColor,
            borderWidth: 2,
            borderRadius: [8, 8, 0, 0],
          },
          label: {
            show: true,
            position: 'top',
            color: '#676e78',
            fontFamily: 'Pretendard',
            fontSize: 11,
            fontWeight: 500,
            formatter(params) {
              const pct = seriesTotal > 0 ? ((params.value / seriesTotal) * 100).toFixed(1) : '0.0';
              return `${new Intl.NumberFormat('ko-KR').format(params.value)}\n(${pct}%)`;
            },
          },
        };
      });

      // 단일 데이터 분석(시리즈 1개)은 범례가 의미 없어 표시하지 않는다 — 수치형 setDensityChart 와 동일한 관례
      const showLegend = series.length > 1;

      const option = {
        color: chartColors,
        title: Utils.buildChartTitle(dataSet.title, chartDom.clientWidth - 32),
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (!params || !params.length) return '';
            let result = `${params[0].name}`;
            params.forEach((p) => {
              const isScatter = p.seriesType === 'scatter';
              const s = series[p.seriesIndex];
              const solidColor = isScatter ? (p.color || '#1d1f20') : (s && s.itemStyle ? s.itemStyle.borderColor : p.color);
              const style = isScatter
                ? `width:12px;height:12px;border-radius:50%;`
                : `width:12px;height:12px;border-radius:2px;`;
              const bg = isScatter
                ? `background-color:${solidColor};`
                : `background:linear-gradient(to bottom, ${solidColor}, ${hexToRgba(solidColor, 0.3)});`;
              const marker = `<span style="display:inline-block;margin-right:6px;border:1px solid ${solidColor};${style}${bg}"></span>`;
              result += `<br/>${marker}${p.seriesName}: ${p.value}`;
            });
            return result;
          },
        },
        legend: {
          show: showLegend,
          top: Utils.chartTitleTop(dataSet.title, 0),
          itemWidth: 14,
          itemHeight: 14,
          textStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
        },
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, showLegend ? 50 : 30), bottom: 80 },
        xAxis: {
          type: 'category',
          data: dataSet.categories || [],
          name: dataSet.xLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 100,
          name: dataSet.yLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series,
      };

      // legend data: 바는 roundRect, 평균은 circle
      const legendData = series.map((s) => ({
        name: s.name,
        icon: 'roundRect',
      }));

      // 평균 Count를 dot(scatter)로 추가 — series에서 자동 계산 (series가 2개 이상일 때만)
      const seriesDataArrays = (dataSet.series || []).map((s) => s.data || []);
      if (seriesDataArrays.length > 1 && catLen > 0) {
        const avgName = (dataSet.average && dataSet.average.name) || '평균 Count';
        const avgData = [];
        for (let i = 0; i < catLen; i++) {
          let sum = 0, cnt = 0;
          seriesDataArrays.forEach((d) => {
            if (i < d.length && d[i] != null) { sum += d[i]; cnt++; }
          });
          avgData.push(cnt > 0 ? Math.round((sum / cnt) * 10) / 10 : 0);
        }
        option.series.push({
          name: avgName,
          type: 'scatter',
          data: avgData,
          symbol: 'circle',
          symbolSize: 10,
          itemStyle: { color: '#1d1f20' },
          z: 10,
        });
        legendData.push({ name: avgName, icon: 'circle' });
      }

      option.legend.data = legendData;

      myChart.setOption(option);
      myChart.resize();
      Utils.attachChartTitleResize(myChart, chartDom, dataSet.title);
      Utils.attachCategoryAxisFit(myChart, chartDom, {
        categories: dataSet.categories || [],
        gridLeft: 80, gridRight: 30, fontSize: 14, fontWeight: 500,
        baseBottom: 80, baseNameGap: 56,
      });
      Utils.attachValueAxisNameFit(myChart, chartDom);
      $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
    },

    /**
     * Set Category Bubble Chart (범주형 버블 차트)
     * 단일 grid에 카테고리별 패널을 graphic으로 구분, 버블 크기=count, 색상=qvalue
     * @param {String} id - DOM element id
     * @param {Object} dataSet
     *   - categories: {Array<String>} 패널 헤더 (ex: ['미성숙','반성숙','성숙','완숙','과성숙'])
     *   - groups: {Array<String>} X축 그룹명 (ex: ['데이터 1','데이터 2','데이터 3'])
     *   - data: {Array<Object>} [{ group, category, count, qvalue }, ...]
     *   - minColumnWidth: {Number} 컬럼당 최소 폭(px). 데이터가 많아 가로 공간이 부족하면
     *                     캔버스에 min-width 가 적용되고 컨테이너에 가로 스크롤이 생긴다. (default 40)
     */
    setCategoryBubbleChart(id, dataSet, renderOptions) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;
      renderOptions = renderOptions || {};

      // 래퍼 구성: [scrollWrap(가로 스크롤) > chartArea] | legendArea(고정)
      chartDom.innerHTML = '';
      chartDom.style.display = 'flex';
      chartDom.style.alignItems = 'stretch';

      const scrollWrap = document.createElement('div');
      scrollWrap.className = 'scroll-wrap';
      scrollWrap.style.cssText = 'flex:1; min-width:0; height:100%; overflow-y:hidden;';
      chartDom.appendChild(scrollWrap);

      const chartArea = document.createElement('div');
      chartArea.style.cssText = 'width:100%; height:100%;';
      scrollWrap.appendChild(chartArea);

      const categories = dataSet.categories || [];
      const groups = dataSet.groups || [];
      const items = dataSet.data || [];

      // 빈 데이터: 빈 차트만 렌더
      if (categories.length === 0 || groups.length === 0 || items.length === 0) {
        let myChart = echarts.getInstanceByDom(chartArea);
        if (myChart) myChart.dispose();
        myChart = echarts.init(chartArea);
        myChart.setOption({
          title: Utils.buildChartTitle(dataSet.title, chartArea.clientWidth - 32),
          grid: { left: 50, right: 10, top: Utils.chartTitleTop(dataSet.title, 40), bottom: 55 },
          xAxis: { type: 'category', data: [''], axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false } },
          yAxis: { type: 'value', min: 0, max: 1, axisLine: { show: false }, axisTick: { show: false }, splitLine: { show: false }, axisLabel: { color: '#79828d', fontFamily: 'Pretendard', fontSize: 12, fontWeight: 500 } },
          series: [],
        });
        Utils.attachChartTitleResize(myChart, chartArea, dataSet.title);
        $(window).off('resize.' + id).on('resize.' + id, () => myChart.resize());
        return;
      }

      const legendArea = document.createElement('div');
      legendArea.style.cssText = 'width:96px; display:flex; flex-direction:column; justify-content:flex-start; padding:30px 8px 0 8px; gap:20px; flex-shrink:0;';
      chartDom.appendChild(legendArea);

      const maxCount = Math.max(...items.map((d) => d.count), 1);
      const minSize = 4;
      const maxSize = 18;

      // qvalue → 색상 (0=빨강 #f54a4a, 0.5=흰, 1=파랑 #2863ff)
      function getColor(qvalue) {
        const t = Math.min(Math.max(qvalue, 0), 1);
        if (t <= 0.5) {
          const s = t / 0.5;
          return `rgb(${Math.round(245 + 10 * s)},${Math.round(74 + 181 * s)},${Math.round(74 + 181 * s)})`;
        }
        const s = (t - 0.5) / 0.5;
        return `rgb(${Math.round(255 - 215 * s)},${Math.round(255 - 156 * s)},255)`;
      }

      // X축: 카테고리별로 그룹을 배치 (패널 간 간격 + 좌우 패딩 포함)
      const xLabels = [];
      const panelBoundaries = [];

      categories.forEach((cat, ci) => {
        const panelStart = xLabels.length;
        xLabels.push(''); // 좌측 패딩
        const dataStart = xLabels.length;
        groups.forEach((g) => xLabels.push(g));
        const dataEnd = xLabels.length - 1;
        xLabels.push(''); // 우측 패딩
        const panelEnd = xLabels.length - 1;
        panelBoundaries.push({
          start: panelStart,
          end: panelEnd,
          dataStart,
          center: (dataStart + dataEnd) / 2,
          name: cat,
        });
      });

      // 데이터(컬럼) 수가 많아지면 캔버스 min-width 를 키워 가로 스크롤로 노출 → 버블 겹침 방지
      const minColumnWidth = dataSet.minColumnWidth || 28;
      const gridSidePadding = 60; // grid.left(50) + grid.right(10)
      const minCanvasWidth = xLabels.length * minColumnWidth + gridSidePadding;
      chartArea.style.minWidth = minCanvasWidth + 'px';

      // scatter 데이터 생성
      const scatterData = items
        .filter((d) => d.count > 0)
        .map((d) => {
          const ci = categories.indexOf(d.category);
          const gi = groups.indexOf(d.group);
          if (ci < 0 || gi < 0) return null;
          const xIdx = panelBoundaries[ci].dataStart + gi;
          return {
            value: [xIdx, d.qvalue],
            symbolSize: minSize + ((d.count / maxCount) * (maxSize - minSize)),
            itemStyle: {
              color: getColor(d.qvalue),
              borderColor: '#ddd',
              borderWidth: 0.5,
            },
            _raw: d,
          };
        })
        .filter(Boolean);

      let myChart = echarts.getInstanceByDom(chartArea);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartArea);

      // 패널 구분선 + 제목을 graphic으로 생성 (setOption 후 convertToPixel 사용)
      const buildGraphic = () => {
        const graphicElements = [];

        const gridRect = myChart.getModel().getComponent('grid', 0).coordinateSystem.getRect();
        const y1 = gridRect.y;
        const y2 = gridRect.y + gridRect.height;

        panelBoundaries.forEach((panel) => {
          const x1 = myChart.convertToPixel({ xAxisIndex: 0 }, panel.start);
          const x2 = myChart.convertToPixel({ xAxisIndex: 0 }, panel.end);

          // 패널 내부 수평 격자선 (0, 0.2, 0.4, 0.6, 0.8, 1.0)
          for (let v = 0; v <= 1; v = Math.round((v + 0.2) * 10) / 10) {
            const py = myChart.convertToPixel({ yAxisIndex: 0 }, v);
            graphicElements.push({
              type: 'line',
              shape: { x1, y1: py, x2, y2: py },
              style: { stroke: '#f0f0f0', lineWidth: 1 },
              z: -2,
              silent: true,
            });
          }

          // 패널 내부 수직 격자선 (각 데이터 포인트 위치)
          for (let idx = panel.dataStart; idx <= panel.dataStart + groups.length - 1; idx++) {
            const px = myChart.convertToPixel({ xAxisIndex: 0 }, idx);
            graphicElements.push({
              type: 'line',
              shape: { x1: px, y1, x2: px, y2 },
              style: { stroke: '#f0f0f0', lineWidth: 1 },
              z: -2,
              silent: true,
            });
          }

          // 패널 테두리
          graphicElements.push({
            type: 'rect',
            shape: { x: x1, y: y1, width: x2 - x1, height: y2 - y1 },
            style: { fill: 'none', stroke: '#e0e0e0', lineWidth: 1 },
            z: -1,
            silent: true,
          });

          // 패널 제목
          graphicElements.push({
            type: 'text',
            style: {
              text: panel.name,
              x: (x1 + x2) / 2,
              y: y1 - 24,
              fill: '#79828d',
              font: '500 13px Pretendard',
              textAlign: 'center',
            },
            silent: true,
          });
        });

        myChart.setOption({ graphic: graphicElements });
      };

      myChart.setOption({
        title: Utils.buildChartTitle(dataSet.title, chartArea.clientWidth - 32),
        grid: { left: 50, right: 10, top: Utils.chartTitleTop(dataSet.title, 40), bottom: 55 },
        xAxis: {
          type: 'category',
          data: xLabels,
          axisLine: { show: false },
          axisTick: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 11,
            fontWeight: 500,
            interval: 0,
            rotate: -45,
          },
        },
        yAxis: {
          type: 'value',
          min: -0.2,
          max: 1,
          interval: 0.2,
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 12,
            fontWeight: 500,
            formatter(v) { return v < 0 ? '' : Utils.formatPValue(v); },
          },
        },
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            const raw = params.data && params.data._raw;
            if (!raw) return '';
            const color = params.data.itemStyle && params.data.itemStyle.color;
            const marker = `<span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};margin-right:6px;"></span>`;
            return `${marker}${raw.group}<br/>${raw.category}<br/>Count: ${raw.count}<br/>q-value: ${Utils.formatPValue(raw.qvalue)}`;
          },
        },
        series: [{
          type: 'scatter',
          data: scatterData,
          symbol: 'circle',
          clip: false,
        }],
      });
      Utils.attachChartTitleResize(myChart, chartArea, dataSet.title);

      // graphic은 차트 렌더링 이후에 좌표 변환 가능.
      // export에서는 완료 Promise를 노출해 캡처가 graphic 생성을 확실히 기다리게 한다.
      if (renderOptions.export) {
        chartDom.__chartExportReady = new Promise((resolve, reject) => {
          setTimeout(() => {
            try {
              buildGraphic();
              resolve();
            } catch (error) {
              reject(error);
            }
          }, 0);
        });
      } else {
        setTimeout(buildGraphic, 0);
      }

      // --- Count 크기 범례 ---
      const legendMinSize = 4;
      const legendMaxSize = 18;
      // 데이터 범위와 무관하게 약 5~6개의 "nice" step 으로 압축 (가독성 + export 단순화)
      const targetStepCount = 5;
      const niceStep = (raw) => {
        if (raw <= 1) return 1;
        const exp = Math.pow(10, Math.floor(Math.log10(raw)));
        const f = raw / exp;
        const nice = f <= 1 ? 1 : f <= 2 ? 2 : f <= 5 ? 5 : 10;
        return nice * exp;
      };
      const step = niceStep(Math.max(1, maxCount / targetStepCount));
      const countSteps = [];
      for (let v = 0; v <= maxCount; v += step) countSteps.push(v);
      if (countSteps[countSteps.length - 1] < maxCount) {
        countSteps.push(Math.ceil(maxCount / step) * step);
      }
      let countHtml = '<div style="color:#555; font-family:Pretendard; font-size:12px; font-weight:600; margin-bottom:8px;">Count</div>';
      countSteps.forEach((c) => {
        // c 가 maxCount 를 넘는 nice-step 끝값일 수 있으므로 ratio 를 1 로 클램프 → 래퍼(18px) 초과 방지
        const ratio = Math.min(1, c / maxCount);
        const size = Math.round(legendMinSize + ratio * (legendMaxSize - legendMinSize));
        countHtml += `<div style="display:flex; align-items:center; gap:8px; margin-bottom:6px;">
          <span style="display:inline-flex; align-items:center; justify-content:center; width:${legendMaxSize}px; height:${legendMaxSize}px; flex-shrink:0;">
            <span style="display:block; width:${size}px; height:${size}px; border-radius:50%; background:#555;"></span>
          </span>
          <span style="color:#79828d; font-family:Pretendard; font-size:11px;">${c}</span>
        </div>`;
      });
      const countDiv = document.createElement('div');
      countDiv.innerHTML = countHtml;
      legendArea.appendChild(countDiv);

      // --- q-value 색상 범례 ---
      const colorDiv = document.createElement('div');
      colorDiv.innerHTML = `
        <div style="color:#555; font-family:Pretendard; font-size:12px; font-weight:600; margin-bottom:8px;">q-value</div>
        <div style="display:flex; align-items:stretch; gap:6px;">
          <div style="width:14px; height:80px; border-radius:3px; border:1px solid #e0e0e0; background:linear-gradient(to bottom, #2863ff, #ffffff, #f54a4a);"></div>
          <div style="display:flex; flex-direction:column; justify-content:space-between;">
            <span style="color:#79828d; font-family:Pretendard; font-size:11px;">1.0</span>
            <span style="color:#79828d; font-family:Pretendard; font-size:11px;">0.5</span>
            <span style="color:#79828d; font-family:Pretendard; font-size:11px;">0.0</span>
          </div>
        </div>`;
      legendArea.appendChild(colorDiv);

      $(window).off('resize.' + id).on('resize.' + id, () => {
        myChart.resize();
        setTimeout(buildGraphic, 0);
      });
    },

    /**
     * Set Trend Band Chart (그룹별 평균 추세 + 최소/최대 밴드)
     * @param {String} id
     * @param {Object} dataSet
     *   [공통] title, xLabel, yLabel
     *
     *   [형식 A] 사전 집계된 시리즈 형식
     *   - labels, series[].{name, data(평균), upper(상한), lower(하한)}
     *
     *   [형식 B] individual_growth_rate_graph_input.json[<형질>] 형식 그대로
     *   - groups: { groupN: [{ clctYmd, mean, min, max }, ...] }
     *     또는 dataSet 최상위에 groupN 키를 직접 펼친 형태
     *   → 내부 변환:
     *      1) clctYmd 에서 연도(YYYY) 추출 (xUnit:'date' 지정 시 일자 그대로)
     *      2) 모든 그룹의 라벨 합집합을 x축으로
     *      3) 그룹별 알려진 두 포인트 사이 결측 라벨은 mean/min/max 선형 보간
     *         (그룹의 알려진 범위 밖은 null 로 두어 외삽하지 않음)
     */
    setTrendBandChart(id, dataSet) {
      const chartDom = document.getElementById(id);
      if (!chartDom) return;

      // 형식 B → 형식 A 자동 변환
      let groups = null;
      if (dataSet.groups && typeof dataSet.groups === 'object' && !Array.isArray(dataSet.groups)) {
        groups = dataSet.groups;
      } else {
        const gKeys = Object.keys(dataSet).filter((k) => /^group\d+$/.test(k) && Array.isArray(dataSet[k]));
        if (gKeys.length) {
          groups = {};
          gKeys.forEach((k) => { groups[k] = dataSet[k]; });
        }
      }

      // 'YYYY-MM-DD' → 로컬 자정 timestamp (시간대 off-by-one 방지)
      const parseYmd = (s) => {
        const m = String(s).match(/(\d{4})-(\d{1,2})-(\d{1,2})/);
        return m ? new Date(+m[1], +m[2] - 1, +m[3]).getTime() : NaN;
      };

      if (groups && !dataSet.series) {
        // 그룹별 점을 수집일자(full date) 기준으로 정렬 → [timestamp, value] 페어 시계열로 구성.
        // (연도 버킷팅·라벨 union·선형보간 없이 실제 수집일자 위치에 표시; 시간축에서 smooth 로 연결)
        // 점 1개 그룹도 포함 → symbol 로 단일 점 표시.
        const validGroups = [];
        Object.keys(groups).forEach((k) => {
          const pts = (groups[k] || [])
            .filter((p) => p && p.clctYmd && !Number.isNaN(parseYmd(p.clctYmd)))
            .slice()
            .sort((a, b) => parseYmd(a.clctYmd) - parseYmd(b.clctYmd));
          if (pts.length >= 1) validGroups.push({ key: k, pts });
        });

        validGroups.sort((a, b) => {
          const na = parseInt(a.key.replace(/\D/g, ''), 10) || 0;
          const nb = parseInt(b.key.replace(/\D/g, ''), 10) || 0;
          return na - nb;
        });

        const series = validGroups.map(({ key, pts }) => {
          const num = key.replace(/\D/g, '');
          const name = (dataSet.groupNames && dataSet.groupNames[key])
            || (num ? `그룹 ${num}` : key);
          return {
            name,
            data: pts.map((p) => [parseYmd(p.clctYmd), typeof p.mean === 'number' ? +p.mean.toFixed(2) : null]),
            upper: pts.map((p) => [parseYmd(p.clctYmd), typeof p.max === 'number' ? p.max : null]),
            lower: pts.map((p) => [parseYmd(p.clctYmd), typeof p.min === 'number' ? p.min : null]),
          };
        });

        dataSet = Object.assign({}, dataSet, { series });
      }

      if (!dataSet.series) dataSet.series = [];
      const hasData = dataSet.series.length > 0 && dataSet.series.some((s) => (s.data || []).length > 0);

      let myChart = echarts.getInstanceByDom(chartDom);
      if (myChart) myChart.dispose();
      myChart = echarts.init(chartDom);

      const chartColors = ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'];

      const hexToRgba = (hex, opacity) => {
        if (!hex || hex.indexOf('#') !== 0) return hex;
        let r = 0, g = 0, b = 0;
        if (hex.length === 4) {
          r = parseInt(hex[1] + hex[1], 16);
          g = parseInt(hex[2] + hex[2], 16);
          b = parseInt(hex[3] + hex[3], 16);
        } else if (hex.length === 7) {
          r = parseInt(hex.substring(1, 3), 16);
          g = parseInt(hex.substring(3, 5), 16);
          b = parseInt(hex.substring(5, 7), 16);
        }
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      };

      const legendData = [];
      const series = [];

      dataSet.series.forEach((item, idx) => {
        const hexColor = chartColors[idx % chartColors.length];
        legendData.push(item.name);
        const stackId = 'band-' + idx;

        // 하한 (투명 base)
        series.push({
          name: item.name + '_lower',
          type: 'line',
          stack: stackId,
          smooth: true,
          symbol: 'none',
          lineStyle: { opacity: 0 },
          areaStyle: { opacity: 0 },
          itemStyle: { opacity: 0 },
          data: item.lower,
          z: 1,
          tooltip: { show: false },
        });

        // 상한 - 하한 (밴드 영역)
        series.push({
          name: item.name + '_band',
          type: 'line',
          stack: stackId,
          smooth: true,
          symbol: 'none',
          lineStyle: { opacity: 0 },
          areaStyle: {
            color: hexToRgba(hexColor, 0.15),
          },
          itemStyle: { opacity: 0 },
          data: item.upper.map((pair, i) => {
            const lo = item.lower[i];
            const hiV = pair ? pair[1] : null;
            const loV = lo ? lo[1] : null;
            return [pair[0], (hiV == null || loV == null) ? null : hiV - loV];
          }),
          z: 1,
          tooltip: { show: false },
        });

        // 평균 라인
        // 점 2개 이상: 점 없는 라인(범례·hover 에도 dot 미표시) / 점 1개: 라인이 안 그려지므로 점으로 표시
        const meanPointCount = (item.data || []).filter((d) => d && d[1] != null).length;
        const isSinglePoint = meanPointCount <= 1;
        series.push({
          name: item.name,
          type: 'line',
          smooth: true,
          showSymbol: isSinglePoint,
          symbol: isSinglePoint ? 'circle' : 'none',
          symbolSize: 6,
          connectNulls: true,
          lineStyle: {
            color: hexColor,
            width: 2,
          },
          itemStyle: {
            color: hexColor,
            // 다중 포인트: 범례가 기본으로 그리는 동그라미 마커까지 투명 처리 → 라인만 남김
            // (단일 포인트는 점을 보여야 하므로 불투명 유지)
            opacity: isSinglePoint ? 1 : 0,
          },
          data: item.data,
          z: 10,
        });
      });

      // 전체 수집일자 범위 → 라벨 단위(연/월/일) 결정
      let minTs = Infinity; let maxTs = -Infinity;
      dataSet.series.forEach((s) => (s.data || []).forEach((pair) => {
        const t = pair && pair[0];
        if (typeof t === 'number' && !Number.isNaN(t)) {
          if (t < minTs) minTs = t;
          if (t > maxTs) maxTs = t;
        }
      }));
      const hasTime = minTs <= maxTs;
      const DAY_MS = 86400000;
      const spanDays = hasTime ? (maxTs - minTs) / DAY_MS : 0;

      // 라벨 단위 결정: '수집일자' 기본 → 라벨이 가용 너비에 겹치면 '월', 월도 겹치면 '연도'로 단계 상향.
      // (고정 span 임계 대신, 각 모드의 실제 눈금 개수 × 예상 라벨폭이 플롯 영역 너비에 들어오는지로 판단)
      let labelMode = 'day';
      if (hasTime) {
        // 모드별 눈금 개수
        const distinctDays = {};
        dataSet.series.forEach((s) => (s.data || []).forEach((pair) => {
          if (pair && typeof pair[0] === 'number') distinctDays[pair[0]] = true;
        }));
        const dayCount = Object.keys(distinctDays).length;
        const dMinAll = new Date(minTs); const dMaxAll = new Date(maxTs);
        const monthCount = (dMaxAll.getFullYear() - dMinAll.getFullYear()) * 12
          + (dMaxAll.getMonth() - dMinAll.getMonth()) + 1;

        // 플롯 영역 너비(px): 컨테이너 너비 − grid.left(80) − grid.right(30)
        const plotWidth = Math.max(0, (chartDom.clientWidth || 0) - 80 - 30);
        // 라벨 1개 예상 폭(px): 글자수 × 약 8px(fontSize 14 기준) + 좌우 여백
        const CHAR_PX = 8; const LABEL_GAP = 12;
        const dayLabelW = '2025-05-03'.length * CHAR_PX + LABEL_GAP; // 수집일자
        const monthLabelW = '2025-05'.length * CHAR_PX + LABEL_GAP; // 월
        const fits = (count, w) => count <= 1 || (count * w) <= plotWidth;

        if (plotWidth <= 0) {
          // 너비 측정 불가(미렌더/숨김) 시 span 기반 기본값으로 폴백
          labelMode = spanDays >= 730 ? 'year' : (spanDays > 31 ? 'month' : 'day');
        } else if (fits(dayCount, dayLabelW)) {
          labelMode = 'day';
        } else if (fits(monthCount, monthLabelW)) {
          labelMode = 'month';
        } else {
          labelMode = 'year';
        }
      }

      const pad2 = (n) => (n < 10 ? `0${n}` : `${n}`);
      const fmtYmd = (d) => `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`;
      const axisLabelFormatter = (value) => {
        const d = new Date(value);
        if (Number.isNaN(d.getTime())) return '';
        if (labelMode === 'year') return `${d.getFullYear()}`;
        if (labelMode === 'month') return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}`;
        return fmtYmd(d);
      };

      // 눈금을 연/월/일 경계(또는 실제 수집일자)에 고정 → 중복 라벨 방지
      let axisMin = hasTime ? minTs : null;
      let axisMax = hasTime ? maxTs : null;
      const tickValues = [];
      if (hasTime) {
        const dMin = new Date(minTs); const dMax = new Date(maxTs);
        if (labelMode === 'year') {
          const y0 = dMin.getFullYear(); const y1 = dMax.getFullYear();
          for (let y = y0; y <= y1; y += 1) tickValues.push(new Date(y, 0, 1).getTime());
          axisMin = new Date(y0, 0, 1).getTime();
          axisMax = new Date(y1 + 1, 0, 1).getTime();
        } else if (labelMode === 'month') {
          let y = dMin.getFullYear(); let m = dMin.getMonth();
          const endY = dMax.getFullYear(); const endM = dMax.getMonth();
          while (y < endY || (y === endY && m <= endM)) {
            tickValues.push(new Date(y, m, 1).getTime());
            m += 1; if (m > 11) { m = 0; y += 1; }
          }
          axisMin = new Date(dMin.getFullYear(), dMin.getMonth(), 1).getTime();
          axisMax = new Date(endY, endM + 1, 1).getTime();
        } else {
          const seen = {};
          dataSet.series.forEach((s) => (s.data || []).forEach((pair) => {
            if (pair && typeof pair[0] === 'number') seen[pair[0]] = true;
          }));
          Object.keys(seen).map((k) => +k).sort((a, b) => a - b).forEach((t) => tickValues.push(t));
          axisMin = minTs - DAY_MS / 2;
          axisMax = maxTs + DAY_MS / 2;
        }
      }

      const option = {
        color: ['#39b852', '#2863ff', '#22b5ff', '#f54a4a', '#ffa431', '#37cec6', '#342fe5', '#a307dd', '#7528f0', '#f0cb00', '#ff6ff9'],
        title: Utils.buildChartTitle(dataSet.title, chartDom.clientWidth - 32),
        tooltip: {
          trigger: 'axis',
          // hover 시 점 대신 세로 dashed 가이드 라인만 표시
          axisPointer: { type: 'line', lineStyle: { type: 'dashed', color: '#b0b6bd', width: 1 } },
          backgroundColor: '#fff',
          borderColor: '#e0e0e0',
          borderWidth: 1,
          textStyle: {
            color: '#1d1f20',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
          extraCssText: 'box-shadow: 0 2px 8px rgba(0,0,0,0.1); border-radius: 8px; padding: 8px 12px;',
          formatter(params) {
            if (!params || !params.length) return '';
            const meanParams = params.filter((p) => !p.seriesName.endsWith('_lower') && !p.seriesName.endsWith('_band'));
            if (!meanParams.length) return '';
            const headD = new Date(meanParams[0].axisValue);
            let result = Number.isNaN(headD.getTime()) ? `${meanParams[0].axisValueLabel || ''}` : fmtYmd(headD);
            meanParams.forEach((p) => {
              const marker = `<span style="display:inline-block;margin-right:6px;width:16px;height:2px;background:${p.color};vertical-align:middle;"></span>`;
              const raw = Array.isArray(p.value) ? p.value[1] : p.value;
              const val = (raw == null) ? '-' : raw;
              result += `<br/>${marker}${p.seriesName}: ${val}`;
            });
            return result;
          },
        },
        legend: {
          data: legendData,
          top: Utils.chartTitleTop(dataSet.title, 0),
          left: 'center',
          itemWidth: 25,
          itemHeight: 14,
          itemGap: 24,
          textStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 13,
            fontWeight: 500,
          },
        },
        grid: { left: 80, right: 30, top: Utils.chartTitleTop(dataSet.title, 50), bottom: 80 },
        xAxis: {
          type: 'time',
          min: axisMin,
          max: axisMax,
          name: dataSet.xLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: { show: false },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
            margin: 16,
            hideOverlap: true,
            customValues: tickValues,
            formatter: axisLabelFormatter,
          },
        },
        yAxis: {
          type: 'value',
          min: 0,
          max: hasData ? null : 100,
          name: dataSet.yLabel || '',
          nameLocation: 'center',
          nameGap: 56,
          nameTextStyle: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 17,
            fontWeight: 500,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            lineStyle: { color: '#f0f0f0' },
          },
          axisLabel: {
            color: '#79828d',
            fontFamily: 'Pretendard',
            fontSize: 14,
            fontWeight: 500,
          },
        },
        series: series,
      };

      myChart.setOption(option);
      Utils.attachChartTitleResize(myChart, chartDom, dataSet.title);
      Utils.attachValueAxisNameFit(myChart, chartDom);
      $(window).off(`resize.${id}`).on(`resize.${id}`, () => myChart.resize());
    },

    /**
     * QR 중앙 로고 기본 경로를 페이지 URL 이 아닌 custom.fed.js 스크립트 위치 기준으로 해석한다.
     * 배포 환경에서 컨트롤러 매핑 URL(/usr/dashboard 등) 로 페이지가 서빙되어도 동일 경로가 유지된다.
     */
    _getDefaultQrLogoSrc() {
      const scripts = document.getElementsByTagName('script');
      for (let i = scripts.length - 1; i >= 0; i--) {
        const src = scripts[i].src;
        if (src && /custom\.fed\.js/.test(src)) {
          try {
            return new URL('../images/favicon/favicon-512x512.png', src).href;
          } catch (e) {
            break;
          }
        }
      }
      const link = document.querySelector('link[rel*="icon"]');
      if (link && link.href) return link.href;
      return 'images/favicon/favicon-512x512.png';
    },

    /**
     * Render QR code with optional center logo on a canvas
     * @param {String} canvasId - target <canvas> element id
     * @param {Object} dataSet
     *   - text: {String} encoded value (required)
     *   - logoSrc: {String} center logo image src (default: custom.fed.js 기준 ../images/favicon/favicon-512x512.png, null 로 비활성)
     *   - logoPct: {Number} logo box size ratio (default 0.18, range 0.10~0.25)
     *   - minVersion: {Number} starting QR version (default 5)
     * @returns {Promise<HTMLCanvasElement|null>} resolves when render done (incl. logo load)
     *
     * 의존: qrcode-generator (https://cdn.jsdelivr.net/npm/qrcode-generator@1.4.4/qrcode.js)
     */
    setQrCode(canvasId, dataSet) {
      const canvas = document.getElementById(canvasId);
      if (!canvas) return Promise.resolve(null);
      const ctx = canvas.getContext('2d');
      const SIZE = canvas.width;
      const text = (dataSet && dataSet.text) || '';
      const logoSrc = dataSet && 'logoSrc' in dataSet ? dataSet.logoSrc : Utils._getDefaultQrLogoSrc();
      const logoPct = dataSet && typeof dataSet.logoPct === 'number' ? dataSet.logoPct : 0.18;
      const minVersion = dataSet && dataSet.minVersion ? dataSet.minVersion : 5;

      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, SIZE, SIZE);

      if (!text) return Promise.resolve(canvas);
      if (typeof qrcode === 'undefined') {
        console.warn('[setQrCode] qrcode-generator 라이브러리가 로드되지 않았습니다.');
        return Promise.resolve(canvas);
      }

      // UTF-8 byte encoding (한글/유니코드 지원)
      qrcode.stringToBytes = function (s) {
        return Array.from(new TextEncoder().encode(s));
      };

      let qr = null;
      let lastError = null;
      for (let v = minVersion; v <= 40; v++) {
        try {
          const inst = qrcode(v, 'H');
          inst.addData(text, 'Byte');
          inst.make();
          qr = inst;
          break;
        } catch (e) {
          lastError = e;
        }
      }
      if (!qr) {
        console.error('[setQrCode] QR 생성 실패:', lastError);
        return Promise.resolve(canvas);
      }

      const count = qr.getModuleCount();
      const margin = 4;
      const total = count + margin * 2;
      const tile = SIZE / total;
      ctx.fillStyle = '#000000';
      for (let r = 0; r < count; r++) {
        for (let c = 0; c < count; c++) {
          if (qr.isDark(r, c)) {
            ctx.fillRect(
              Math.floor((c + margin) * tile),
              Math.floor((r + margin) * tile),
              Math.ceil(tile) + 0.5,
              Math.ceil(tile) + 0.5
            );
          }
        }
      }

      if (!logoSrc) return Promise.resolve(canvas);

      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => {
          const logoBox = Math.round(SIZE * logoPct);
          const pad = Math.round(logoBox * 0.08);
          const totalBox = logoBox + pad * 2;
          const x = Math.round((SIZE - totalBox) / 2);
          const y = Math.round((SIZE - totalBox) / 2);
          ctx.fillStyle = '#ffffff';
          ctx.fillRect(x, y, totalBox, totalBox);
          const iw = img.naturalWidth;
          const ih = img.naturalHeight;
          const sourceSize = Math.min(iw, ih);
          const sx = (iw - sourceSize) / 2;
          const sy = (ih - sourceSize) / 2;
          ctx.drawImage(img, sx, sy, sourceSize, sourceSize, x + pad, y + pad, logoBox, logoBox);
          resolve(canvas);
        };
        img.onerror = () => resolve(canvas);
        img.src = logoSrc;
      });
    },

    /**
     * Render multiple QR codes off-screen and download as a ZIP archive
     * @param {Array} items - [{ text, fileName }] — text 는 인코딩값, fileName 은 zip 내 파일명(확장자 제외)
     * @param {String} zipName - ZIP 파일명 (확장자 제외, 기본 'QR코드')
     * @param {Object} options
     *   - logoSrc: {String} 중앙 로고 이미지 경로
     *   - logoPct: {Number} 로고 크기 비율 (default 0.18)
     *   - canvasSize: {Number} 각 QR 캔버스 픽셀 크기 (default 640)
     *   - minVersion: {Number} QR 시작 버전 (default 5)
     */
    async downloadQrCodesAsZip(items, zipName, options) {
      if (!items || !items.length) return;
      Utils.startLoading();

      const opts = options || {};
      const canvasSize = opts.canvasSize || 640;
      const container = document.createElement('div');
      container.style.cssText = 'position:absolute;left:-9999px;top:-9999px;';
      document.body.appendChild(container);

      try {
        const zip = new JSZip();
        const usedNames = new Set();
        for (let i = 0; i < items.length; i++) {
          const item = items[i] || {};
          const tempId = '__qr_export_' + i + '__';
          const canvas = document.createElement('canvas');
          canvas.id = tempId;
          canvas.width = canvasSize;
          canvas.height = canvasSize;
          container.appendChild(canvas);

          const qrOpts = { text: item.text };
          if ('logoSrc' in opts) qrOpts.logoSrc = opts.logoSrc;
          if (opts.logoPct != null) qrOpts.logoPct = opts.logoPct;
          if (opts.minVersion != null) qrOpts.minVersion = opts.minVersion;
          await Utils.setQrCode(tempId, qrOpts);

          const blob = await new Promise((resolve) => canvas.toBlob(resolve, 'image/png'));
          if (blob) {
            let base = (item.fileName || item.text || 'qrcode').replace(/[^a-zA-Z0-9_\-가-힣]/g, '_');
            let name = base + '.png';
            let dup = 1;
            while (usedNames.has(name)) {
              name = base + '_' + (++dup) + '.png';
            }
            usedNames.add(name);
            zip.file(name, blob);
          }
        }

        const zipBlob = await zip.generateAsync({ type: 'blob' });
        const url = URL.createObjectURL(zipBlob);
        const link = document.createElement('a');
        link.download = (zipName || 'QR코드') + '.zip';
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      } catch (e) {
        console.error('[downloadQrCodesAsZip] Error:', e);
      } finally {
        document.body.removeChild(container);
        Utils.endLoading();
      }
    },

    /**
     * Download a canvas as PNG file
     * @param {String} canvasId - target <canvas> element id
     * @param {String} fileName - download file name (extension auto-appended if omitted)
     */
    downloadCanvas(canvasId, fileName) {
      const canvas = document.getElementById(canvasId);
      if (!canvas) return;
      const safe = (fileName || 'image').replace(/[^a-zA-Z0-9_\-가-힣]/g, '_');
      const name = /\.png$/i.test(safe) ? safe : safe + '.png';
      canvas.toBlob((blob) => {
        if (!blob) return;
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.download = name;
        link.href = url;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      }, 'image/png');
    },

    /**
     * 차트를 이미지로 변환 후 ZIP 다운로드
     * @param {Array} charts - [{ fn: '차트함수명', data: {차트데이터}, fileName: '파일명', folder: '폴더경로' }, ...]
     *   folder 는 선택값이며, '통계/상관분석' 처럼 '/' 로 임의 깊이의 하위 폴더를 지정할 수 있다. (없으면 ZIP 루트에 저장)
     * @param {String} zipName - ZIP 파일명
     */
    async downloadChartsAsZip(charts, zipName) {
      Utils.startLoading();

      const zip = new JSZip();
      const container = document.createElement('div');
      container.style.cssText = 'position:absolute;left:-9999px;top:-9999px;';
      document.body.appendChild(container);

      const isGridChart = (fn) => fn === 'setPairPlotChart' || fn === 'setCrossPairPlotChart';
      const isCategoryBubbleChart = (fn) => fn === 'setCategoryBubbleChart';
      const observerKeys = [
        '__titleResizeObserver',
        '__categoryAxisFitObserver',
        '__valueAxisNameFitObserver',
        '__valueAxisXFitObserver',
      ];

      // 최초 setOption부터 animation을 끈다. 생성 후 덮어쓰면 symbol/graphic이
      // 애니메이션 중간 상태로 캡처될 수 있으므로 init 시점에 export 모드를 주입한다.
      const renderChartForExport = (fn, id, data, afterRender) => {
        if (typeof this[fn] !== 'function') {
          throw new Error(`[downloadChartsAsZip] Unknown chart function: ${fn}`);
        }
        const originalInit = echarts.init;
        echarts.init = function () {
          const instance = originalInit.apply(echarts, arguments);
          const originalSetOption = instance.setOption.bind(instance);
          instance.setOption = function (option) {
            const args = Array.prototype.slice.call(arguments, 1);
            const exportOption = option && typeof option === 'object' && !Array.isArray(option)
              ? Object.assign({}, option, {
                animation: false,
                animationDuration: 0,
                animationDurationUpdate: 0,
              })
              : option;
            return originalSetOption.apply(instance, [exportOption].concat(args));
          };
          return instance;
        };
        try {
          this[fn](id, data, { animation: false, export: true });
          if (typeof afterRender === 'function') afterRender();
        } finally {
          echarts.init = originalInit;
        }
      };

      const cleanupChartDom = (chartDom, id) => {
        if (!chartDom) return;
        const elements = [chartDom].concat(Array.from(chartDom.querySelectorAll('div')));
        elements.forEach((el) => {
          observerKeys.forEach((key) => {
            if (el[key] && typeof el[key].disconnect === 'function') el[key].disconnect();
            delete el[key];
          });
          const instance = echarts.getInstanceByDom(el);
          if (instance && !(typeof instance.isDisposed === 'function' && instance.isDisposed())) {
            instance.dispose();
          }
        });
        $(window).off('.' + id).off('.legend_' + id);
      };

      // 브라우저 canvas 한도를 넘지 않도록 대형 grid 차트의 배율을 자동 축소한다.
      const getExportPixelRatio = (width, height, preferred) => {
        const maxDimension = 16000;
        const maxArea = 64 * 1024 * 1024;
        const safeWidth = Math.max(1, width);
        const safeHeight = Math.max(1, height);
        return Math.max(0.01, Math.min(
          preferred || 2,
          maxDimension / safeWidth,
          maxDimension / safeHeight,
          Math.sqrt(maxArea / (safeWidth * safeHeight))
        ));
      };

      const loadImage = (src) => new Promise((resolve, reject) => {
        const image = new Image();
        image.onload = () => resolve(image);
        image.onerror = () => reject(new Error('[downloadChartsAsZip] Failed to decode chart image'));
        image.src = src;
      });

      // folder(임의 깊이 가능) + fileName 을 ZIP 내부 경로로 조합. JSZip 이 중간 폴더를 자동 생성한다.
      const buildPath = (folder, fileName) => {
        const dir = (folder || '')
          .replace(/\\/g, '/') // 윈도우 구분자 → /
          .replace(/^\/+|\/+$/g, '') // 앞뒤 슬래시 제거
          .replace(/\/{2,}/g, '/'); // 중복 슬래시 정리
        return dir ? `${dir}/${fileName}.png` : `${fileName}.png`;
      };

      try {
        for (let idx = 0; idx < charts.length; idx++) {
        const chart = charts[idx];
        const tempId = '__chart_export_' + idx + '__';
        const chartDom = document.createElement('div');
        chartDom.id = tempId;
        container.appendChild(chartDom);

        if (isGridChart(chart.fn)) {
          // grid 기반 다중 차트: 스크롤 없이 전체 펼침
          // setCrossPairPlotChart 는 xTraits=comparative2 (env), setPairPlotChart 는 traits=comparative1∪2
          const pearsonList = chart.data.correlation && Array.isArray(chart.data.correlation.pearson)
            ? chart.data.correlation.pearson : null;
          let cols = (chart.data.traits || chart.data.xTraits || []).length;
          if (cols === 0 && pearsonList) {
            const seen = new Set();
            if (chart.fn === 'setCrossPairPlotChart') {
              pearsonList.forEach((p) => { if (p.comparative2) seen.add(p.comparative2); });
            } else {
              pearsonList.forEach((p) => { if (p.comparative1) seen.add(p.comparative1); if (p.comparative2) seen.add(p.comparative2); });
            }
            cols = seen.size;
          }
          const cellSize = 300;
          const gap = 8;
          const labelW = 56;
          const totalW = labelW + cols * cellSize + (cols - 1) * gap;
          chartDom.style.cssText = `width:${totalW}px;`;

          // 내부 wrapper의 overflow를 풀어서 스크롤 없이 전체 렌더링

          renderChartForExport(chart.fn, tempId, chart.data, () => {
            // 지연 init 으로 보류된 셀도 export 모드가 적용된 상태에서 강제 init
            if (typeof chartDom.__pairPlotInitAll === 'function') {
              chartDom.__pairPlotInitAll();
            }
          });

          // 내부 스크롤 wrapper의 overflow를 풀어서 전체 펼침
          chartDom.querySelectorAll('.echarts-pairplot-wrapper, .scroll-wrap').forEach((el) => {
            el.style.overflow = 'visible';
          });

          // echarts 인스턴스 리사이즈
          chartDom.querySelectorAll('div').forEach((el) => {
            const inst = echarts.getInstanceByDom(el);
            if (inst) inst.resize();
          });

          await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

          const instances = [];
          chartDom.querySelectorAll('div').forEach((el) => {
            const inst = echarts.getInstanceByDom(el);
            if (inst) {
              inst.setOption({ animation: false });
              if (inst._zr) inst._zr.refreshImmediately();
              instances.push({ el, inst });
            }
          });

          if (instances.length > 0) {
            await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
            const parentRect = chartDom.getBoundingClientRect();
            const actualW = parentRect.width;
            const actualH = parentRect.height;
            const canvas = document.createElement('canvas');
            const pixelRatio = getExportPixelRatio(actualW, actualH, 2);
            canvas.width = actualW * pixelRatio;
            canvas.height = actualH * pixelRatio;
            const ctx = canvas.getContext('2d');
            ctx.scale(pixelRatio, pixelRatio);
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, actualW, actualH);

            // Y축/X축 라벨을 DOM 위치 기반으로 그리기
            ctx.fillStyle = '#79828d';
            ctx.font = '500 14px Pretendard';
            ctx.textAlign = 'center';
            ctx.textBaseline = 'middle';
            chartDom.querySelectorAll('.echarts-pairplot-ylabel').forEach((el) => {
              const r = el.getBoundingClientRect();
              ctx.save();
              ctx.translate(r.left - parentRect.left + r.width / 2, r.top - parentRect.top + r.height / 2);
              ctx.rotate(-Math.PI / 2);
              ctx.fillText(el.textContent, 0, 0);
              ctx.restore();
            });
            chartDom.querySelectorAll('.echarts-pairplot-xlabel').forEach((el) => {
              const r = el.getBoundingClientRect();
              ctx.fillText(el.textContent, r.left - parentRect.left + r.width / 2, r.top - parentRect.top + r.height / 2);
            });

            // 상삼각 plain HTML 셀(echarts 인스턴스 없음)의 border + Corr 텍스트 그리기
            chartDom.querySelectorAll('.echarts-pairplot-corr').forEach((el) => {
              const cellEl = el.closest('.echarts-pairplot-cell') || el;
              const cellRect = cellEl.getBoundingClientRect();
              ctx.strokeStyle = '#dcdedf';
              ctx.lineWidth = 1;
              ctx.strokeRect(cellRect.left - parentRect.left, cellRect.top - parentRect.top, cellRect.width, cellRect.height);

              const labelEl = el.querySelector('.echarts-pairplot-corr-label');
              if (labelEl) {
                const r = labelEl.getBoundingClientRect();
                ctx.fillStyle = '#555';
                ctx.font = '400 14px Pretendard';
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(labelEl.textContent, r.left - parentRect.left + r.width / 2, r.top - parentRect.top + r.height / 2);
              }
              const valueEl = el.querySelector('.echarts-pairplot-corr-value');
              if (valueEl) {
                const r = valueEl.getBoundingClientRect();
                const fontSize = parseInt(valueEl.style.fontSize, 10) || 18;
                ctx.fillStyle = '#1d1f20';
                ctx.font = `700 ${fontSize}px Pretendard`;
                ctx.textAlign = 'center';
                ctx.textBaseline = 'middle';
                ctx.fillText(valueEl.textContent, r.left - parentRect.left + r.width / 2, r.top - parentRect.top + r.height / 2);
              }
            });

            for (const { el, inst } of instances) {
              const dataURL = inst.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' });
              const img = await loadImage(dataURL);

              // cell(padding 포함) 기준 border
              const cellEl = el.closest('.echarts-pairplot-cell') || el;
              const cellRect = cellEl.getBoundingClientRect();
              const cx = cellRect.left - parentRect.left;
              const cy = cellRect.top - parentRect.top;
              ctx.strokeStyle = '#dcdedf';
              ctx.lineWidth = 1;
              ctx.strokeRect(cx, cy, cellRect.width, cellRect.height);

              // echarts 실제 캔버스 위치 (padding 안쪽)
              const echartsCanvas = el.querySelector('canvas');
              if (echartsCanvas) {
                const canvasRect = echartsCanvas.getBoundingClientRect();
                ctx.drawImage(img, canvasRect.left - parentRect.left, canvasRect.top - parentRect.top, canvasRect.width, canvasRect.height);
              } else {
                ctx.drawImage(img, cx, cy, cellRect.width, cellRect.height);
              }
              inst.dispose();
            }

            const base64 = canvas.toDataURL('image/png').split(',')[1];
            zip.file(buildPath(chart.folder, chart.fileName), base64, { base64: true });
          }
        } else if (isCategoryBubbleChart(chart.fn)) {
          // echarts 캔버스 + 우측 HTML 범례를 함께 합성
          chartDom.style.cssText = 'width:1000px;height:500px;';

          renderChartForExport(chart.fn, tempId, chart.data);
          if (chartDom.__chartExportReady) await chartDom.__chartExportReady;

          // 스크롤 제거 후 자연 폭으로 펼치기
          chartDom.querySelectorAll('.scroll-wrap').forEach((el) => {
            el.style.overflow = 'visible';
          });

          const scrollWrap = chartDom.querySelector('.scroll-wrap');
          const chartArea = scrollWrap && scrollWrap.firstElementChild;
          const legendArea = chartDom.lastElementChild;
          const inst = chartArea ? echarts.getInstanceByDom(chartArea) : null;

          if (inst) {
            // chartArea 가 가진 min-width 만큼 chartDom 폭 확장 (범례 폭 + 여백 포함)
            const minW = parseInt(chartArea.style.minWidth, 10) || chartArea.offsetWidth;
            const legendW = legendArea && legendArea !== scrollWrap ? legendArea.offsetWidth : 0;
            chartDom.style.width = (minW + legendW + 8) + 'px';

            inst.resize();
            inst.setOption({ animation: false });
            if (inst._zr) inst._zr.refreshImmediately();
            await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));

            const parentRect = chartDom.getBoundingClientRect();
            const actualW = parentRect.width;
            const actualH = parentRect.height;
            const canvas = document.createElement('canvas');
            const pixelRatio = getExportPixelRatio(actualW, actualH, 2);
            canvas.width = actualW * pixelRatio;
            canvas.height = actualH * pixelRatio;
            const ctx = canvas.getContext('2d');
            ctx.scale(pixelRatio, pixelRatio);
            ctx.fillStyle = '#fff';
            ctx.fillRect(0, 0, actualW, actualH);

            // 1) echarts 차트 이미지
            const dataURL = inst.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' });
            const chartImg = await loadImage(dataURL);
            const chartRect = chartArea.getBoundingClientRect();
            ctx.drawImage(
              chartImg,
              chartRect.left - parentRect.left,
              chartRect.top - parentRect.top,
              chartRect.width,
              chartRect.height
            );

            // 2) 우측 legendArea: 인라인 스타일 기반 DOM 워크로 직접 그리기
            if (legendArea && legendArea !== scrollWrap) {
              const drawLegendNode = (el) => {
                const cs = getComputedStyle(el);
                if (cs.display === 'none' || cs.visibility === 'hidden') return;
                const r = el.getBoundingClientRect();
                const x = r.left - parentRect.left;
                const y = r.top - parentRect.top;
                const w = r.width;
                const h = r.height;

                // 배경 (그라데이션 vs 단색)
                const bgImage = cs.backgroundImage;
                const bgColor = cs.backgroundColor;
                const borderRadius = parseFloat(cs.borderTopLeftRadius) || 0;

                if (bgImage && bgImage.indexOf('linear-gradient') !== -1) {
                  const grad = ctx.createLinearGradient(x, y, x, y + h);
                  grad.addColorStop(0, '#2863ff');
                  grad.addColorStop(0.5, '#ffffff');
                  grad.addColorStop(1, '#f54a4a');
                  ctx.fillStyle = grad;
                  if (borderRadius > 0) {
                    const rr = Math.min(borderRadius, w / 2, h / 2);
                    ctx.beginPath();
                    ctx.moveTo(x + rr, y);
                    ctx.arcTo(x + w, y, x + w, y + h, rr);
                    ctx.arcTo(x + w, y + h, x, y + h, rr);
                    ctx.arcTo(x, y + h, x, y, rr);
                    ctx.arcTo(x, y, x + w, y, rr);
                    ctx.closePath();
                    ctx.fill();
                  } else {
                    ctx.fillRect(x, y, w, h);
                  }
                  if (cs.borderTopWidth && parseFloat(cs.borderTopWidth) > 0) {
                    ctx.strokeStyle = cs.borderTopColor;
                    ctx.lineWidth = parseFloat(cs.borderTopWidth);
                    ctx.strokeRect(x, y, w, h);
                  }
                } else if (bgColor && bgColor !== 'rgba(0, 0, 0, 0)' && bgColor !== 'transparent') {
                  ctx.fillStyle = bgColor;
                  // border-radius 가 short side의 절반 이상이면 원으로 그리기
                  const isCircle = w > 0 && h > 0 && borderRadius >= Math.min(w, h) / 2 - 0.5;
                  if (isCircle) {
                    ctx.beginPath();
                    ctx.arc(x + w / 2, y + h / 2, Math.min(w, h) / 2, 0, Math.PI * 2);
                    ctx.fill();
                  } else {
                    ctx.fillRect(x, y, w, h);
                  }
                }

                // 직속 텍스트 노드만 그리기 (자식 element 의 텍스트는 자식 순회 시 그려짐)
                const directText = Array.from(el.childNodes)
                  .filter((n) => n.nodeType === Node.TEXT_NODE)
                  .map((n) => n.textContent)
                  .join('')
                  .trim();
                if (directText) {
                  const fontSize = parseFloat(cs.fontSize) || 11;
                  const fontWeight = cs.fontWeight || '400';
                  ctx.fillStyle = cs.color;
                  ctx.font = `${fontWeight} ${fontSize}px Pretendard, sans-serif`;
                  ctx.textAlign = 'left';
                  ctx.textBaseline = 'top';
                  // line-height 보정: 텍스트를 중앙에 가깝게 배치
                  const lineHeight = parseFloat(cs.lineHeight) || fontSize * 1.2;
                  const textY = y + Math.max(0, (h - lineHeight) / 2) + (lineHeight - fontSize) * 0.5;
                  ctx.fillText(directText, x, textY);
                }
              };

              const walk = (node) => {
                if (node.nodeType !== Node.ELEMENT_NODE) return;
                drawLegendNode(node);
                Array.from(node.children).forEach(walk);
              };
              walk(legendArea);
            }

            const base64 = canvas.toDataURL('image/png').split(',')[1];
            zip.file(buildPath(chart.folder, chart.fileName), base64, { base64: true });
            inst.dispose();
          }
        } else {
          // 단일 echarts 인스턴스
          chartDom.style.cssText = 'width:800px;height:400px;';

          renderChartForExport(chart.fn, tempId, chart.data);

          let instance = echarts.getInstanceByDom(chartDom);
          if (!instance) {
            const children = chartDom.querySelectorAll('div');
            for (const child of children) {
              instance = echarts.getInstanceByDom(child);
              if (instance) break;
            }
          }

          if (instance) {
            instance.setOption({ animation: false });
            await new Promise((resolve) => {
              if (instance._zr) instance._zr.refreshImmediately();
              requestAnimationFrame(() => requestAnimationFrame(resolve));
            });

            const pixelRatio = getExportPixelRatio(instance.getWidth(), instance.getHeight(), 2);
            const dataURL = instance.getDataURL({ type: 'png', pixelRatio, backgroundColor: '#fff' });
            const base64 = dataURL.split(',')[1];
            zip.file(buildPath(chart.folder, chart.fileName), base64, { base64: true });
            instance.dispose();
          }
        }

        cleanupChartDom(chartDom, tempId);
        if (chartDom.parentNode === container) container.removeChild(chartDom);
      }

        const blob = await zip.generateAsync({ type: 'blob' });
        const a = document.createElement('a');
        a.classList.add('sr-only');
        const downloadUrl = URL.createObjectURL(blob);
        a.href = downloadUrl;
        a.download = `${zipName}.zip`;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        setTimeout(() => URL.revokeObjectURL(downloadUrl), 1000);
      } finally {
        Array.from(container.children).forEach((chartDom) => {
          cleanupChartDom(chartDom, chartDom.id);
        });
        if (container.parentNode) container.parentNode.removeChild(container);
        Utils.endLoading();
      }
    },

    /**
     * Get date with range
     * @param {Date} date
     * @param {String} range
     * @param {Boolean} isAdd
     * @returns {Date}
     */
    getDateWithRange(date, range, isAdd) {
      if (!date || !range) return null;
      const value = parseInt(range);
      const unit = range.slice(-1).toUpperCase();
      const newDate = new Date(date);
      const sign = isAdd ? 1 : -1;

      if (unit === 'Y') {
        newDate.setFullYear(newDate.getFullYear() + sign * value);
      } else if (unit === 'M') {
        newDate.setMonth(newDate.getMonth() + sign * value);
      } else if (unit === 'D') {
        newDate.setDate(newDate.getDate() + sign * value);
      }
      return newDate;
    },

    /**
     * Download target element as a self-contained standalone HTML file.
     * All CSS (with base64 fonts), JS, and echarts instances are inlined.
     * @param {String} targetSelector - CSS selector for the element to capture
     * @param {String} filename - Download filename (without .html extension)
     */
    async downloadAsStandaloneHtml(targetSelector, filename) {
      Utils.startLoading();

      const targetEl = document.querySelector(targetSelector);
      if (!targetEl) {
        console.error('[downloadAsStandaloneHtml] Target element not found:', targetSelector);
        return;
      }

      try {
        // 1. Fetch all CSS stylesheets and inline fonts as base64
        const cssLinks = document.querySelectorAll('link[rel="stylesheet"]');
        let inlinedCss = '';

        for (const link of cssLinks) {
          try {
            const href = link.href;
            if (!href) continue;
            const cssText = await fetch(href, { credentials: 'same-origin' }).then((r) => {
              if (!r.ok) throw new Error(r.status);
              return r.text();
            });
            const baseUrl = href.substring(0, href.lastIndexOf('/') + 1);
            const resolved = await this._resolveCssUrls(cssText, baseUrl);
            inlinedCss += '/* source: ' + href.split('/').pop() + ' */\n' + resolved + '\n\n';
          } catch (e) {
            console.warn('[downloadAsStandaloneHtml] Failed to fetch CSS:', link.href, e);
          }
        }

        // 2. Fetch all external JS files
        // Skip: data-report-exclude (외부 위젯/크로스도메인 스크립트는 CORS 로 fetch 불가)
        // 각 파일은 개별 <script> 로 내보낸다(아래 6번). 하나의 블록으로 합치면 top-level 스코프가
        // 공유되어, 앞선 번들이 남긴 module/exports 바인딩을 jQuery 등의 UMD 가 감지 →
        // window.jQuery 전역 노출을 건너뛰면서 jQuery 의존 코드(Bootstrap 탭 등)가 전부 죽는다.
        const scriptTags = document.querySelectorAll('script[src]:not([data-report-exclude])');
        const externalScripts = [];

        for (const script of scriptTags) {
          try {
            const src = script.src;
            if (!src) continue;
            const jsText = await fetch(src, { credentials: 'same-origin' }).then((r) => {
              if (!r.ok) throw new Error(r.status);
              return r.text();
            });
            externalScripts.push({ name: src.split('/').pop(), text: jsText });
          } catch (e) {
            console.warn('[downloadAsStandaloneHtml] Failed to fetch JS:', script.src, e);
          }
        }

        // 3. Collect inline scripts (CHART_DATA, init functions, tab handlers, etc.)
        // Skip: data-report-exclude, document.write, browserSync
        // 인라인 스크립트도 원본처럼 각각 별도 <script> 로 내보낸다(스코프 누수/중단 격리).
        const inlineScripts = document.querySelectorAll('script:not([src]):not([data-report-exclude])');
        const inlineScriptTexts = [];

        inlineScripts.forEach((script) => {
          const text = script.textContent.trim();
          if (text && !text.includes('document.write') && !text.includes('browserSync') && !text.includes('browser-sync')) {
            inlineScriptTexts.push(text);
          }
        });

        // 4. Clone target content and build report layout
        const contentClone = targetEl.cloneNode(true);

        // Extract dynamic info for report header
        const titleEl = targetEl.querySelector('.title-wrap h3');
        const badgesEl = targetEl.querySelector('.title-wrap .d-flex.align-items-center');
        const reportTitle = titleEl ? titleEl.textContent.trim() : '';
        const reportBadges = badgesEl ? badgesEl.innerHTML : '';

        // Clean echarts rendered DOM (will be re-rendered from CHART_DATA)
        contentClone.querySelectorAll('canvas').forEach((c) => c.remove());
        contentClone.querySelectorAll('[_echarts_instance_]').forEach((el) => {
          el.removeAttribute('_echarts_instance_');
          el.innerHTML = '';
        });

        // Remove elements marked with data-report-exclude
        contentClone.querySelectorAll('[data-report-exclude]').forEach((el) => el.remove());

        // Remove the dynamically injected ibreeder chat widget iframe
        // (embed.js injects a fixed-position iframe that should not be in the report)
        contentClone.querySelectorAll('iframe[src*="ibreeder.kr/embed"], iframe[src*="/embed?host"]').forEach((el) => el.remove());

        // Reset to first tab active state for each tab group
        contentClone.querySelectorAll('.nav-link').forEach((el) => el.classList.remove('active'));
        contentClone.querySelectorAll('.tab-pane').forEach((el) => {
          el.classList.remove('active', 'show');
        });
        contentClone.querySelectorAll('.nav-tabs, [role="tablist"]').forEach((tabList) => {
          const firstLink = tabList.querySelector('.nav-link');
          if (firstLink) {
            firstLink.classList.add('active');
            const target = firstLink.getAttribute('data-target');
            if (target) {
              const pane = contentClone.querySelector(target);
              if (pane) pane.classList.add('active', 'show');
            }
          }
        });

        // 5. Convert all images to base64 data URIs
        const images = contentClone.querySelectorAll('img[src]');
        for (const img of images) {
          try {
            const src = img.getAttribute('src');
            if (!src || src.startsWith('data:')) continue;
            const resolvedUrl = new URL(src, window.location.href).href;
            const response = await fetch(resolvedUrl);
            const arrayBuffer = await response.arrayBuffer();
            const bytes = new Uint8Array(arrayBuffer);
            let binary = '';
            for (let i = 0; i < bytes.length; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            const base64 = btoa(binary);
            const contentType = response.headers.get('content-type') || 'image/png';
            img.setAttribute('src', 'data:' + contentType + ';base64,' + base64);
          } catch (e) {
            console.warn('[downloadAsStandaloneHtml] Failed to convert image:', img.getAttribute('src'), e);
          }
        }

        // Convert favicon for report header logo
        // 현재 페이지 head에 이미 떠있는 favicon <link>를 우선 사용한다.
        // (하드코딩된 상대 경로 'images/favicon/favicon-180x180.png'를
        // window.location.href 기준으로 풀면 운영 환경에서 404가 떨어지고
        // 그 응답이 그대로 base64로 박혀 로고가 깨지는 문제 방지)
        let logoBase64 = '';
        try {
          const faviconLink = document.querySelector('link[rel="icon"][sizes="32x32"]')
            || document.querySelector('link[rel="icon"]')
            || document.querySelector('link[rel="shortcut icon"]');
          const logoUrl = faviconLink && faviconLink.href
            ? faviconLink.href
            : new URL('images/favicon/favicon-180x180.png', window.location.href).href;
          const logoResp = await fetch(logoUrl, { credentials: 'same-origin' });
          if (!logoResp.ok) throw new Error('HTTP ' + logoResp.status);
          const ct = logoResp.headers.get('content-type') || 'image/png';
          if (ct.indexOf('image/') !== 0) throw new Error('Not an image: ' + ct);
          const logoBuf = await logoResp.arrayBuffer();
          const logoBytes = new Uint8Array(logoBuf);
          let logoBinary = '';
          for (let i = 0; i < logoBytes.length; i++) {
            logoBinary += String.fromCharCode(logoBytes[i]);
          }
          logoBase64 = 'data:' + ct + ';base64,' + btoa(logoBinary);
        } catch (e) {
          console.warn('[downloadAsStandaloneHtml] Failed to convert logo:', e);
        }

        // 6. Build report layout HTML (matching analysis_report.html structure)
        const escapeScript = (str) => str.replace(/<\/script>/gi, '<\\/script>');

        // 외부/인라인 스크립트를 각각 독립된 <script> 태그로 (라이브 페이지와 동일한 로딩 순서·스코프)
        const externalScriptTags = externalScripts.map(
          (s) => '<script>\n/* source: ' + s.name + ' */\n' + escapeScript(s.text) + '\n<\/script>',
        );
        const inlineScriptTags = inlineScriptTexts.map(
          (t) => '<script>\n' + escapeScript(t) + '\n<\/script>',
        );

        const html = [
          '<!DOCTYPE html>',
          '<html lang="ko">',
          '<head>',
          '<meta charset="utf-8" />',
          '<meta name="viewport" content="width=device-width, initial-scale=1.0" />',
          '<title>' + (filename || 'Analysis Result') + '</title>',
          '<style>', inlinedCss, '</style>',
          '</head>',
          '<body>',
          '<div class="layout-report">',
          '  <!-- header -->',
          '  <header class="layout-header">',
          '    <div class="container h-100">',
          '      <div class="d-flex align-items-center h-100">',
          '        <div class="img-wrap">',
          '          <img src="' + logoBase64 + '" alt="로고"/>',
          '        </div>',
          '        <div class="d-flex flex-column gap-6">',
          '          <h2 class="fs-15">데이터 육종 플랫폼, ibreeder</h2>',
          '          <div class="title-wrap">',
          '            <h3>' + reportTitle + '</h3>',
          '            <div class="d-flex align-items-center flex-wrap gap-6 ml-16">',
          '              ' + reportBadges,
          '            </div>',
          '          </div>',
          '        </div>',
          '      </div>',
          '    </div>',
          '  </header>',
          '  <!-- main -->',
          '  <main class="layout-main" id="content">',
          contentClone.outerHTML,
          '  </main>',
          '  <!-- footer -->',
          '  <footer class="layout-footer">',
          '    <div class="container">',
          '      <p class="copyright text-center">&copy; 2022 - ' + new Date().getFullYear() + ' Insilicogen, Inc. All rights reserved</p>',
          '    </div>',
          '  </footer>',
          '</div>',
          ...externalScriptTags,
          ...inlineScriptTags,
          '</body>',
          '</html>',
        ].join('\n');

        // 7. Trigger download
        const blob = new Blob([html], { type: 'text/html;charset=utf-8' });
        const a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = (filename || 'analysis_result') + '.html';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(a.href);

      } catch (e) {
        console.error('[downloadAsStandaloneHtml] Error:', e);
      } finally {
        Utils.endLoading();
      }
    },

    /**
     * Resolve CSS url() references to base64 data URIs.
     * @param {String} cssText - Raw CSS text
     * @param {String} baseUrl - Base URL for resolving relative paths
     * @returns {String} CSS with url() replaced by base64 data URIs
     */
    async _resolveCssUrls(cssText, baseUrl) {
      const urlRegex = /url\(\s*['"]?(?!data:)([^'")]+)['"]?\s*\)/g;
      const matches = [];
      let match;

      while ((match = urlRegex.exec(cssText)) !== null) {
        matches.push({ full: match[0], path: match[1] });
      }

      for (const m of matches) {
        try {
          const resolvedUrl = new URL(m.path, baseUrl).href;
          const response = await fetch(resolvedUrl);
          const arrayBuffer = await response.arrayBuffer();
          const bytes = new Uint8Array(arrayBuffer);
          let binary = '';
          for (let i = 0; i < bytes.length; i++) {
            binary += String.fromCharCode(bytes[i]);
          }
          const base64 = btoa(binary);

          const contentType = response.headers.get('content-type') || 'application/octet-stream';
          const dataUri = 'data:' + contentType + ';base64,' + base64;
          cssText = cssText.split(m.full).join('url("' + dataUri + '")');
        } catch (e) {
          console.warn('[_resolveCssUrls] Failed to resolve:', m.path, e);
        }
      }

      return cssText;
    },
  };
})();
